'use strict';

function apply_pollyfills() {
	// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Object/entries
	if (!Object.entries) {
		Object.entries = function(obj) {
			var ownProps = Object.keys(obj),
				i = ownProps.length,
				resArray = new Array(i); // preallocate the Array
			while (i--) {
				resArray[i] = [ownProps[i], obj[ownProps[i]]];
			}
			
			return resArray;
		};
	}
	// https://sentry.io/organizations/yalwa/issues/2563605516
	// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
	if (!String.prototype.repeat) {
		String.prototype.repeat = function(count) {
			'use strict';
			if (this == null) {
				throw new TypeError('can\'t convert ' + this + ' to object');
			}
			var str = '' + this;
			count = +count;
			if (count != count) {
				count = 0;
			}
			if (count < 0) {
				throw new RangeError('repeat count must be non-negative');
			}
			if (count == Infinity) {
				throw new RangeError('repeat count must be less than infinity');
			}
			count = Math.floor(count);
			if (str.length == 0 || count == 0) {
				return '';
			}
			// Ensuring count is a 31-bit integer allows us to heavily optimize the
			// main part. But anyway, most current (August 2014) browsers can't handle
			// strings 1 << 28 chars or longer, so:
			if (str.length * count >= 1 << 28) {
				throw new RangeError('repeat count must not overflow maximum string size');
			}
			var rpt = '';
			for (var i = 0; i < count; i++) {
				rpt += str;
			}
			return rpt;
		}
	}
	
	// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	if (!Array.prototype.includes) {
		Object.defineProperty(Array.prototype, 'includes', {
			value: function(searchElement, fromIndex) {
				if (this == null) {
					throw new TypeError('"this" is null or not defined');
				}
				var o = Object(this);
				var len = o.length >>> 0;
				if (len === 0) {
					return false;
				}
				var n = fromIndex | 0;
				var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
				
				function sameValueZero(x, y) {
					return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
				}
				
				while (k < len) {
					if (sameValueZero(o[k], searchElement)) {
						return true;
					}
					k++;
				}
				return false;
			}
		});
	}
}

apply_pollyfills();

jQuery.fn.on_once = function(...args) {
	if (typeof args[0] === "object") {
		const events = args[0];
		const rest_args = args.slice(1);
		for (const [event, handler] of Object.entries(events)) {
			const [event_name, namespace] = event.split(".");
			if (!namespace) {
				console.warn(`on_once requires a namespace for "${event}"`);
				continue;
			}
			this.off(event).on(event, handler, ...rest_args);
		}
		return this;
	}
	
	const event_string = args[0];
	if (!event_string.includes(".")) {
		console.warn(`on_once requires a namespace for "${event_string}"`);
		return this;
	}
	
	return this.off(event_string).on(...args);
};

jQuery.fn.off_namespace = function(namespace) {
	if (!namespace) {
		console.warn("off_namespace requires a namespace");
		return this;
	}
	return this.off(`.${namespace}`);
};

// unfortunately namespaced callbacks don't work currently (August 2018)
function generic_captcha_callback(a) {
	jQuery(document).trigger('captcha_success', a);
	// return new Promise(function(resolve, reject) {
	// 	jQuery(document).trigger('captcha_success', a);
	// 	resolve();
	// });
}

yalwa.basics = (function(pub) {
	'use strict';
	
	let debounce_refs = new Map();
	let expiration_suffix = '-expiration';
	const REGENERATE_THRESHOLD = 3600;
	const RELOAD_CHECK_THRESHOLD = 300; // 5 minutes in seconds
	
	pub = pub || {};
	
	pub.ONE_MINUTE = 60;
	pub.ONE_HOUR = 3600;
	pub.ONE_DAY = 86400;
	pub.ONE_WEEK = 604800;
	pub.ONE_MONTH = 2592000;
	pub.ONE_YEAR = 31536000;
	
	pub.PREMIUM_TOUCHPOINT = {
		MY_UPDATES: 8,
		MY_UPDATES_PLP: 9,
		PAF: 11,
		MY_PA_FOLLOWERS_MENU: 19,
		MY_PA_FOLLOWERS_START: 20,
		MY_PA_FOLLOWERS_DROPDOWN: 21,
		MC_PA_SNEAKPIC: 27,
		MC_PA_RECOVER: 32,
		MY_ADS_SPOTLIGHT: 37,
		SPOTLIGHT_CTA_TRY: 38,
		SPOTLIGHT_CTA_NO_TOP: 39,
		SPOTLIGHT_CTA_ALREADY: 40,
		SPOTLIGHT_CTA_READY: 41,
		SPOTLIGHT_CTA_WALLET_INACTIVE: 42,
		UPSELLING_SPOTLIGHT: 43,
		PURCHASE_AGAIN: 44,
		MY_UPDATES_INACTIVE: 47,
		MY_UPDATES_INACTIVE_PLP: 48,
		MY_UPDATES_INACTIVE_PLURAL: 49,
		MY_UPDATES_INACTIVE_PLURAL_PLP: 50,
		EMAIL_43: 57,
		EMAIL_125: 58,
		EMAIL_126: 59,
		EMAIL_127: 60,
		EMAIL_130: 61,
		EMAIL_131: 62,
		EMAIL_135: 63,
		EMAIL_136: 64,
		PA_PAF_WEBSITE_PHONE: 82,
		PA_VIP_LANDING_PAGE: 87,
	}
	
	let nav_started = false;
	let applied_bfcache_handlers = false;
	let check_stylesheet_polyfill_needed_promise;
	
	pub.init = async function() {
		use_passive_event_listeners_globally();
		let ua = navigator.userAgent.toLowerCase();
		yalwa.v.is_phonegap = (ua.indexOf('yalwapp') > -1);
		yalwa.v.is_ios = ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1 || /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		
		pub.ga.init();
		
		pub.check_stylesheet_polyfill_needed();
		session_storage_age_init();
		pub.sw.init();
		init_nonprod();
		autolabel_init();
		jQuery('body').on('click', '.js-post_ad', pub.js_post_ad_click);
		if (yalwa.v.is_phonegap) {
			if (!yalwa.v.is_ios) {
				// WARNING! Please don't activate fastclick.js. We don't need it any more, and it has side effects.
			}
			jQuery('.js-openexternal').on('click', yalwa.basics.openexternal_click); // beware used via cordova please don't move it used in UHP!!!
		}
		pub.init_follow_user();
		pub.fingerprint.init();
		pub.localize_user_online_ts();
		pub.init_show_more_ahp();
		
		if (window.loadjs) {
			window.loadjs.done('basics.js');
		}
		
		jQuery('.js-missing_info_end').on('click', (e) => {
			yalwa.basics.ga.pageview({page: '/profile_missing_info-profile', 'location': '/'}, 'b');
		});
		
		if (!((typeof yalwa.v.aid === 'undefined' || parseInt(yalwa.v.aid) > 0)
			&& (typeof yalwa.v.current_geoID === 'undefined' || yalwa.v.current_geoID <= 0))) {
			jQuery('.js-snh_go').prop('disabled', false);
		}
		
		init_promotion_tracking();
		if (!yalwa.basics.ls_get('uac_reset') || parseInt(yalwa.basics.ls_get('uac_reset')) < 1565647200) {
			yalwa.basics.ls_set('uac_reset', yalwa.basics.unix());
			yalwa.basics.ls_remove('uac');
		}
		if (yalwa.v.uac_userID && !yalwa.v.scache) {
			var uac = yalwa.basics.ls_get('uac', true) || [];
			var count_before = uac.length;
			uac.push(yalwa.v.uac_userID);
			var uac_new = uac.filter(filter_unique);
			yalwa.basics.ls_set('uac', uac_new);
			if (!yalwa.basics.ls_get('uac_u')) {
				yalwa.basics.ls_set('uac_u', pub.create_uuid());
			}
			if (count_before && count_before != uac_new.length && uac_new.length > 1) {
				uac_send(yalwa.basics.ls_get('uac_u'), yalwa.basics.ls_get('uac', true));
			}
		}
		
		pub.webpush.init();
		
		init_sc_icon();
		pub.init_button_links();
		
		if (jQuery('.js-animation_tada').length) {
			yalwa.basics.add_animation_on_pageload(jQuery('.js-animation_tada'), 'tada', 600);
		}
		
		if (!yalwa.basics.get_cookie('testing_cookie')) {
			yalwa.basics.set_cookie('testing_cookie', 1);
		}
		
		window.addEventListener('appinstalled', () => {
			yalwa.basics.ga.ping_metric('CM_PWA_INSTALLED', 1);
			yalwa.basics.ga.event({
				category: 'PWA',
				action: 'installed',
				label: 'locanto'
			});
		});
		
		check_underage();
		if (yalwa.v.seen_with_dol_account) {
			yalwa.basics.ls_set('seen_with_dol_account', true);
		}
		yalwa.basics.overlay.init();
		track_core_web_vitals();
		
		// initialize regenerate routine and fingerprint check/reload when user is logged in
		if (yalwa.basics.is_logged_in()) {
			yalwa.basics.ls_set('last_regenerate_ts', yalwa.basics.unix());
			init_regenerate_routine();
			init_check_reload_needed();
			user_updates_helper.load();
		}
		if (yalwa.basics.get_get('regenerate') === 'push') { // covers both webpush and cordova
			yalwa.basics.label('endpoint_confirmed_toast', 'main').done(label => {
				yalwa.basics.toast({message: label, type: 'success'});
				yalwa.basics.set_get({'regenerate': null}, false, false);
			});
		}
		
		if (yalwa.v.gdpr_active) {
			pub.load_js(yalwa.basics.static_url('js') + 'shared/gdpr.js');
		}
		check_for_ignored_postings();
		prepare_cached_bst_dol_promo();
		if (yalwa.basics.get_random_int(1, 100) === 1) { // track 1%
			setTimeout(resource_tracking, 10000);
		}
		if (jQuery('.js-show_posting_images').length) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/bst_posting_images.js', () => yalwa.bst_posting_images.init());
		}
		login_touch_point_check();
		handle_email_change_toast();
		
		yalwa.basics.pwa_promos.init_close_android_promo_listener();
		yalwa.basics.auth.gsi.init();
		yalwa.basics.username_tips.init();
		apply_bfcache_handlers();
		remove_srl_artifacts();
		flash_message();
		init_tippy();
		virtual_links();
		jQuery('.js-yalwa_closure_cta').on('click', yalwa_closure_cta);
		attach_pf_touchpoint_tracking();
		if (jQuery('.js-input_tips').length) {
			yalwa.basics.import_js('mobile/modules/input_tips.js').then((Module) => {
				Module.init();
			})
		}
	};
	
	pub.check_stylesheet_polyfill_needed = function() {
		if (check_stylesheet_polyfill_needed_promise) {
			return check_stylesheet_polyfill_needed_promise;
		}

		check_stylesheet_polyfill_needed_promise = (async function() {
			try {
				const has_doc = 'adoptedStyleSheets' in Document.prototype;
				let has_shadow = false;
				try {
					has_shadow = 'adoptedStyleSheets' in ShadowRoot.prototype;
				} catch {
					has_shadow = false;
				}
				const has_css_stylesheet = typeof CSSStyleSheet !== 'undefined';
				const has_replace_sync = has_css_stylesheet && typeof CSSStyleSheet.prototype.replaceSync === 'function';
				let can_construct = false;
				if (has_css_stylesheet) {
					try {
						new CSSStyleSheet();
						can_construct = true;
					} catch {
						can_construct = false;
					}
				}
				if (has_doc && has_shadow && has_css_stylesheet && has_replace_sync && can_construct) {
					return;
				}
			} catch (e) {
			
			}
			return new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.async = true;
				script.defer = true;
				script.src = yalwa.basics.static_url('js') + 'external/adoptedStyleSheets.js';
				script.onload = resolve;
				script.onerror = () => reject(new Error('Failed to load construct-style-sheets polyfill'));
				document.head.appendChild(script);
			});
		})();
		return check_stylesheet_polyfill_needed_promise;
	};

	
	function init_tippy() {
		const els = document.querySelectorAll('[data-tippy]');
		if (els.length) {
			yalwa.basics.load_tippy().done(() => {
				tippy('[data-tippy]', {
					content(reference) {
						return reference.getAttribute('data-tippy');
					},
					placement: 'bottom',
					allowHTML: true,
					trigger: 'mouseenter focus',
					interactive: true,
					hideOnClick: false,
					touch: false,
					zIndex: 8
				});
			});
		}
	}
	
	function attach_pf_touchpoint_tracking() {
		jQuery(document)
			.on('click', '.js-pf_touchpoint', pf_touchpoint_click)
			.on('click', '.js-pf_touchpoint_parent a', pf_touchpoint_click);
		if (yalwa.basics.get_get('utm_source') === 'locanto' && yalwa.basics.get_get('utm_medium') === 'system_email') {
			const whitelisted = [
				43, 125, 126, 127, 130, 131, 135, 136
			];
			if (whitelisted.includes(parseInt(yalwa.basics.get_get('utm_campaign')))) {
				pub.pf_touchpoint_add('email', {
					unix: yalwa.basics.unix(),
					touchpointID: pub.PREMIUM_TOUCHPOINT['EMAIL_' + yalwa.basics.get_get('utm_campaign')]
				});
			}
		}
	}
	
	pub.touchpoint_info_get = function() {
		return yalwa.basics.ls_get('pf_touchpoint_log', true) || {};
	};
	
	function pf_touchpoint_click() {
		const $e = jQuery(this).closest('.js-pf_touchpoint,.js-pf_touchpoint_parent');
		if ($e.data('touchpoint') === 73) {
			yalwa.basics.ga.datalayer({
				event: 'premium_account_rework',
				action: 'dropdown_menu_upgrade_click',
			});
		}
		pub.pf_touchpoint_add($e.data('touchpoint_featureclass'), {
			unix: yalwa.basics.unix(),
			touchpointID: $e.data('touchpoint')
		});
	}
	
	pub.pf_touchpoint_add = function(key, value) {
		const pf_touchpoint_log = pub.touchpoint_info_get();
		pf_touchpoint_log[key] = value;
		yalwa.basics.ls_set('pf_touchpoint_log', pf_touchpoint_log);
	};
	
	function yalwa_closure_cta() {
		jQuery('.js-yalwa_closure').remove();
		yalwa.basics.set_get({fyi: null});
	}
	
	function remove_srl_artifacts() {
		if (yalwa.basics.is_logged_in()) {
			if (yalwa.basics.get_get('srlp')) {
				yalwa.basics.set_get({'srlp': null});
			}
			yalwa.basics.set_cookie('srlp', 0, -1);
		}
	}
	
	pub.init_button_links = () => {
		jQuery('.js-button_link').off('click.button_click').on('click.button_click', function() {
			yalwa.basics.navigate(jQuery(this).data('url'));
		});
	}
	pub.snh_navigation_started = false;
	
	function apply_bfcache_handlers() {
		if (applied_bfcache_handlers) {
			return;
		}
		applied_bfcache_handlers = true;
		jQuery(window).on('pageshow', event => {
			if (event.originalEvent.persisted) {
				// snh activate search
				pub.snh_navigation_started = false;
				jQuery('.js-snh_go').prop('disabled', false);
				
				if (window.googletag && googletag.pubads) {
					googletag.pubads().refresh();
				}
				yalwa.basics.ga.update_navigation_type('bfcache');
				yalwa.basics.ga.pageview({page: document.location.pathname, location: document.location.href});
				yalwa.basics.ga.update_navigation_type('simulated');
				yalwa.basics.ga.update_pagetype_before();
			}
			if (pub.is_back_forward_navigation(event.originalEvent)) {
				if (yalwa.basics.get_routing() === 'vap') {
					jQuery('.js-main_col').css({transform: ''});
				}
				if (yalwa.v.search_page_cookie_page) {
					const type = ['BROWSE', 'SIMSEARCH', 'POPSEARCH'].indexOf(yalwa.basics.page_type()) ? 'browse' : 'search';
					yalwa.basics.set_cookie(
						'loc_last_sp_mobile',
						type + encodeURIComponent("\t") + location.href
					);
				}
				if (yalwa.basics.get_random_int(1, 100) === 1) {
					yalwa.basics.ga.event({
						category: 'bfcache',
						action: 'used',
						label: event.originalEvent.persisted ? 'yes' : 'no'
					});
				}
			}
		});
	}
	
	const user_updates_helper = (function(pub) {
		
		pub = pub || {};
		pub.load = _ => {
			if (!yalwa.v.WELCOME_BACK) {
				return;
			}
			apply_bfcache_handler();
		};
		
		function init() {
			if (yalwa.v.user_updates_clear_cache) {
				yalwa.basics.ls_set('user_updates_clear_cache', true);
			}
			if (jQuery('.js-loader_userupdates').length) {
				if (typeof yalwa.user_updates === 'undefined') {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/user_updates.js', function() {
						yalwa.user_updates.init(true, true);
					}, false, true);
				} else {
					yalwa.user_updates.show(true, true);
				}
			} else if (can_be_showed()) {
				yalwa.basics.ls_set('user_updates_clear_cache', true);
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/user_updates.js', function() {
					yalwa.user_updates.init();
				}, false, true);
			}
			jQuery('body').on('click', '.js-user_updates_menu_button', _ => {
				if (typeof yalwa.user_updates === 'undefined') {
					yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/user_updates.js', function() {
						yalwa.user_updates.init(true);
					}, false, true);
				} else {
					yalwa.user_updates.show(true);
				}
			});
		}
		
		function apply_bfcache_handler() {
			jQuery(window).on('pageshow', event => {
				if (yalwa.basics.is_back_forward_navigation(event.originalEvent)) {
					yalwa.v.user_updates_buttons_showable = yalwa.basics.ss_get('user_updates_buttons_showable');
					yalwa.v.user_updates_seen = yalwa.basics.ss_get('user_updates_seen');
					init();
				} else { // update clients session storage with server values
					yalwa.basics.ss_set('user_updates_buttons_showable', yalwa.v.user_updates_buttons_showable);
					determine_seen().then(init);
				}
			});
		}
		
		const API = '/api/ajax/user_updates';
		
		const set_seen = _ => {
			return jQuery.ajax({
				url: API,
				type: 'get',
				dataType: 'json',
				data: {
					action: 'set_seen'
				},
				cache: false
			});
		}
		
		const determine_seen = _ => {
			return new Promise((resolve, reject) => {
				let has_it_been_seen = true;
				if (['vap', 'PAF', 'PAF_create_new', 'checkout', 'book_upgrade'].includes(yalwa.v.routing) && !yalwa.v.user_updates_seen) {
					return set_seen().then(response => {
						resolve(response);
					});
				} else {
					has_it_been_seen = yalwa.v.user_updates_seen;
				}
				yalwa.basics.ss_set('user_updates_seen', has_it_been_seen);
				yalwa.v.user_updates_seen = has_it_been_seen;
				resolve('init_without_seen_update');
			});
		}
		
		const get_last_activity = _ => {
			return JSON.parse(decodeURIComponent(yalwa.basics.get_cookie('last_activity')));
		}
		
		const can_be_showed = _ => {
			return yalwa.v.user_updates_buttons_showable && !yalwa.v.user_updates_seen;
		}
		
		return pub;
		
	}());
	
	pub.get_navigation_type = function() {
		let nav = window.performance.getEntriesByType('navigation');
		if (nav[0] && nav[0].type) {
			return nav[0].type;
		}
		return null;
	};
	
	pub.init_show_more_ahp = function() {
		
		jQuery('.js-ahp_see_more_button').on('click', (e) => {
			var cl = 'ahp_categorylist__l2_collapsed';
			jQuery(e.currentTarget).siblings('.' + cl).removeClass(cl);
			yalwa.basics.show(jQuery(e.currentTarget).siblings('.js-ahp_categorylist__l2_see_more'));
			jQuery(e.currentTarget).remove();
			recalculate_columns_height();
		});
		
		show_more_ahp();
		recalculate_columns_height();
		
		jQuery(window).on('resize', () =>
			yalwa.basics.debounce(function() {
				show_more_ahp();
				recalculate_columns_height();
			}, 100)
		);
		
	};
	
	function recalculate_columns_height() {
		const $container = jQuery('.ahp_categorylist').first();
		const desktop_width = 1080;
		
		if (window.innerWidth > desktop_width) {
			$container.css('gridAutoRows', '2px');
		} else {
			$container.css('gridAutoRows', '');
		}
		
		const columns = 3;
		const column_heights = Array(columns).fill(0);
		const $grid_items = $container.children();
		let max_column_height = 0;
		
		$grid_items.each(function() {
			const $item = $(this);
			const column = parseInt($item.css('gridColumnStart'), 10) - 1;
			const row_start = Math.ceil(column_heights[column] / 2);
			$item.css('gridRowStart', row_start);
			column_heights[column] += $item.outerHeight() + 16;
			if (column_heights[column] > max_column_height) {
				max_column_height = column_heights[column];
			}
		});
		
		if (window.innerWidth > desktop_width) {
			$container.css('height', max_column_height + 'px');
		} else {
			$container.css('height', '');
		}
	}
	
	function show_more_ahp(params) {
		const $see_more_selector = jQuery(".js-ahp_categorylist__l2_collapsed");
		$see_more_selector.each(function() {
			let $el = jQuery(this);
			let $button = $el.siblings('.js-ahp_see_more_button');
			let $hidden = $el.siblings('.js-ahp_categorylist__l2_see_more');

			if ($hidden.length && $hidden.children().length > 0) {
				$button.show();
			} else if ($el[0].scrollHeight != Math.round($el.innerHeight())) {
				$button.show();
			} else {
				$button.hide();
			}
		});
	};
	
	pub.is_back_forward_navigation = function(event) {
		// check for bfcache
		if (event && (event.persisted || (event.originalEvent && event.originalEvent.persisted))) {
			return true;
		}
		// check for disk cache
		return pub.get_navigation_type() === 'back_forward';
	};
	
	function use_passive_event_listeners_globally() {
		// https://github.com/jquery/jquery/issues/2871
		jQuery.event.special.touchstart = {
			setup: function(_, ns, handle) {
				this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
			}
		};
		jQuery.event.special.touchmove = {
			setup: function(_, ns, handle) {
				this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
			}
		};
		jQuery.event.special.wheel = {
			setup: function(_, ns, handle) {
				this.addEventListener("wheel", handle, {passive: true});
			}
		};
		jQuery.event.special.mousewheel = {
			setup: function(_, ns, handle) {
				this.addEventListener("mousewheel", handle, {passive: true});
			}
		};
	}
	
	function abandoned_recently() {
		const ts = yalwa.basics.get_cookie('track_jumpoff_last_ts');
		if (ts && ts - yalwa.basics.unix() < 48 * 60 * 60) {
			return yalwa.basics.get_cookie('track_jumpoff');
		}
	}
	
	function get_resource_type(type, url) {
		if (type === 'img') {
			if (/\.svg/.test(url)) {
				type = 'svg';
			}
		} else {
			if (/\.svg/.test(url)) {
				type = 'svg';
			} else if (/\.(gif|jpe?g|png|webp|ico)$/.test(url)) {
				type = 'img';
			} else if (/\.css$/.test(url)) {
				type = 'css';
			} else if (/\.js([\?#].*)?$/.test(url)) {
				type = 'script';
			} else if (/\.woff2?$/.test(url)) {
				type = 'font';
			} else if (/fonts\.googleapis/.test(url)) {
				type = 'font';
			} else {
				// console.log('unknown/unhandled resource type: ' + type + ' ' + url);
				return 'other';
			}
		}
		if (type === 'script') {
			if (!/^https:\/\/static\.locanto/.test(url)) {
				type = 'script_external';
			}
		}
		return type;
	}
	
	function resource_tracking() {
		if (window.performance === undefined) {
			return;
		}
		const list = performance.getEntriesByType("resource");
		if (list === undefined) {
			return;
		}
		const by_type = {};
		for (let i = 0; i < list.length; i++) {
			const t_size = list[i].transferSize;
			const url = list[i].name;
			if (!t_size) {
				// console.log('ignore (no size): ' + url);
				continue;
			}
			let type = get_resource_type(list[i].initiatorType, url);
			if (['xmlhttprequest', 'iframe', 'beacon', 'other'].indexOf(type) !== -1) {
				// console.log('ignore: (type ' + type + ')' + url);
				continue;
			}
			
			if (by_type[type] === undefined) {
				by_type[type] = {
					transfer_size: 0,
					item_count: 0,
					// details: []
				};
			}
			by_type[type].item_count++;
			// by_type[type].details.push(url + ' ' + t_size);
			by_type[type].transfer_size += t_size || 0;
		}
		yalwa.basics.beacon('/api/ajax/track/', {
			t: 'resources',
			data: JSON.stringify(by_type),
			pagetype: yalwa.basics.page_type()
		});
	}
	
	function regenerate() {
		yalwa.basics.ls_set('last_regenerate_ts', yalwa.basics.unix());
		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'post',
			data: {
				action: 'regenerate_login'
			}, xhrFields: {
				withCredentials: true
			}
		});
	}
	
	function init_regenerate_routine() { // post requests might fail when the page was open for a long time and session expired
		document.addEventListener('visibilitychange', regenerate_check);
	}
	
	function regenerate_check() {
		if (document.visibilityState === 'visible' &&
			yalwa.basics.ls_get('last_regenerate_ts') &&
			yalwa.basics.is_logged_in() &&
			(yalwa.basics.unix() - yalwa.basics.ls_get('last_regenerate_ts') > REGENERATE_THRESHOLD)) {
			regenerate();
		}
	}
	
	function flash_message() {
		var $flash_message = jQuery('.js-flash_message');
		if ($flash_message.length && $flash_message.data('message')) {
			var message_type = $flash_message.data('type') || 'success';
			yalwa.basics.toast({
				message: decodeURI($flash_message.data('message')),
				progressBar: true,
				type: message_type,  // Use the value from data-type
				positionClass: "toast-top-full-width",
				timeOut: 10000
			});
		}

		if (yalwa.basics.get_cookie('flash_message')) {
			yalwa.basics.toast({
				message: decodeURI(yalwa.basics.get_cookie('flash_message')),
				progressBar: true,
				type: 'success',
				positionClass: "toast-top-full-width",
				timeOut: 10000
			});
			yalwa.basics.set_cookie('flash_message', 0, -1);
		}
	}
	
	function virtual_links() {
		$(document).on('click', '[data-virtual-href]', function(event) {
			const href = $(this).data('virtual-href');
			if (href.startsWith('?')) {
				const current_url = new URL(window.location.href);
				const new_params = new URLSearchParams(href.slice(1));
				new_params.forEach((value, key) => {
					current_url.searchParams.set(key, value);
				});
				window.location.href = current_url.toString();
			} else {
				const original_href = href.replace(/\|/g, '/');
				const restored_href = 'https://' + original_href;
				window.location.href = restored_href;
			}
		});
	}
	
	function init_check_reload_needed() {
		if (!yalwa.v.scache) {
			document.addEventListener('visibilitychange', check_reload_needed);
		}
	}
	
	/**
	 * reload the page when the last reload time is 5 minutes ago and there is new fingerprint available
	 * @see https://yalwa.atlassian.net/browse/DEV-2971
	 */
	function check_reload_needed() {
		if (location.port) {
			return; // disabled by Philipp, not always helpful on dev, since you might want to preserve a specific state
		}
		if (document.visibilityState === 'visible'
			&& yalwa.basics.ls_get('last_regenerate_ts')
			&& yalwa.basics.is_logged_in()
			&& (yalwa.basics.unix() - yalwa.basics.ls_get('last_regenerate_ts') > RELOAD_CHECK_THRESHOLD)) {
			get_fingerprint().done(function(response) {
				if (response && response.success) {
					const revision_number = yalwa.basics.revision_number();
					let DOM_fingerprint;
					if (revision_number && typeof revision_number === 'string') {
						DOM_fingerprint = revision_number.replace('/', '');
					}
					
					const last_check_loaded_ts = yalwa.basics.ls_get('last_check_reloaded_ts');
					// when the server fingerprint and DOM fingerprint are different reload the page
					if (DOM_fingerprint
						&& response.fingerprint
						&& DOM_fingerprint !== response.fingerprint
						&& (!last_check_loaded_ts || yalwa.basics.unix() - last_check_loaded_ts > RELOAD_CHECK_THRESHOLD)
					) {
						yalwa.basics.ls_set('last_check_reloaded_ts', yalwa.basics.unix());
						yalwa.basics.reload();
					}
				}
			});
		}
	}
	
	function get_fingerprint() {
		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'get',
			dataType: 'json',
			data: {action: 'get_fingerprint'},
			cache: false
		});
	}
	
	function track_core_web_vitals() {
		if (location.hostname === 'locan.to' || location.hostname === 'lcn.to') { // short url (used for sharing)
			return;
		}
		if (yalwa.basics.get_routing() === 'demo') {
			return;
		}
		const page_type = pub.page_type();
		const is_distribution = Boolean(yalwa.v.is_distribution_page);
		const track_percent_10 = ['HOME', 'INDEX', 'POST'].indexOf(page_type) !== -1 || yalwa.v.is_dol;
		const track_percent_100 = Boolean(location.port) || is_distribution;
		if (track_percent_100 || (track_percent_10 && yalwa.basics.get_random_int(1, 10) === 1) || yalwa.basics.get_random_int(1, 100) === 1) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/webvitals.min.js', () => {
				webVitals.onCLS(send_to_analytics);
				webVitals.onLCP(send_to_analytics);
				webVitals.onINP(send_to_analytics);
				webVitals.onTTFB(send_to_analytics);
				webVitals.onFCP(send_to_analytics);
			});
		}
	}
	
	pub.is_mobile_browser = function() { // https://stackoverflow.com/a/45666491/333864
		return /Mobi/i.test(window.navigator.userAgent);
	};
	
	pub.app_type = function() {
		return yalwa.basics.ga.dimension_get('CD_APPTYPE');
	};
	
	pub.page_type = function() {
		return yalwa.basics.ga.dimension_get('CD_PAGETYPE');
	};
	
	pub.revision_number = function() {
		return yalwa.basics.ga.dimension_get('CD_APPVERSION');
	};
	
	function send_to_analytics(metric) {
		let is_nationwide_val = 3; // N/A
		if (yalwa.v.is_nationwide !== undefined) {
			is_nationwide_val = yalwa.v.is_nationwide ? 2 : 1;
		}
		let data = {
			t: 'web-vitals',
			page_type: pub.page_type(),
			app_type: pub.app_type(),
			metric: metric.name,
			value: metric.value,
			is_nationwide: is_nationwide_val,
			scache: yalwa.v.scache ? 1 : 0,
		};
		yalwa.basics.beacon('/api/ajax/track/', data);
		const thresholds_to_log = {
			'CLS': 250,
			'INP': 500,
			'LCP': 4000,
			'FCP': 3000,
			'TTFB': 1800,
		};
		let v = metric.value;
		if (metric.name === 'CLS') {
			v *= 1000;
		}
		if (thresholds_to_log[metric.name] && v > thresholds_to_log[metric.name]) {
			yalwa.basics.ga.event({
				category: 'web vitals',
				action: 'bad ' + metric.name,
				label: yalwa.basics.page_type(),
				value: v
			});
		}
	}
	
	function session_storage_age_init() {
		if (!yalwa.basics.ss_get('sessionStorage_age')) {
			yalwa.basics.ss_set('sessionStorage_age', yalwa.basics.unix());
		}
	}
	
	pub.equalize_heights = function($elements, add = 0) {
		// Reset heights to auto for accurate measurement
		$elements.css('height', 'auto');
		
		// Find maximum height
		let max_height = 0;
		$elements.each(function() {
			const current_height = $(this).outerHeight();
			if (current_height > max_height) {
				max_height = current_height;
			}
		});
		
		if (add) {
			max_height += add;
		}
		
		// Apply uniform height
		$elements.outerHeight(max_height);
	}
	
	pub.session_storage_age = function() {
		if (yalwa.basics.ss_get('sessionStorage_age')) {
			return yalwa.basics.unix() - yalwa.basics.ss_get('sessionStorage_age');
		} else {
			return null;
		}
	};
	
	pub.string_contains_non_latin_chars = foreign_characters => /[^\u0020-\u007e]|(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/.test(foreign_characters);
	
	function check_underage() {
		if (yalwa.v.init_plp_underage && jQuery('.js-plp_underage').length) {
			jQuery('.js-plp_underage .js-plp_ok').on('click', () => jQuery('.js-logo_link img').trigger('click'));
			jQuery('.js-plp_underage .js-plp_confirm').on('click', () => {
				yalwa.basics.set_cookie('loc_underage_accept', 1, yalwa.basics.ONE_MONTH);
				jQuery('.js-generic_shadow').hide();
			});
		}
	}
	
	function resolve_asset_url(url) {
		const match = url.match(/\/assets\/[\d_]+\/(js|styles)\/(.+)$/);
		if (!match) {
			return Promise.resolve(url); // external URL, pass through
		}
		const type = match[1];
		const path = match[2];

		// fonts use a static 1_1 makeref, no filemtime resolution needed
		if (path.indexOf('fonts/') === 0) {
			return Promise.resolve(url);
		}

		// check pre-resolved hot_assets tokens first (server-side injected via php_var_to_js)
		const hot_token = yalwa.v.hot_assets && yalwa.v.hot_assets[type] && yalwa.v.hot_assets[type][path];
		if (hot_token) {
			return Promise.resolve(url.replace(/\/assets\/[\d_]+\//, '/assets/' + hot_token + '/'));
		}

		const cache_key = 'afu:' + (yalwa.v.fingerprint || '') + ':' + type + ':' + path;

		let cached = yalwa.basics.ls_get(cache_key);
		if (cached) {
			return Promise.resolve(cached);
		}

		return jQuery.ajax({
			url: '/api/ajax/general',
			type: 'get',
			dataType: 'json',
			data: {action: 'get_asset_url', type: type, path: path},
			cache: false
		}).then(function (response) {
			if (response && response.success && response.url) {
				yalwa.basics.ls_set(cache_key, response.url);
				return response.url;
			}
			yalwa.basics.ls_set(cache_key, url); // cache fallback so we don't retry every load
			return url;
		}, function () {
			yalwa.basics.ls_set(cache_key, url); // AJAX failed → cache fallback
			return url;
		});
	}

	const load_deferreds = {};
	/**
	 * please do not use callback, use promise chain instead.
	 * @param {string} url
	 * @param {string} type
	 * @param {string} no_crossorigin
	 * @param {array<string>} attributes
	 * @param {array<string>} data_attributes
	 * @param {function} callback - deprecated, use promise chain instead.
	 * @return {Promise}
	 */
	pub.load_js = function(url, callback, type, no_crossorigin, attributes, data_attributes) {
		url = pub.normalize_asset_path(url);
		if (!load_deferreds[url]) {
			const d = jQuery.Deferred();
			resolve_asset_url(url).then(function (resolved_url) {
				const script = document.createElement('script');
				script.onload = () => d.resolve();
				script.onerror = () => {
					console.error(`Failed to load script: ${resolved_url}`);
					d.reject(`Script load error for ${resolved_url}`);
				};
				script.src = resolved_url;
				script.type = type ? type : '';
				if (!no_crossorigin) {
					script.crossOrigin = 'anonymous';
				}
				if (attributes) {
					attributes.forEach(attribute => {
						script[attribute] = true;
					})
				}
				if (data_attributes) {
					Object.keys(data_attributes).forEach(key => {
						script.setAttribute('data-' + key, data_attributes[key]);
					});
				}
				document.head.appendChild(script);
			}, function () {
				d.reject();
			});
			load_deferreds[url] = d.promise();
		}
		return load_deferreds[url].done(() => {
			if (typeof callback === 'function') {
				callback();
			}
		});
	};

	pub.load_css_multiple = function(urls) {
		// Load CSS files
		const css_promises = (urls || []).map(url => yalwa.basics.load_css(url));
		// Wait for all assets to load
		return Promise.all([...css_promises])
			.then(() => {
				console.log('all given css assets loaded successfully')
			})
			.catch(error => {
				console.error('Failed to load assets:', error);
			});
	}

	pub.normalize_asset_path = function(url) {
		const parsed_url = new URL(url, window.location.href);
		parsed_url.pathname = parsed_url.pathname.replace(/\/{2,}/g, '/');
		return parsed_url.href;
	};
	
	pub.load_css = function(url) {
		if (Array.isArray(url)) {
			return pub.load_css_multiple(url);
		}

		url = pub.normalize_asset_path(url);

		return resolve_asset_url(url).then(function (resolved_url) {
			return new Promise((resolve, reject) => {
				if (document.querySelector(`link[href="${resolved_url}"]`) || document.querySelector(`link[href="${url}"]`)) {
					resolve();
					return;
				}
				const link = document.createElement('link');
				link.rel = 'stylesheet';
				link.type = 'text/css';
				link.href = resolved_url;
				link.onload = resolve;
				link.onerror = reject;
				document.head.appendChild(link);
			});
		});
	};
	
	pub.fingerprint = function(pub) {
		
		let key_hash = 'fingerprint';
		let key_ID = 'fingerprintID';
		
		pub = pub || {};
		
		pub.init = function() {
			pub.check();
		};
		
		pub.check = function() {
			if (!yalwa.basics.is_logged_in()) {
				return;
			}
			if (!yalwa.basics.ss_get(key_hash)) {
				// calc fingerprint only once during session
				try {
					load().done(determine);
				} catch (error) {
				
				}
			}
		};
		
		pub.getID = function() {
			return yalwa.basics.ls_get(key_ID);
		};
		
		pub.clear = function() {
			yalwa.basics.ls_remove(key_ID);
			yalwa.basics.ss_remove(key_hash);
		}
		
		function determine() {
			if (typeof Fingerprint2 === 'undefined') {
				return;
			}
			if (window.requestIdleCallback) {
				requestIdleCallback(store);
			} else {
				setTimeout(store, 500);
			}
		}
		
		function store() {
			Fingerprint2.getPromise().then((components) => {
				let hash = calc_hash(components);
				yalwa.basics.ss_set(key_hash, hash);
				send_to_server(hash);
			});
		}

		pub.get_hash = async function () {
			try {
				await load();
				const components = await Fingerprint2.getPromise();
				let hash = calc_hash(components);
				return hash;
			} catch (error) {
				return null;
			}
		};
		
		function calc_hash(components) {
			return Fingerprint2.x64hash128(components.map((c) => c.value).join(''), 31);
		}
		
		function send_to_server(hash) {
			return jQuery.ajax({
				url: '/api/ajax/save_fingerprint/',
				type: 'post',
				data: {
					fingerprint: hash,
					ua: navigator.userAgent
				}
			}).done(function(fingerprintID) {
				if (fingerprintID > 0) {
					// store latest ID in localStorage
					yalwa.basics.ls_set(key_ID, fingerprintID);
					jQuery('body').trigger('fingerprint_saved');
				}
			});
		}
		
		function load() {
			return yalwa.basics.load_js('https://cdnjs.cloudflare.com/ajax/libs/fingerprintjs2/2.1.0/fingerprint2.min.js');
		}
		
		return pub;
		
	}(pub.fingerprint);
	
	pub.is_html_cached = function() {
		if (yalwa.basics.ls_get('page_created') === null || yalwa.basics.ls_get('page_created') === 'undefined') {
			yalwa.basics.ls_set('page_created', yalwa.v.page_created);
			return false;
		}
		if (parseInt(yalwa.basics.ls_get('page_created')) < yalwa.v.page_created) {
			yalwa.basics.ls_set('page_created', yalwa.v.page_created);
			return false;
		}
		return true;
	};
	
	function handle_session_l1() {
		if (yalwa.v.session_user_type !== undefined) {
			let do_it = true;
			switch (yalwa.v.session_user_type) {
				case 'personals':
				case 'non-personals':
				case 'hybrid':
					do_it = yalwa.basics.ss_get('session_l1_type_send') !== yalwa.v.session_user_type;
					break;
			}
			if (do_it) {
				yalwa.basics.ss_set('session_l1_type_send', yalwa.v.session_user_type);
				track_session_user_type();
			}
		}
	}
	
	function track_session_user_type() {
		yalwa.basics.ga.dimension_set('CD_SESSION_L1_TYPE', yalwa.v.session_user_type);
	}
	
	function init_sc_icon() {
		if (jQuery('.js-floating_sc_button').length) {
			yalwa.basics.add_animation_on_pageload(jQuery('.js-sc_animation'), 'tada', 600);
			jQuery('.js-floating_sc_button').on('click', function(e) {
				e.preventDefault();
				yalwa.basics.ga.event({
					category: 'shopping cart click',
					action: 'shopping cart click'
				});
				yalwa.basics.navigate(jQuery('.js-floating_sc_button').attr('href'))
				return false;
			});
		}
	}
	
	pub.openexternal_click = function(e) { // beware used via cordova please don't move it used in UHP!!!
		e.preventDefault();
		e.stopPropagation();
		yalwa.basics.openexternal(jQuery(this).prop('href'));
		return false;
	};
	
	pub.openexternal = function(url) { // beware used via cordova please don't move it used in UHP!!!
		if (yalwa.basics.yalwapp_version() >= 240) {
			yalwa.basics.cordova_send({action: 'openexternal', params: {url: url}});
		}
	};
	
	pub.openpartner = function(url) { // beware used via cordova
		// After 270 release use only openexternal
		yalwa.basics.openexternal(url);
		/*if (yalwa.basics.yalwapp_version() >= 250) {
			yalwa.basics.cordova_send({action: 'openpartner', params: {url: url}});
		} else {
			yalwa.basics.openexternal(url);
		}*/
	};
	
	pub.openwebintent = function(url) { // beware used via cordova
		if (yalwa.basics.yalwapp_version() >= 250) {
			yalwa.basics.cordova_send({action: 'openpartner', params: {url: url}});
		} else {
			yalwa.basics.openexternal(url);
		}
	};
	
	pub.opensecondwebview = function(url) { // beware used via cordova
		if (yalwa.basics.yalwapp_version() >= 270) {
			yalwa.basics.cordova_send({action: 'opensecondwebview', params: {url: url}});
		} else {
			yalwa.basics.openexternal(url);
		}
	};
	
	pub.opencordovaexternal = function(url) {
		let app_version = yalwa.basics.yalwapp_version();
		
		if (!yalwa.v.is_phonegap || app_version === 0) {
			window.open(url, null, 'noopener');
			return;
		}
		
		yalwa.basics.cordova_send({
			action: app_version < 270 ? 'openpartner' : 'openexternal',
			params: {
				url: url.replace(/^http:/, "https:") // cordova inappbrowser does not support http protocol
			}
		});
	};
	
	pub.cordova_send = function(object) { // beware used via cordova please don't move it used in UHP!!!
		if (yalwa.v.is_phonegap) {
			// App versions whose expander listens on the InAppBrowser message bridge
			// receive actions immediately; the expander only runs the cordova_collect
			// polling loop when the bridge predicate is inactive.
			if (is_iab_message_bridge_active()) {
				try {
					// The plugin's native bridge delivers a plain STRING body as a
					// message event; a dictionary body would be treated as an
					// executeScript result routed by its id (and silently dropped).
					window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(object));
					return;
				} catch (e) {
					// bridge not available in this webview, fall through to the queue
				}
			}
			yalwa.v.send_pending = yalwa.v.send_pending || [];
			yalwa.v.send_pending.push(object);
		}
	};
	pub.cordova_collect = function() { // beware used via cordova please don't move it used in UHP!!!
		var pending = yalwa.v.send_pending;
		if (pending) {
			yalwa.v.send_pending = null;
		}
		return {items: pending, timeout: 500};
	};
	
	pub.add_animation_on_scrollview = function($element, name, animation) {
		
		if ($element.length) {
			
			var animation_done = false;
			var $scroll_window;
			$scroll_window = jQuery('.js-main_col');
			$scroll_window.on('scroll.' + name, yalwa.basics.throttle(function() {
				if (is_scrolled_into_view($element) && !animation_done) {
					setTimeout(function() {
						// $element.addClass('animated ' + animation);
						$element.velocity('callout.' + animation, {duration: 600, delay: 600});
					}, 200);
					animation_done = true;
					$scroll_window.unbind('scroll.' + name);
				}
			}, 200));
		}
	};
	
	pub.add_animation_on_pageload = function($element, animation, timeout) {
		if (!timeout) {
			timeout = 200;
		}
		if ($element.length) {
			setTimeout(function() {
				if (jQuery.fn.velocity) {
					$element.velocity('callout.' + animation, {duration: 600, delay: 600});
				}
			}, timeout);
		}
	};
	
	/*
	 * function to check if a Locanto user also has #Dating account
	 * @param {int} id - locanto user ID
	 */
	pub.check_is_dol_user = function(id) {
		return jQuery.ajax({
			url: '/api/ajax/dol',
			dataType: 'json',
			type: 'get',
			data: {
				action: 'is_dol_user',
				userID: id
			}
		});
	};
	
	function is_scrolled_into_view(elem) {
		var docViewTop = jQuery(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();
		
		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();
		
		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}
	
	function uac_send(uac_u, uac) {
		jQuery.ajax({
			url: '/api/ajax/general/',
			type: 'post',
			data: {
				action: 'uac',
				uac_u: uac_u,
				uac: JSON.stringify(uac)
			},
			dataType: 'json'
		}).done(function(r) {
			if (r.other_uuid) {
				yalwa.basics.ls_set('uac_u', r.other_uuid);
			}
			if (r.reset) {
				yalwa.basics.ls_set('uac_reset', yalwa.basics.unix());
				yalwa.basics.ls_remove('uac');
			}
		});
	}
	
	pub.before_logout = function() {
		const deferred = jQuery.Deferred();
		yalwa.basics.webpush.unsubscribe().then(() => {
			yalwa.basics.fingerprint.clear();
			deferred.resolve(true);
		});
		return deferred.promise();
	};
	
	function filter_unique(value, index, self) {
		return self.indexOf(value) === index;
	}
	
	function init_promotion_tracking() {
		jQuery('.js-promotion').on('click', function() {
			var $promotion = jQuery(this);
			var promo_touchpoint = $promotion.data('promo_touchpoint');
			var promo_name = $promotion.data('promotion_name');
			yalwa.basics.set_cookie('track_promotion_click', promo_touchpoint + '--' + promo_name, 86400);
			return true;
		});
	}

//autolabel
	function autolabel_init() {
		jQuery('.js-autolabel:not(.autolabel-wrap)').each(function() {
			var $this = jQuery(this);
//			$this.on('click', '.js-autolabel_clear', function() {
//				jQuery(this).closest('.autolabel-wrap').find('input,textarea,select').val('').trigger('input');
//			});
			$this.addClass('autolabel-wrap')
				.find('input,textarea').on('input', yalwa.basics.autolabel_check)
				.each(function(index, element) {
					var $element = jQuery(element);
					if ($element.is('textarea')) {
						$element.parent().addClass('autolabel-textarea');
					}
					yalwa.basics.autolabel_check.apply(element);
				});
			
			$this.find('select').on('change', yalwa.basics.autolabel_check)
				.each(function(index, element) {
					yalwa.basics.autolabel_check.apply(jQuery(element));
				});
			
			$this.find('.jq-dropdown-menu input[type="radio"]').on('change', yalwa.basics.autolabel_check)
				.each(function(index, element) {
					yalwa.basics.autolabel_check.apply(jQuery(element));
				});
		});
	}
	
	function autolabel_check() {
		var $this = jQuery(this);
		var value = $this.val();
		var hidevalue;
		var text;
		
		if ($this.parents('.jq-dropdown-menu').length > 0) {
			if (!jQuery(this).is(':checked')) {
				return;
			}
			
			$this = $this.closest('.jq-dropdown');
			text = $this.data('autolabel');
		} else {
			text = $this.data('autolabel') || $this.attr('placeholder');
		}
		
		if ($this.data('hidevalue')) {
			hidevalue = '' + $this.data('hidevalue');
		} else {
			hidevalue = '';
		}
		
		if ((!(hidevalue === 'empty' && !value))) {
			if (!$this.siblings('label').length) {
				if (text) {
					var $l = jQuery('<label>' + text + '</label>');
//					var $l = jQuery('<label>' + text + ($this.hasClass('js-autolabel_offer_clear') ? '<span class="autolabel-clear js-autolabel_clear">clear</span>' : '') + '</label>');
					$l.addClass('autolabel-animation');
					if ($this.hasClass('jq-dropdown')) {
						$l.css('z-index', 101);
					}
					
					$l.insertAfter($this);
				}
			}
		} else {
			$this.siblings('label').remove();
		}
	}

//autolabel-end
	
	pub.is_pwa = function() {
		if (window.navigator.standalone === true) {
			return true;
		}
		if (typeof (matchMedia) === 'function' && matchMedia('(display-mode: standalone)').matches) {
			return true;
		}
		return false;
	};
	
	function init_nonprod() {
		if (location.port) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/dev.js');
		}
	}
	
	pub.init_wrapper = function(callback, wait_for) {
		jQuery(callback);
	};
	
	pub.get_random_int = function(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};
	
	pub.random_percentage = function(percent) {
		const random = Math.random();
		return random <= (percent / 100) ? true : false;
	};
	
	pub.maps = {
		api_call_done: false,
		load_with_apikey: function(callback_name, additional) {
			additional = additional || '';
			yalwa.basics.load_js('https://maps.googleapis.com/maps/api/js?key=' + yalwa.v.google_api_key + '&callback=' + callback_name + additional, null, null, true);
		},
		load_api: function(callback_name, additional) {
			pub.maps.load_with_apikey(callback_name, additional);
			pub.maps.api_call_done = true;
		},
		suggestions: function geolocate_autocomplete_request(lat, lon) {
			return jQuery.ajax({
				url: '/api/geo/geolocate_autocomplete/',
				data: {
					lat: lat,
					lon: lon,
					mobile: true
				},
				dataType: 'json'
			});
		}
	};
	
	function cookie_name_final(cookie_name) {
		const whitelist = yalwa.v.cookie_names_whitelist || [];
		const cookie_prefix = yalwa.v.cookie_prefix;
		if (whitelist.includes(cookie_name) && cookie_prefix) {
			return `${cookie_prefix}${cookie_name}`;
		} else {
			return cookie_name;
		}
	}
	
	pub.get_cookie_name_final = cookie_name_final;
	
	pub.get_cookie = function(cookie_name) {
		if (typeof (document.cookie) === 'undefined') {
			return false;
		}
		cookie_name = cookie_name_final(cookie_name);
		// https://stackoverflow.com/a/21125098/333864
		let match = document.cookie.match(new RegExp('(^| )' + cookie_name + '=([^;]+)'));
		if (match) {
			return match[2];
		} else {
			return false;
		}
	};
	
	pub.set_cookie = function(cookie_name, content, duration) {
		var domain;
		if (yalwa.v.cookie_domain) {
			domain = yalwa.v.cookie_domain;
		} else {
			var host = window.location.href.replace((location.protocol ? location.protocol : 'http:') + '//', '').split('/')[0];
			host = host.split('.');
			var pos = host.length - 1;
			if (host[pos].search(/:/)) {
				host[pos] = host[pos].split(':')[0]; // remove port
			}
			domain = host[pos - 1] + '.' + host[pos];
			if (host[pos - 1] === 'co' || host[pos - 1] === 'com') {
				domain = host[pos - 2] + '.' + domain;
			}
			if (typeof (arguments[3]) !== 'undefined' && arguments[3]) {
				var i = pos - 2;
				while (i >= 0) {
					domain = host[i] + '.' + domain;
					i--;
				}
			}
		}
		cookie_name = cookie_name_final(cookie_name);
		var c = cookie_name + '=' + content + '; domain=' + domain + '; path = /; Secure; SameSite=Lax';
		if (duration) {
			var d = new Date();
			d = new Date(d.getTime() + 1000 * duration);
			c += '; expires=' + d.toGMTString();
		}
		document.cookie = c;
	};
	
	pub.get_generic = function(name, element, suppress_logging) {
		name = name.toLowerCase();
		var info_holder;
		if (element && element instanceof jQuery && !element.length) {
			element = null;
		}
		if (!element) {
			info_holder = jQuery('[data-' + name + ']');
			if (info_holder.length > 1) {
				info_holder = info_holder.first();
			}
		} else {
			info_holder = jQuery(element);
			while (!info_holder.data(name)) {
				info_holder = info_holder.parent();
				if (info_holder.is('html')) {
					if (!info_holder.data(name)) {
						info_holder = null;
					}
					break;
				}
			}
		}
		
		if (info_holder && info_holder.length) {
			return info_holder.data(name);
		}
		if (!suppress_logging) {
			yalwa.basics.sentry.submit_error(new Error('tried to retrieve property "' + name + '" without success'));
		}
		return null;
	};
	
	pub.get_msgID = function(element, suppress_logging) {
		return pub.get_generic('msgid', element, suppress_logging);
	};
	
	pub.is_mobile_site = function() {
		return yalwa.v.is_mobile;
	};
	
	/**
	 * @desc executes the given function (fn) at the given threshold interval, useful for scrolling and resize events
	 * @param fn
	 * @param threshold
	 * @param scope
	 * @returns {(function(): void)|*}
	 */
	pub.throttle = function(fn, threshold, scope) {
		threshold || (threshold = 250);
		var last,
			deferTimer;
		return function() {
			var context = scope || this;
			
			var now = +new Date(),
				args = arguments;
			if (last && now < last + threshold) {
				// hold on to it
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function() {
					last = now;
					fn.apply(context, args);
				}, threshold);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	};
	
	/**
	 * @desc executes the callback function after the cooldown period (timeout)
	 * for continuously occurring events such as user type in search field after user has stopped
	 * typing and wait for cooldown period (timeout) then fire the AJAX call
	 * @param callback
	 * @param timeout
	 */
	pub.debounce = function(callback, timeout) {
		timeout = timeout || 200;
		return function() {
			var scope = this;
			var args = arguments;
			if (debounce_refs.has(callback)) {
				clearTimeout(debounce_refs.get(callback));
			}
			debounce_refs.set(callback, setTimeout(function() {
				debounce_refs.delete(callback);
				callback.apply(scope, Array.prototype.slice.call(args));
			}, timeout));
		}();
	};
	
	pub.once = function(fn, context) {
		var result;
		return function() {
			if (fn) {
				result = fn.apply(context || this, arguments);
				fn = null;
			}
			return result;
		};
	};
	
	pub.get_altered_url = function(params) {
		var get_string = document.location.search.slice(1);
		var changed_params = Object.assign({}, params);
		var p_final = {};
		if (get_string !== '') {
			var get_array = get_string.split('&');
			var get_name;
			var get_value;
			for (var i in get_array) {
				if (get_array.hasOwnProperty(i)) {
					var tmp = get_array[i].split('=');
					get_name = tmp[0];
					get_value = tmp[1];
					if (!get_name) {
						continue;
					}
					if (get_name in changed_params) {
						if (changed_params[get_name] !== null && changed_params[get_name] !== undefined) {
							p_final[get_name] = changed_params[get_name]; // overwrite
						}
						delete changed_params[get_name];
					} else {
						p_final[get_name] = get_value; // unchanged
					}
				}
			}
		}

		for (var name_tmp1 in changed_params) {
			if (changed_params[name_tmp1] !== null && changed_params[name_tmp1] !== undefined) {
				p_final[name_tmp1] = changed_params[name_tmp1]; // add
			}
		}

		const p_final_array = [];
		for (var name_tmp2 in p_final) {
			if (typeof p_final[name_tmp2] === 'string') {
				p_final[name_tmp2] = p_final[name_tmp2].replace('&', '%26');
			}
			p_final_array.push(name_tmp2 + '=' + p_final[name_tmp2]); // maybe safer to use encodeURIComponent?
		}

		var new_url = document.location.protocol + '//' + document.location.host + document.location.pathname;
		if (p_final_array.length) {
			new_url += '?' + p_final_array.join('&');
		}
		return new_url;
	};
	
	pub.get_isset = function(name) {
		var url = new URL(window.location.href);
		return url.searchParams && url.searchParams.get(name) !== null;
	};
	
	pub.get_get = function(name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		let results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};
	
	pub.set_get = function(params, remember, reload, state) {
		remember = remember || false;
		reload = reload || false;
		var new_url = pub.get_altered_url(params);
		if (remember) {
			if (reload || !window.history.pushState) {
				yalwa.basics.navigate(new_url);
			} else {
				window.history.pushState(state, null, new_url);
			}
		} else if (window.history.replaceState) {
			window.history.replaceState(yalwa.admin ? (state || history.state) : state, null, new_url);
		}
	};
	
	pub.ss_set = function(key, value, expire) {
		expire = expire || false;
		return s_set(key, value, 'sessionStorage', expire);
	};
	pub.ls_set = function(key, value, expire) {
		expire = expire || false;
		return s_set(key, value, 'localStorage', expire);
	};
	pub.ss_remove = function(key) {
		return s_remove(key, 'sessionStorage');
	};
	pub.ls_remove = function(key) {
		return s_remove(key, 'localStorage');
	};
	pub.ss_get = function(key, is_object) {
		return s_get(key, is_object, 'sessionStorage');
	};
	pub.ls_get = function(key, is_object) {
		return s_get(key, is_object, 'localStorage');
	};
	
	function ls_flush() {
		if (arguments.length > 0) {
			yalwa.basics.sentry.submit_error(new Error('potential incorrect usage of ls_flush'));
			return;
		}
		const keep = [];
		jQuery([
			['forbid_app_rating', false],
			['uac', true],
			['uac_u', false],
			['interested', true],
			['dismissed_app_download', false],
			['uac_reset', false],
			['regs', true],
			['seen_swipe_hint', false],
			['send_on_enter', false],
			['last_areaID', false],
			['seen_with_dol_account', false],
			['dol_login_helper_seen_times', false],
			['dol_login_helper_DNS', false],
			['dol_app_promo_viewed_times', false],
			['dol_app_promo_do_not_show', false],
			['dol_reaction_count', false],
			['seen_swipe_guide', false],
			['followup_session', false],
		]).each(function(i, config) {
			keep.push([config[0], pub.ls_get(config[0], config[1])]);
		});
		if (window.localStorage && window.localStorage.clear) {
			localStorage.clear();
			sessionStorage.clear();
		}
		for (let i = 0; i < keep.length; i++) {
			pub.ls_set(keep[i][0], keep[i][1]);
		}
	}
	
	function s_set(key, value, type, expire) {
		if (!navigator.cookieEnabled) {
			return;
		}
		try {
			window[type].setItem(key, typeof (value) === 'object' ? JSON.stringify(value) : value);
			if (expire) {
				window[type].setItem(key + expiration_suffix, expire);
			}
			return true;
		} catch (e) {
			// QuotaExceededError
			//   chrome/safari      firefox
			if (e.code === 22 || e.code === 1014) {
				try {
					window[type].clear();
				} finally {
					try {
						window[type].setItem(key, typeof (value) === 'object' ? JSON.stringify(value) : value);
						if (expire) {
							window[type].setItem(key + expiration_suffix, expire);
						}
						return true;
					} catch (e) {
						if (location.port) {
							console.log(e.message);
						}
					}
				}
			}
			if (location.port) {
				console.log(e.message);
			}
		}
	}
	
	function s_remove(key, type) {
		try {
			window[type].removeItem(key);
			window[type].removeItem(key + expiration_suffix);
			return true;
		} catch (e) {
			return false;
		}
	}
	
	function s_get(key, is_object, type) {
		try {
			if (window[type].getItem(key + expiration_suffix)) {
				var expiration_ts = parseInt(window[type].getItem(key + expiration_suffix));
				if (expiration_ts < pub.unix()) {
					s_remove(key, type);
					return null;
				}
			}
			
			var value = window[type].getItem(key);
			if (value === 'true') {
				return true;
			} else if (value === 'false') {
				return false;
			} else if (value === 'null') {
				return null;
			}
			if (is_object) {
				value = JSON.parse(value);
			}
			return value;
		} catch (e) {
			return null;
		}
	}
	
	pub.toast = function(config) {
		if (typeof (config) !== 'object') {
			yalwa.basics.sentry.submit_error(new Error('wrong toastr usage'));
		}
		provide_toastr()
			.done(do_toast.bind(undefined, config));
	};
	
	pub.toast_success = function(message) {
		pub.toast({
			message: message,
			type: 'success',
			progressBar: true,
			positionClass: "toast-top-full-width",
			timeOut: 5000,
			"closeButton": true,
		});
	};
	
	pub.label_clear_cache = function() {
		try {
			Object.keys(localStorage).forEach(function(key) {
				if (/lang_/.test(key)) {
					localStorage.removeItem(key);
				}
			});
			return true;
		} catch (e) {
			return false;
		}
	};
	
	pub.label_cache = function(label, file) {
		return pub.ls_get(ls_lang_key(label, file || 'main'));
	};
	
	pub.labels = function(labels_wanted) {
		check_svn_revision();
		var deferred;
		var values = {};
		var requests = [];
		for (var i = 0; i < labels_wanted.length; i++) {
			var label_key = labels_wanted[i].label;
			var file = labels_wanted[i].file || 'main';
			
			var ls_value = pub.ls_get(ls_lang_key(label_key, file));
			if (ls_value === null) {
				requests.push({
					label: label_key,
					file: file
				});
			} else {
				values[label_key] = ls_value;
			}
		}
		if (requests.length) {
			deferred = request_labels(requests, false, values);
		} else {
			deferred = jQuery.Deferred();
			deferred.resolve(values);
		}
		
		return deferred.promise();
	};
	
	pub.label = function(label_key, file) {
		check_svn_revision();
		file = file || 'main';
		var deferred;
		var ls_value;
		if (yalwa.v.lang && yalwa.v.lang[label_key]) {
			ls_value = yalwa.v.lang[label_key];
		} else {
			ls_value = pub.ls_get(ls_lang_key(label_key, file));
		}
		if (ls_value === null) {
			deferred = request_labels([{label: label_key, file: file}], true);
		} else {
			deferred = jQuery.Deferred();
			deferred.resolve(ls_value);
		}
		return deferred.promise();
	};
	
	// only used by cordova, webpush are tracked in sw.js
	pub.track_pn_received = function(typeID, device_typeID, variationID, cordova_deviceID) {
		track('received', typeID, device_typeID, variationID, cordova_deviceID);
	};
	
	// only used by cordova, webpush are tracked in sw.js
	pub.track_pn_clicked = function(typeID, device_typeID, variationID, cordova_deviceID) {
		track('clicked', typeID, device_typeID, variationID, cordova_deviceID);
	};
	
	function track(action, typeID, device_typeID, variationID, cordova_deviceID) {
		if (yalwa.basics.tracking_quota_add_and_check()) {
			return;
		}
		const url = '/api/ajax/pn_tracker/';
		const data = {
			action: action,
			typeID: typeID,
			device_typeID: device_typeID
		};
		if (variationID) {
			data.variationID = variationID;
		}
		if (cordova_deviceID) {
			data.cordova_deviceID = cordova_deviceID;
		}
		yalwa.basics.beacon(url, data);
	}
	
	pub.upload_type_regex = function(allow_pdf = false) {
		return allow_pdf ? (/((\.|\/)(gif|jpe?g|png|pdf)|data:image\/jpeg;base64,)$/i) : (/((\.|\/)(gif|jpe?g|png)|data:image\/jpeg;base64,)$/i);
	};
	
	pub.show_this = function() {
		return pub.show(jQuery(this));
	};
	
	pub.hide_this = function() {
		return pub.hide(jQuery(this));
	};
	
	pub.toggle_this = function() {
		return pub.toggle(jQuery(this));
	};
	
	pub.show = function($element) {
		if ($element && $element.length) {
			return $element.removeClass('hidden');
		}
	};
	
	pub.hide = function($element) {
		if ($element && $element.length) {
			return $element.addClass('hidden');
		}
	};
	
	pub.toggle = function($element, bool) {
		if (bool === undefined) {
			if ($element.hasClass('hidden')) {
				return pub.show($element);
			} else {
				return pub.hide($element);
			}
		} else {
			if (bool) {
				return pub.show($element);
			} else {
				return pub.hide($element);
			}
		}
	};
	
	pub.readonly_check = function() {
		if (yalwa.v.is_read_only_mode) {
			yalwa.basics.label('Server_maintenance_general').done((label_message) => {
				yalwa.basics.toast({
					message: label_message.replace(/<\/?[^>]+(>|$)/g, ""),
					type: 'warning',
					progressBar: true,
				});
			});
			return false;
		} else {
			return true;
		}
	}
	
	pub.init_follow_user = function() {
		if (yalwa.v.show_follow_toaster) {
			yalwa.basics.toast({message: yalwa.v.lang.info_following_now, type: 'success'});
		}
		jQuery('.js-follow-user-btn').off('click').on('click', function() {
			if (!yalwa.basics.readonly_check()) {
				return false;
			}
			var $btn = jQuery(this);
			$btn.prop('disabled', true);
			
			var action;
			if ($btn.hasClass('btn_active')) {
				action = 'unfollow';
			} else {
				action = 'follow';
			}
			pub.update_follow_user(action, $btn.data('userid'), 'cta');
		});

		if (window.location.hash === '#follow') {
			jQuery('.js-follow-user-btn.btn_inactive').first().click();
		}
		if (yalwa.v.userID_viewed) {
			jQuery(window).on('pageshow', event => {
				if (pub.is_back_forward_navigation(event.originalEvent)) {
					let tmp = html_cache_invalidator_get();
					if (tmp[yalwa.v.userID_viewed]) {
						delete tmp[yalwa.v.userID_viewed];
						html_cache_invalidator_set(tmp);
						yalwa.basics.reload();
					}
				}
			});
		}
	};
	
	function html_cache_invalidator_get() {
		return yalwa.basics.ss_get('html_cache_invalidator', true) || {};
	}
	
	function html_cache_invalidator_set(val) {
		yalwa.basics.ss_set('html_cache_invalidator', val);
	}
	
	function update_vap_follow_counter(action) {
		let $vap_counter = jQuery('.js-vap_follower_count');
		if ($vap_counter.length === 1) {
			let vap_count_current_val = parseInt($vap_counter.text());
			$vap_counter.text(action === 'follow' ? vap_count_current_val + 1 : vap_count_current_val - 1);
		}
	}

	pub.update_follow_user = function(action, userID, context = '') {
		const $btn = jQuery('.js-follow-user-btn');
		return jQuery.post(
			'/api/ajax/follow_user',
			{
				action: action,
				userID: userID,
                msgID: (yalwa.basics.get_routing() === 'vap') ? yalwa.v.posting_id : null
			},
			function(data) {
				let tmp = html_cache_invalidator_get();
				tmp[userID] = true;
				html_cache_invalidator_set(tmp);
				$btn.prop('disabled', false);
				jQuery('.info_follow,.js-info_follow').hide();
				if (data.success) {
					update_vap_follow_counter(action);
					if (data.type === 'btn_active') {
                        if (context !== 'contact' && !data.nudge) {
                            yalwa.basics.toast({message: yalwa.v.lang.info_following_now, type: 'success'});
                        }
                        if (data.nudge && data.nudge_plp && context === 'cta') {
                            jQuery('.js-plp_container')
								.append(data.nudge_plp)
								.addClass('plp_container--center');
                            yalwa.mobile.check_for_detach();
                            let $nudge_plp = jQuery('.js-plp_nudge_follow');
                            $nudge_plp.trigger('plp_show');
                            yalwa.mobile.init_nudge();
                        }
					} else {
						yalwa.basics.toast({message: yalwa.v.lang.info_not_following, type: 'success'});
					}
					if (data.type === 'btn_active') {
						jQuery('.hide_button_after_click').hide();
						$btn.html(data.message);
					} else {
						jQuery('.hide_button_after_click').hide();
						var icon = yalwa.basics.yimage(1178, {'pixel': 10});
						$btn.html(data.message + icon);
					}
					$btn.removeClass('btn_active').removeClass('btn_inactive').addClass(data.type);
				} else {
					// something went wrong
					jQuery('.hide_button_after_click').hide();
					$btn.html(data.message);
				}
			},
			'json'
		);
	};
	
	pub.contact_follow_trigger = function() {
		if (jQuery('.js-contact_follow').is(':checked')) {
			yalwa.basics.update_follow_user(jQuery('.js-contact_follow').is(':checked') ? 'follow' : 'unfollow', jQuery('.js-follow-user-btn').data('userid'), 'contact');
		}
	};
	
	pub.get_cart_not_empty_favicon = function() {
		return yalwa.basics.static_url('images') + 'bg/icons/favicons/favicon_red_dot.svg';
	};
	
	pub.avs_find_criteria_type = function(config) {
		const defaults = {
			data: null,
			value: null,
			no_rolloff: false,
			skip_very_bad_merging: false,
			skip_neutral_merging: false
		};
		
		// Merge defaults with config
		config = {...defaults, ...config};
		
		let sorted_keys = Object.keys(config.data).sort((a, b) => a - b);
		let matching_key = null;
		let percentage_missing = null;
		let final_start_value = null;
		
		for (let i = 0; i < sorted_keys.length; i++) {
			let key = sorted_keys[i];
			let inner_array = config.data[key];
			let all_conditions_met = true;
			let start_value = Infinity;
			let has_ge_comparator = false;
			
			for (let j = 0; j < inner_array.length; j++) {
				let criteria = inner_array[j];
				
				switch (criteria.comparator) {
					case '<=':
						if (!(config.value <= parseFloat(criteria.base_value))) {
							all_conditions_met = false;
						}
						break;
					case '==':
						if (!(config.value == parseFloat(criteria.base_value))) {
							all_conditions_met = false;
						}
						break;
					case '>=':
						if (!(config.value >= parseFloat(criteria.base_value))) {
							all_conditions_met = false;
						}
						start_value = Math.min(start_value, parseFloat(criteria.base_value));
						has_ge_comparator = true;
						break;
				}
			}
			
			if (!has_ge_comparator) {
				start_value = 0;
			}
			
			if (all_conditions_met) {
				matching_key = key;
				final_start_value = start_value;
				if (i < sorted_keys.length - 1) { // if not last key
					let next_key = sorted_keys[i + 1];
					let next_inner_array = config.data[next_key];
					let closest_value = Infinity;
					for (let k = 0; k < next_inner_array.length; k++) {
						let next_criteria = next_inner_array[k];
						if (next_criteria.comparator === '>=' || next_criteria.comparator === '==') {
							closest_value = Math.min(closest_value, parseFloat(next_criteria.base_value));
						}
					}
					if (closest_value !== Infinity) {
						let diff = closest_value - config.value;
						percentage_missing = Math.abs((diff / (closest_value - start_value)) * 100);
					}
				}
				break;
			}
		}
		
		if (!percentage_missing) {
			if (config.no_rolloff) {
				percentage_missing = 0;
			} else {
				percentage_missing = 100 - (config.value - final_start_value) * 5;
				if (percentage_missing < 0) {
					percentage_missing = 0;
				}
			}
		}
		return avs_get_category_mapping(config, matching_key, percentage_missing);
	}
	
	function avs_get_category_mapping(config, matching_key, percentage_missing) {
		if (yalwa.v.avs_L1 === 'P') {
			switch (matching_key) {
				case '-2':
					percentage_missing += 100;
					percentage_missing /= 2;
					matching_key = '1';
					break;
				case '-1':
					if (!config.skip_very_bad_merging) {
						percentage_missing /= 2;
					}
					matching_key = '1';
					break;
				case '0':
					percentage_missing += 100;
					percentage_missing /= 2;
					matching_key = '2';
					break;
				case '1':
					percentage_missing /= 2;
					matching_key = '2';
					break;
				case '2':
					percentage_missing += 0;
					matching_key = '4';
					break;
			}
		} else {
			switch (matching_key) {
				case '-2':
					matching_key = '1';
					break;
				case '-1':
					percentage_missing += 100;
					percentage_missing /= 2;
					matching_key = '2';
					break;
				case '0':
					if (!config.skip_neutral_merging) {
						percentage_missing /= 2;
					}
					matching_key = '2';
					break;
				case '1':
					matching_key = '4';
					break;
				case '2':
					matching_key = '5';
					break;
			}
		}
		
		percentage_missing = percentage_missing.toFixed(2);
		return [matching_key, percentage_missing];
	}
	
	pub.static_url = function(type) {
		const static_url = yalwa.v.static_url;
		if (static_url) {
			switch (type) {
				case 'images':
					return static_url + '/images/';
				case 'svg':
					return static_url + '/images/bg/svg/';
				case 'js':
					return static_url + '/js/';
				case 'css':
					return static_url + '/styles/';
				case 'fonts':
					return static_url.replace(/\/[0-9]+_[0-9]+$/, '/1_1') + '/styles/fonts/'; // DEV-7613
				default:
					yalwa.basics.sentry.submit_error(new Error(`invalid type ${type} given for static url`));
			}
		}
		yalwa.basics.sentry.submit_error(new Error(`invalid static_url value: ${static_url} => ${type}`));
	};
	
	pub.import_js = async function(path) {
		const url = await resolve_asset_url(yalwa.basics.static_url('js') + path);
		return import(url);
	};
	
	pub.js_post_ad_click = function(event) {
		event.preventDefault();
		event.stopPropagation();
		const $target = jQuery(this);
		let label = $target.data('position');
		if (yalwa.mobile && yalwa.mobile.page_will_unload) {
			yalwa.mobile.page_will_unload();
		}
		if (label === 'between results' || label === 'below results' || label === 'paf_widget_browse') {
			yalwa.basics.ls_set('mpaf_reset_on_start', true);
		}
		
		let url = $target.attr('href');
		if (!url) {
			url = jQuery(event.target).closest('[href]').prop('href');
		}
		if (url.search('post') === -1) {
			yalwa.basics.sentry.submit_error(new Error('bad link to PAF'));
		}
		
		if (label === 'below results') {
			
			if ($target.data('language')) {
				label += (' ' + $target.data('language'));
			}
			
			if ($target.data('category')) {
				label += ('_' + $target.data('category'));
			}
			
			if ($target.data('version')) {
				label += ('_' + $target.data('version'));
			}
		}
		
		yalwa.v.post_ad_clicked = false;
		
		let pagetype = $target.data('pagetype');
		if (typeof pagetype === 'undefined') {
			pagetype = '(undefined)';
		}
		
		yalwa.basics.ga.event({
			category: 'post ad click mobile',
			action: pagetype,
			label: label
		});
		
		if (window && window.location && !yalwa.v.post_ad_clicked) { // (found in JS ERROR LOGS)
			yalwa.v.post_ad_clicked = true;
			if (!yalwa.basics.is_logged_in()) {
				pub.auth.module.show_dialog(event);
			} else {
				yalwa.basics.navigate(url);
			}
		}
		
		return false;
	};
	
	function progress_load() {
		var deferred = jQuery.Deferred();
		if (progress_is_loaded()) {
			deferred.resolve();
		} else {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/nprogress.js', function() {
				deferred.resolve();
			});
		}
		return deferred.promise();
	}
	
	function progress_is_loaded() {
		return typeof (window.NProgress) !== 'undefined';
	}
	
	function progress_start(name, settings) {
		name = name || 'single';
		progress_load().done(function() {
			settings = settings || {};
			yalwa.v.progress = yalwa.v.progress || {};
			if (yalwa.v.progress[name]) {
				progress_stop(name);
			}
			if (window.NProgress) {
				yalwa.v.progress[name] = new window.NProgress();
				yalwa.v.progress[name].configure(settings);
				
				yalwa.v.progress[name].start();
			}
		});
	}
	
	function progress_is_started(name) {
		return yalwa.v.progress && yalwa.v.progress[name];
	}
	
	function progress_set(name, value) {
		name = name || 'single';
		if (yalwa.v.progress && yalwa.v.progress[name]) {
			yalwa.v.progress[name].set(value);
		}
	}
	
	function progress_stop_error(name) {
		name = name || 'single';
		if (yalwa.v.progress[name]) {
			yalwa.v.progress[name].error();
		}
		progress_stop(name);
	}
	
	function progress_stop(name) { // beware: used via cordova
		name = name || 'single';
		progress_load().done(function() {
			if (yalwa.v.progress && typeof (yalwa.v.progress[name]) !== 'undefined') {
				progress_load().done(function() {
					yalwa.v.progress[name].done();
					delete yalwa.v.progress[name];
				});
			}
		});
	}
	
	function provide_toastr() {
		var deferred = jQuery.Deferred();
		if (toastr_loaded()) {
			deferred.resolve();
		} else {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/toastr.min.js', function() {
				if (toastr_loaded()) {
					deferred.resolve();
				} else {
					deferred.reject();
				}
			});
		}
		return deferred.promise();
	}
	
	function toastr_loaded() {
		return typeof (window.toastr) !== 'undefined';
	}
	
	function do_toast(config) {
		config.showDuration = config.showDuration || 0;
		config.hideDuration = config.hideDuration || 250;
		config.customClass = config.customClass || '';
		config.positionClass = 'locanto_toast ' + (config.positionClass || 'toast-top-full-width');
		config.show_icon = config.show_icon && config.show_icon === 'no' ? false : true;
		if (!toastr_loaded()) {
			if (location.port) {
				yalwa.basics.sentry.submit_error(new Error('unable to load toastr'));
			}
		} else {
			if (typeof (window.toastr[config.type]) === 'function') {
				if (config.maxCount) {
					if (window.toastr.count === undefined) {
						window.toastr.count = 1;
					}
					window.toastr.subscribe(function(arg) {
						if (arg.state === 'visible') {
							window.toastr.count++;
						} else {
							window.toastr.count--;
						}
					});
					var maxCount = config.maxCount;
					if (window.toastr.count > maxCount) {
						return false;
					}
				}
				var $toast = window.toastr[config.type].call(undefined, config.message || '', config.title || '', config);
				var icon_names = {
					'error': 'warning-sign',
					'info': 'info-icon',
					'success': 'checkmark--white',
					'warning': 'warning-sign',
				};
				let icon_folder = 'main';
				if ($toast && config.show_icon) {
					$toast.prepend('<div class="toast-yicon_wrapper">' + yalwa.basics.yicon(icon_names[config.type], {
						classes: 'toastr__yicon',
						folder: icon_folder
					}) + '</div>');
					jQuery('.toast-close-button').html(yalwa.basics.yicon('close', {'pixel': 12, 'classes': 'hitbox'}));
				}
				
			}
		}
	}
	
	function ls_lang_key(label_key, file) {
		return 'lang_' + file + '_' + label_key;
	}
	
	pub.label_set = function(label, file, value) {
		pub.ls_set(ls_lang_key(label, file), value);
	};
	
	function request_labels(labels, single_mode, values) {
		return jQuery.ajax({
			url: '/api/ajax/general/',
			data: {
				action: 'request_labels',
				labels: labels,
				single_mode: single_mode ? 1 : 0
			},
			dataType: single_mode ? 'text' : 'json'
		}).then(function(response) {
			if (single_mode) {
				if (response) {
					pub.label_set(labels[0].label, labels[0].file, response);
					return response;
				} else {
					yalwa.basics.sentry.submit_error(new Error('tried to request invalid language key "' + labels[0].key + '" in file "' + labels[0].file + '"'));
				}
			} else {
				values = values || {};
				for (var label_tmp in response) {
					if (response.hasOwnProperty(label_tmp)) {
						if (response[label_tmp].value) {
							pub.label_set(label_tmp, response[label_tmp].file, response[label_tmp].value);
						}
						values[label_tmp] = response[label_tmp].value;
					}
				}
				return values;
			}
		});
	}
	
	pub.get_svn_revision = function() {
		if (yalwa.v.fingerprint) {
			return yalwa.v.fingerprint || '';
		}
		yalwa.basics.sentry.submit_error(new Error('invalid fingerprint value in get_svn_revision: locanto'));
	};
	
	function check_svn_revision() {
		const svn_revision_cache = pub.ls_get('svn_revision');
		const svn_revision = yalwa.basics.get_svn_revision();
		if (svn_revision_cache && svn_revision_cache !== svn_revision) {
			pub.label_clear_cache();
			pub.ls_set('svn_revision', svn_revision);
		}
	}
	
	pub.progress = {
		load: progress_load,
		start: progress_start,
		stop: progress_stop, // beware: used via cordova
		set: progress_set,
		error: progress_stop_error,
		is_started: progress_is_started
	};
	
	pub.autolabel_check = autolabel_check;
	pub.autolabel_init = autolabel_init;
	
	pub.check_sp_params = function() {
		if (typeof yalwa.v.sp_params != 'undefined') {
			if (yalwa.v.sp_params) {
				pub.set_cookie('loc_sp_params', yalwa.v.sp_params, 0);
			} else {
				pub.set_cookie('loc_sp_params', 0, -1);
			}
		}
	};
	
	pub.language = function() {
		if (yalwa.v.language) {
			return yalwa.v.language;
		}
		return jQuery('html').data('language');
	};
	
	let dayjs_deferred_promise;
	let dayjs;
	pub.load_dayjs = function() {
		if (!dayjs_deferred_promise) {
			const dayjs_deferred = jQuery.Deferred();
			/*
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'shared/modules/day_oldbrowsers.js').then(() => {
				Dayjs.load().done(() => {
					dayjs = Dayjs;
					dayjs_deferred.resolve(Dayjs);
				});
			});
			*/
			yalwa.basics.import_js('shared/modules/day.js').then((Module) => {
				Module.Dayjs.load().done(() => {
					dayjs = Module.Dayjs;
					dayjs_deferred.resolve(Module.Dayjs);
				});
			});
			
			dayjs_deferred_promise = dayjs_deferred.promise();
		}
		return dayjs_deferred_promise;
	};
	
	pub.dayjs = () => {
		return dayjs;
	};
	
	pub.localize_user_online_ts = function() {
		const $elements = jQuery('.js-last_online').not('.js-last_online_checked');
		if ($elements.length) {
			pub.load_dayjs().done(() => {
				$elements.each((i, e) => {
					const $e = jQuery(e);
					$e.addClass('js-last_online_checked');
					const lo = $e.data('last_online');
					// never render a future date (DEV-18029 QA report): a skewed last_online_ts
					// would otherwise show "Tomorrow at ..." via the dayjs calendar
					if (lo && lo * 1000 <= Date.now() + 60000) {
						$e.parent().find('.js-last_online_label').text(yalwa.basics.dayjs().calendar(lo));
					}
				});
			});
		}
	};
	
	pub.chrome_version = function() { // http://stackoverflow.com/a/4900484/333864
		var raw = navigator.userAgent.match(/(Chrom(e|ium)|CriOS)\/([0-9]+)\./);
		return raw ? parseInt(raw[3], 10) : false;
	};
	
	// careful - this method is used in external/fileupload.js ...
	pub.safari_version = function() {
		let result = false;
		let raw = navigator.userAgent.match(/Version\/([0-9]+).*Safari/) ||
			navigator.userAgent.match(/Safari\/([0-9]+)/) ||
			navigator.userAgent.match(/AppleWebKit\/([0-9]+).*YalwApp/);
		result = raw ? parseInt(raw[1], 10) : false;
		return result;
	};
	
	pub.is_safari = function() {
		const userAgent = navigator.userAgent.toLowerCase();
		// Safari's user agent string contains 'safari' and not 'chrome' or 'chromium' since Chrome/Chromium also include 'safari' in their user agent strings
		const is_safari_browser = userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('chromium');
		// Additionally check for 'crios' (Chrome for iOS) and 'fxios' (Firefox for iOS) since they use the Safari rendering engine on iOS but are not Safari
		const is_ios_browser = userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');
		const is_safari_on_ios = is_ios_browser && !userAgent.includes('crios') && !userAgent.includes('fxios');
		return is_safari_browser || is_safari_on_ios;
	};
	
	pub.clone_absolute = function($to_clone) {
		const $clone = $to_clone.clone();
		jQuery('body').append($clone);
		const left = $to_clone.offset().left;
		$clone.css({top: $to_clone.offset().top, left: left, position: 'absolute', 'zIndex': 10});
		return $clone;
	};
	
	pub.yimage = function(name, o) {
		let default_settings = {
			pixel: 16,
			folder: 'main',
			site: 'bg/icons/svg/mobile',
			data: {},
			title: '',
			alt: ''
		};
		if (typeof name === 'number') {
			default_settings = {
				pixel: 16,
				folder: String(name % 100).padStart(2, '0'), // last two digits
				site: 'yimage',
				data: {},
				title: '',
				alt: ''
			};
		}
		o = o || {};
		if (!name) {
			yalwa.basics.sentry.submit_error_with_options(new Error('yimage call without name'), {extra: {object: o}});
			return '';
		}
		o.classes = o.classes ? `yimage yicon ${o.classes}` : 'yimage yicon';
		o = jQuery.extend(default_settings, o);
		
		let data_string = '';
		const data_keys = Object.keys(o.data);
		if (data_keys.length) {
			data_keys.map(data_key => {
				data_string += ` data-${data_key}="${o.data[data_key]}"`;
			})
		}
		let title_string = '';
		if (o.title) {
			title_string = ' title="' + o.title + '"';
		}
		let alt_string = '';
		if (o.alt) {
			alt_string = ' alt="' + o.alt + '"';
		}
		return `<img src="${yalwa.v.static_url}/images/${o.site}/${o.folder}/${name}.svg" class="${o.classes}" width="${o.pixel}" height="${o.pixel}"${data_string}${title_string}${alt_string}>`;
	};
	
	pub.yimage_toggle = function($element, icon_primary, icon_alternate) {
		const src = $element.attr('src');
		const new_icon = src.includes(icon_primary) ? icon_alternate : icon_primary;
		pub.yimage_change(new_icon, $element);
	}
	
	pub.yicon_toggle = function($element, first_icon_name, second_icon_name) {
		if (yalwa.v.yimage_active) {
			pub.yimage_toggle($element, first_icon_name, second_icon_name);
			return;
		}
		const class_name = yicon_sprite_get($element);
		const replaced_name = class_name.includes(first_icon_name) ? first_icon_name : second_icon_name;
		const with_name = class_name.includes(first_icon_name) ? second_icon_name : first_icon_name;
		const new_class_name = class_name.replace(replaced_name, with_name);
		$element.toggleClass(`${class_name} ${new_class_name}`);
	}
	
	pub.yicon_change = function(new_name, $element) {
		if (yalwa.v.yimage_active) {
			pub.yimage_change(new_name, $element);
			return;
		}
		const existing_class = yicon_sprite_get($element);
		const sprite_part = extract_sprites_mobile_part(existing_class);
		$element.removeClass(existing_class).addClass(`${sprite_part}${new_name}`);
	}
	
	pub.yicon_get_id = function($element) {
		if (yalwa.v.yimage_active) {
			return yimage_name_get($element);
		}
		const existing_class = yicon_sprite_get($element);
		const sprite_part = extract_sprites_mobile_part(existing_class);
		return existing_class.replace(sprite_part, '');
	}
	
	function extract_sprites_mobile_part(input_string) {
		const regex = /^(sprites_mobile_.*?__)/;
		if (!input_string) {
			return null;
		}
		const match = input_string.match(regex);
		return match && match[1] ? match[1] : null;
	}
	
	pub.yicon_modifier = function($element, modifier, action) {
		if (yalwa.v.yimage_active) {
			pub.yimage_modifier_fallback($element, modifier, action);
			return;
		}
		let c = yicon_modifier_get($element);
		if (c) {
			modifier_helper(c + '--' + modifier, $element, action);
		}
	};
	
	function yicon_sprite_get($element) {
		var bem_class;
		let cl = $element.attr('class');
		if (cl) {
			jQuery.each(cl.split(' '), (i, name) => {
				if (name.startsWith('sprites_') && !bem_class && name.indexOf('js-') !== 0 && name.indexOf('__') !== -1) {
					bem_class = name;
				}
			});
		}
		return bem_class ? bem_class : null;
	}
	
	function yicon_modifier_get($element) {
		var bem_class;
		let cl = $element.attr('class');
		if (cl) {
			jQuery.each(cl.split(' '), (i, name) => {
				if (!bem_class && name.indexOf('js-') !== 0 && name.indexOf('__') !== -1) {
					bem_class = name;
				}
			});
		}
		return bem_class ? bem_class.replace(/--.*/, '') : null;
	}
	
	const yimage_name_pattern = /\/([^\/]+)\.svg$/;
	
	pub.yimage_modifier_fallback = function($element, modifier, action) {
		if (!$element.length) {
			return;
		}
		const name = yimage_name_get($element);
		const [name_root, existing_modifier] = name.split('--');
		let name_final;
		switch (action) {
			case 'add':
				name_final = name_root + '--' + modifier;
				break;
			case 'remove':
				name_final = name_root;
				if (existing_modifier === modifier) {
					name_final = name_root;
				} else {
					name_final = name;
				}
				break;
			default:
				if (existing_modifier === modifier) {
					name_final = name_root;
				} else {
					name_final = name_root + '--' + modifier;
				}
				break;
		}
		pub.yimage_change(name_final, $element);
	};
	
	pub.yimage_change = function(name, $element) {
		if (!$element.length) {
			return;
		}
		const src = $element.attr('src');
		if (!src) {
			return;
		}
		const new_src = src.replace(yimage_name_pattern, `/${name}.svg`);
		if (new_src !== src) {
			$element.attr('src', new_src);
		}
	}
	
	function yimage_name_get($element) {
		const src = $element.attr('src');
		const match = src.match(yimage_name_pattern);
		if (match) {
			return match[1];
		} else {
			return null;
		}
	}
	
	pub.yicon = function(name, o) {
		if (yalwa.v.yimage_active) {
			return yalwa.basics.yimage(name, o);
		}
		o = jQuery.extend({
			pixel: 16,
			folder: 'main',
			classes: '',
			site: 'mobile'
		}, o);
		var data_string = '';
		if (o.data) {
			var data = [];
			for (var i in o.data) {
				data.push('data-' + i + '="' + o.data[i] + '"');
			}
			data_string += ' ' + data.join(' ');
		}
		var title_string = '';
		if (o.title) {
			title_string = ' title="' + o.title + '"';
		}
		return '<div style="width:' + o.pixel + 'px;height:' + o.pixel + 'px;" class="yicon sprites_' + o.site + '_' + o.folder + '__' + name + ' ' + o.classes + '"' + data_string + title_string + '></div>';
	};
	
	pub.yif = function(name, o) {
		var font_class = 'yif';
		o = jQuery.extend({
			pixel: 16,
			name: 'flaticon',
			classes: '',
			suffix: 'mobile'
		}, o);
		var data_string = '';
		if (o.data) {
			var data = [];
			for (var i in o.data) {
				data.push('data-' + i + '="' + o.data[i] + '"');
			}
			data_string += ' ' + data.join(' ');
		}
		return '<i class="' + font_class + (o.pixel ? ' ' + font_class + '_' + o.pixel : '') + ' ' + o.name + '_' + o.suffix + ' ' + o.name + '-' + name + (o.classes ? ' ' + o.classes : '') + '"' + data_string + '></i>';
	};
	
	pub.image_upload_dimensions = function(file) {
		var deferred = jQuery.Deferred();
		if (file && window.URL && window.URL.createObjectURL) {
			var img = new Image();
			img.src = window.URL.createObjectURL(file);
			img.onload = function() {
				var w = img.naturalWidth;
				var h = img.naturalHeight;
				window.URL.revokeObjectURL(img.src);
				deferred.resolve({w: w, h: h});
			};
		} else {
			deferred.reject();
		}
		return deferred.promise();
	};
	
	pub.image_upload_ratio_check = function(file) {
		var deferred = jQuery.Deferred();
		pub.image_upload_dimensions(file).done(function(d) {
			if (d && d.w) {
				var ratio = Math.max(d.w, d.h) / Math.min(d.w, d.h);
				deferred.resolve(ratio > 10);
			} else {
				deferred.reject();
			}
		});
		return deferred.promise();
	};
	
	pub.linkify = function(text) {
		var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;äöü]*[-A-Z0-9+&@#\/%=~_|])/ig;
		return text.replace(urlRegex, linkify_helper);
	};
	
	function linkify_helper(url) {
		return '<a target="_blank" class="js-external_links" href="' + url + '">' + url + '</a>';
	}
	
	pub.normalize = function(text) {
		if (typeof (text.normalize) === 'function') {
			// http://stackoverflow.com/a/37511463
			text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
		}
		return text;
	};
	
	pub.unix = function(date) {
		return Math.floor((date || Date.now()) / 1000);
	};
	
	pub.login_url = function(params) {
		params = params || {};
		params.cid = params.cid || yalwa.v.cid || yalwa.v.countryID;
		params.aid = params.aid || yalwa.v.aid;
		params['continue'] = params['continue'] || encodeURI(location.href);
		var params_array = [];
		jQuery.each(params, function(name, value) {
			if (value !== undefined && value !== null) {
				params_array.push(name + '=' + value);
			}
		});
		return yalwa.v.accounts_url + 'login?' + params_array.join('&');
	};
	
	// careful: can be easily manipulated, don't user for sensitive stuff
	pub.is_logged_in = function() {
		return yalwa.v.is_logged_in;
	};
	
	pub.is_hybrid = function() {
		return yalwa.v.is_hybrid ? true : false;
	}
	
	pub.upload_max_file_size = function() {
		return 20000000; // 20MB
	};
	
	function get_cordova_app_detection_regex() {
		let regex = /(^|[ \t])YalwApp\/[abcdefgh][AYL]\.(\d+)\.(\d+)\.(\d+)(\/\d{1,2})?([ \t]|$)/;
		return regex;
	}
	
	pub.yalwapp_version = function() {
		var matches = navigator.userAgent.match(get_cordova_app_detection_regex());
		if (matches && matches[1] && matches[2] && matches[3]) {
			if (matches[4]) {
				return parseInt(matches[1] + matches[2] + matches[3] + matches[4], 10);
			} else {
				return parseInt(matches[1] + matches[2] + matches[3], 10);
			}
		}
		return 0;
	};
	pub.yalwapp_type = function() {
		const matches = navigator.userAgent.match(/YalwApp\/([abcdefgh])L/);
		return matches ? matches[1] : '';
	}

	function is_iab_message_bridge_active() {
		// Matches the expander's is_iab_message_bridge_active(): app versions whose
		// expander listens on the cordova_iab message bridge instead of the
		// cordova_collect polling loop. The site must not post into a bridge
		// nothing listens on, and must not keep polling when the bridge is live.
		var type = pub.yalwapp_type();
		if (type === 'g') {
			return pub.yalwapp_version() >= 3016;
		}
		if (type === 'h') {
			return pub.yalwapp_version() >= 3022;
		}
		return false;
	}
	
	pub.upload_defaults = function() {
		return {
			dataType: 'json',
			disableImageResize: /Android(?!.*Chrome)|Opera/.test(window.navigator && navigator.userAgent),
			imageMaxWidth: 600,
			imageMaxHeight: 600,
			imageMinWidth: 1,
			imageMinHeight: 1,
			imageOrientation: true,
			imageQuality: .9,
			disableImageMetaDataSave: true,
			acceptFileTypes: yalwa.basics.upload_type_regex(),
			maxFileSize: pub.upload_max_file_size()
		};
	};
	
	pub.cordova_upload_blob = function(b64Data) { // beware: used via cordova version < 2.4.4
		yalwa.mobile.cordova.cordova_upload_blob(b64Data, 'data:image/jpeg;base64,');
	};
	
	function debug_navigation(url) {
		if (!location.port) {
			return false;
		}
		const do_debug = false;
		if (do_debug) {
			console.trace(url);
		}
		return do_debug;
	}
	
	pub.nav_started = function() {
		return nav_started;
	};
	
	pub.reload = function(bypass_cache = false) {
		if (debug_navigation(location.href)) {
			return;
		}
		nav_started = true;
		if (bypass_cache) {
			const url = new URL(window.location.href);
			url.searchParams.set('cache_bypass', Date.now());
			window.location.replace(url.toString());
		} else {
			window.location.reload();
		}
	};
	
	pub.navigate = function(url) {
		if (debug_navigation(url)) {
			return;
		}
		if (!url || url.search('undefined') !== -1) {
			yalwa.basics.sentry.submit_error_with_options(new Error('invalid function call navigate without argument url'), {extra: {url: url}});
			return;
		}
		if (yalwa.mobile) {
			yalwa.mobile.page_will_unload(url);
		}
		nav_started = true;
		if (yalwa.v.promo_interstitial) {
			jQuery(document).trigger('navigate_away', url);
		} else {
			window.location.href = url;
		}
	};
	
	pub.new_tab = function(url) {
		if (debug_navigation(url)) {
			return;
		}
		if (!url || url.search('undefined') !== -1) {
			yalwa.basics.sentry.submit_error_with_options(new Error('invalid function call navigate without argument url'), {extra: {url: url}});
			return;
		}
		if (url[0] === '/') {
			url = location.origin + url;
		}
		if (yalwa.v.is_phonegap) {
			yalwa.basics.opencordovaexternal(url);
		} else if (yalwa.basics.is_pwa()) {
			yalwa.basics.navigate(url);
		} else {
			window.open(url, null, 'noopener');
		}
	};
	
	pub.beacon = function(url, data) {
		return new Promise((resolve, reject) => {
			let result = false;
			if (url.indexOf('api/ajax/track') !== -1) {
				data.pt = yalwa.v.pt;
			}
			if (typeof navigator.sendBeacon === 'function') {
				try {
					let fd = new FormData();
					Object.keys(data).forEach(key => fd.append(key, data[key]));
					result = navigator.sendBeacon(url, fd);
				} catch (err) {
					//console.warn('navigator.sendBeacon failed:', err);
				}
			}
			
			if (result) {
				resolve(result);
			} else {
				jQuery.ajax({url: url, data: data, type: 'post'})
					.done(resolve)
					.fail(reject);
			}
		});
	};
	
	pub.connection = function() {
		const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
		let result = 'unknown';
		if (connection) {
			const connection_type = connection.hasOwnProperty('type') ? 'type' : 'effectiveType';
			result = connection[connection_type];
		}
		return result;
	};
	
	function navigation_type() {
		if (window.performance && window.performance.getEntriesByType && pub.get_navigation_type()) {
			return pub.get_navigation_type();
		}
		
		// https://yalwa.sentry.io/issues/3970088180/events/48178c79ab604a169c75ba5d0fcdce4e/?project=1793688
		// yalwa.basics.sentry.submit_error(new Error('using old performance.navigation api'));
		
		// old/deprecated
		if (window.performance && window.performance.navigation && window.performance.navigation.type !== undefined) {
			switch (window.performance.navigation.type) {
				case window.performance.navigation.TYPE_BACK_FORWARD:
					return 'back_forward';
				case window.performance.navigation.TYPE_NAVIGATE:
					return 'navigate';
				case window.performance.navigation.TYPE_RELOAD:
					return 'reload';
				case window.performance.navigation.TYPE_RESERVED:
					return 'reserved';
				default:
					return 'unknown';
			}
		}
		return 'unsupported';
	}
	
	function timing_bucket(ms, type) {
		var steps;
		switch (type) {
			case 'total':
				steps = [300, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 7500, 10000, 15000, 25000]; // 14
				break;
			case 'wire':
				steps = [2, 5, 10, 25, 50, 150, 300, 400, 500, 600, 800, 1000, 1250, 1500, 1750, 2000, 3000, 5000, 7500]; // 19
				break;
			case 'backend':
				steps = [5, 10, 25, 100, 150, 200, 250, 300, 350, 400, 500, 600, 800, 1000, 1500, 2000, 3000, 5000]; // 18
				break;
			case 'frontend':
				steps = [200, 300, 400, 500, 750, 1000, 1250, 1500, 1750, 2000, 2500, 3000, 4000, 5000, 7500, 10000]; // 16
				break;
		}
		for (var i = 0; i < steps.length; i++) {
			if (ms < steps[i]) {
				return steps[i];
			}
		}
		return 'max';
	}
	
	function nickname_check(name) {
		return jQuery.ajax({
			type: 'post',
			url: '/api/ajax/nickname_check/',
			dataType: 'json',
			data: {
				nickname: name
			}
		});
	}
	
	function nickname_check_response(response) {
		var success = response[0];
		var $nickname_suggestions = jQuery('.js-nickname_suggestions');
		$nickname_suggestions.html('');
		var $input = jQuery('.js-choose_nickname');
		$input.removeClass('text_valid text_invalid');
		if (success) {
			$input.addClass('text_valid');
		} else {
			$input.addClass('text_invalid');
			var message = response[1];
			if (response[2] === 'suggestions') {
				var html = '<br><strong>' + message + '</strong><div class="nickname_suggestions__label">' + response[3] + '</div>';
				for (var i = 0; i < response[4].length; i++) {
					html += (i > 0 ? ', ' : '') + '<span class="nickname_suggestions__item js-nickname_suggestion">' + response[4][i] + '</span>';
				}
				$nickname_suggestions.html(html);
			} else if (message) {
				yalwa.basics.toast({message: message, type: 'warning'});
			}
		}
	}
	
	pub.init_nickname_dialog = function() {
		var $input = jQuery('.js-choose_nickname');
		$input.after('<div class="nickname_suggestions js-nickname_suggestions"></div>');
		jQuery('.js-nickname_suggestions').on('click', '.js-nickname_suggestion', function() {
			$input.val(jQuery(this).text()).trigger('input');
			jQuery('.js-nickname_suggestions').html('');
		})
		$input.on('blur input', function() {
			yalwa.basics.debounce(function() {
				if ($input.val()) {
					nickname_check($input.val()).done(nickname_check_response);
				}
			}, 300);
		});
		jQuery('.js-choose_nickname_submit').on('click', function() {
			let $this = jQuery(this);
			let new_nickname = $input.val();
			if (new_nickname) {
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'account',
					action: 'add_nickname',
					data: {
						new_username: new_nickname
					},
					include_session: true,
					is_cross_origin: true
				}).then(response => {
					yalwa.basics.toast({message: response.label, type: response.type});
					if (response.type === 'success') {
						setTimeout(yalwa.basics.reload, 2000);
					}
				});
			} else {
				$input.velocity('callout.shake');
			}
		});
	};
	
	pub.init_delete_account = function() {
		if (yalwa.v.is_hybrid_user && yalwa.v.is_hybrid_user_with_payment) {
			jQuery('.js-delete_account_reason').one('change', 'input', hybrid_warning);
		}
		jQuery('.js-delete_account_reason').on('change', 'input', function() {
			var $this = jQuery(this);
			yalwa.basics.hide(jQuery('.js-show_on_select'));
			if ($this.is(':checked')) {
				yalwa.basics.show($this.closest('li').find('.js-show_on_select'));
			}
			yalwa.basics.show(jQuery('.js-delete_account_go'));
		});
		jQuery('.js-delete_account_go').on('click', function() {
			yalwa.basics.navigate(decodeURIComponent(jQuery(this).data('url')));
		});
	};
	
	function hybrid_warning() {
		jQuery('.js-hybrid_warning')
			.on('click', '.js-plp_confirm', () => {
				yalwa.basics.ga.event({
					category: 'hybrid-change-warning',
					action: 'hybrid-warning-confirm',
					label: 'delete-account',
				});
				jQuery('.js-hybrid_warning').trigger('plp_hide');
			})
			.on('click', '.js-plp_ok', () => {
				yalwa.basics.ga.event({
					category: 'hybrid-change-warning',
					action: 'hybrid-warning-cancel',
					label: 'delete-account'
				}).done(() => yalwa.basics.navigate(yalwa.v.my_locanto_url));
				jQuery('.js-hybrid_warning').trigger('plp_hide');
			})
			.trigger('plp_show');
	}
	
	pub.get_routing = function() {
		yalwa.v.routing = yalwa.v.routing || jQuery('html').data('routing');
		return yalwa.v.routing;
	};
	
	pub.check_routing = function() {
		const routing = yalwa.basics.get_routing();
		switch (routing) {
			case 'vap':
				if (yalwa.v.deleted_ad) {
					if (yalwa.v.src && yalwa.v.src === '0') {
						// Tracking only for organic postings
						yalwa.basics.ga.event({
							category: '404_page',
							action: yalwa.v.deleted_ad === 'visible' ? 'visible' : 'blurred',
							label: yalwa.v.posting_id
						});
					}
					if (yalwa.v.deleted_ad === 'blurred') {
						let disable_resize = false;
						
						setTimeout(function() {
							if (jQuery('.page_main').height() > jQuery('.deleted_ad').height()) {
								// Set disable_resize if we have small amount of content in deleted_ad
								disable_resize = true;
							}
						}, 200);
						
						const adjustHeight = () => {
							const deletedAdHeight = jQuery('.deleted_ad').height();
							const mainFullContainer = jQuery('.main_full_container');
							if (mainFullContainer.length) {
								mainFullContainer.height(deletedAdHeight + 100);
							} else if (!disable_resize) {
								jQuery('.page_main').height(deletedAdHeight + 60);
							}
						};
						
						// Attach the resize event handler
						jQuery(window).on('resize', () => setTimeout(adjustHeight, 200));
						
						// Trigger the resize event initially
						jQuery(window).trigger('resize');
					}
				}
				break;
			case 'delete_account':
				yalwa.basics.init_delete_account();
				break;
			case 'account_activation':
				check_uac().done(function(cn) {
					if (yalwa.v.redirect && suspicious(cn)) {
						if (yalwa.basics.get_get('ctrlStr') && yalwa.v.redirect !== yalwa.basics.get_get('ctrlStr') && jQuery('#nickname').length) {
							yalwa.basics.set_get({ctrlStr: yalwa.v.redirect}, true, true);
						}
					}
				});
				break;
			case 'login':
				hide_panel_on_twofactor();
				break;
			case 'registration':
				hide_panel_on_twofactor();
				init_registration_check();
				break;
		}
	};
	
	function hide_panel_on_twofactor() {
		jQuery(document).on('twofactor-dialog-show', 'yalwa-twofactordialog', function() {
			yalwa.basics.hide(jQuery('.js-login_modal'));
		}).on('twofactor-dialog-closed', 'yalwa-twofactordialog', function() {
			yalwa.basics.show(jQuery('.js-login_modal'));
		});
	}
	function cart_set_tracking(features) {
		var tracking_feature_multiply = {
			12: 10, // nationwide city extension = multiply value by 10
		};
		var booked_features_cap = 1;
		var booked_features = 0;
		jQuery.each(features, function(index, feature) {
			if (tracking_feature_multiply[feature.featureID]) {
				booked_features += (tracking_feature_multiply[feature.featureID] * parseInt(feature.amount));
			} else {
				booked_features += parseInt(feature.amount);
			}
		});
		
		if (booked_features > 0) {
			yalwa.basics.ga.ping_metric('CM_CART_ADD', booked_features < booked_features_cap ? booked_features : booked_features_cap);
		}
	}
	
	pub.cart_set_ajax = function(features, context) {
		cart_set_tracking(features);
		return jQuery.ajax({
			url: '/api/cart/set/',
			type: 'post',
			data: {
				source: context,
				data: features
			}
		});
	};
	
	pub.supports_audio = function() {
		const a = document.createElement('audio');
		return !!(a.canPlayType && a.canPlayType('audio/mpeg;').replace(/no/, ''));
	};
	
	pub.gdpr_consent_given = function(consent_category) {
		if (!yalwa.v.gdpr_active) {
			// gdpr not necessary
			return true;
		}
		const settings_cookie = pub.get_cookie('gdpr_settings');
		// user should see the gdpr popup first
		if (!settings_cookie) {
			return false;
		}
		
		try {
			const settings = JSON.parse(unescape(decodeURI(settings_cookie)));
			return settings[consent_category];
		} catch (e) {
			// cookie does not contain valid JSON
			return false;
		}
	};
	
	pub.create_uuid = function() { // https://stackoverflow.com/a/8809472/333864
		if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
			return crypto.randomUUID();
		}
		var d = new Date().getTime();
		if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
			d += performance.now(); //use high-precision timer if available
		}
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	};
	
	pub.svg = (function(pub) {
		
		pub = pub || {};
		
		pub.create = function(name, options) {
			if (!name) {
				return '';
			}
			var classes = [];
			options = options || {};
			if (options['classes'] && Array.isArray(options['classes'])) {
				classes = classes.concat(options['classes']);
			}
			var mod = options['mod'] || ['16', 'greyblack'];
			classes = classes.concat(mod.map(function(modifier) {
				if (!isNaN(parseInt(modifier))) {
					return 'ysvg--' + modifier;
				} else {
					return 'yicon ysvg--' + modifier;
				}
				
			}));
			return '<img class="' + classes.join(' ') + '" alt="" src="' + yalwa.basics.static_url('svg') + name + '.svg">'
		};
		
		pub.create_sprite = function(name, options) {
			var svg_class = 'ysvg';
			var classes = [svg_class];
			options = options || {};
			options['pixel'] = options['pixel'] || 16;
			options['sprite_name'] = options['sprite_name'] || 'main';
			if (options['classes'] && Array.isArray(options['classes'])) {
				classes = classes.concat(options['classes']);
			}
			var mod = options['mod'] || ['greyblack'];
			classes = classes.concat(mod.map(function(modifier) {
				return svg_class + '--' + modifier;
			}));
			
			return '<div style="width:' + options['pixel'] + 'px; height:' + options['pixel'] + 'px;" class="sprites_mobile_' + options['sprite_name'] + '__' + name + ' yicon js-yicon ysvg--' + mod + ' ' + classes.join(' ') + '"></div>';
		};
		
		pub.get_id = function($element) {
			var url = get_url($element);
			if (!url) {
				return null;
			}
			var result = url.match(/#([A-Za-z_-]+)$/);
			if (!result || !result[1]) {
				return null;
			}
			return result[1];
		};
		
		pub.set_id = function($element, new_value) {
			var use = get_use($element);
			if (use) {
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', get_url($element).replace(/[^#]+$/, new_value));
			}
		};
		
		pub.lazyload = function($element) {
			var use = get_use($element);
			if (use) {
				use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', use.dataset.href);
			}
		};
		
		function get_use($element) {
			var $use = $element.children('use');
			return $use.length ? $use[0] : null;
		}
		
		function get_url($element) {
			var $use = get_use($element);
			if (!$use) {
				return null;
			}
			var url = $use.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
			if (!url) {
				return null;
			}
			return url;
		}
		
		return pub;
		
	}(pub.svg));
	
	pub.state = (function(pub) {
		
		pub = pub || {};
		var current_state = ['init_dummy'];
		var pagepop_checks = {};
		var debug = false;
		
		pub.init = function() {
			// https://github.com/visionmedia/page.js/issues/213
			jQuery(document).ready(function() {
				setTimeout(function() {
					window.addEventListener('popstate', onpopstate);
				}, 100);
			});
		};
		
		// callback should include necessary dom-changes to apply when going back
		// return true if dom-change took place, otherwise false to proceed to next pop
		// arguments: state_from, state_to
		pub.register = function(id, callback) {
			pagepop_checks[id] = callback;
		};
		
		// reset virtual history
		pub.unregister = function() {
			current_state = ['init_dummy'];
			pagepop_checks = {};
		};
		
		pub.push = function(state, title, url) {
			title = title || null;
			url = url || window.location.href;
			if (typeof (state) === 'string') {
				state = {id: state};
			}
			if (debug) {
				console.log('%cpush:' + state.id, 'color:blue');
			}
			current_state.push(state);
			window.history.pushState(state, title, url);
			if (window.history.state && window.history.state.ltw_type === 'root') {
				if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
					yalwa.mobile.cordova.remove_backbutton();
				}
			} else {
				if (yalwa.v.is_phonegap && yalwa.v.is_ios) {
					yalwa.mobile.cordova.activate_backbutton();
				}
			}
		};
		
		// probably not needed anymore
		pub.try_cancel = function(id) {
			if (history.state && history.state.id === id) {
				if (debug) {
					console.log('%ccancel success:' + id, 'color:red');
				}
				var s = state_current();
				if (s && typeof (s) === 'object') {
					s.cancelled = true;
				}
			} else {
				if (debug) {
					console.log('%ccancel fail: ' + id, 'color:red', history.state);
				}
			}
		};
		
		pub.back = function() {
			back();
		};
		
		pub.extend = function(params, no_url) {
			var updated_state = jQuery.extend(history.state, params);
			state_current_set(updated_state);
			history.replaceState(updated_state, null, no_url ? null : yalwa.basics.get_altered_url(params));
		};
		
		function state_current_set(value) {
			if (current_state.length) {
				current_state[current_state.length - 1] = value;
			}
		}
		
		function state_current() {
			return current_state.length ? current_state[current_state.length - 1] : null;
		}
		
		function back() {
			window.history.back();
		}
		
		pub.prevent_back_button_caching = function(url) {
			yalwa.basics.state.push({id: 'prevented', state: 'custom_handling', url: url}, null, window.location.href);
			yalwa.basics.state.push({id: 'prevented', state: 'prevent_back', url: url}, null, window.location.href);
			yalwa.basics.state.push({id: 'prevented', state: 'prevent_forward', url: url}, null, window.location.href);
			history.back();
			history.forward();
		};
		
		function onpopstate(e) {
			var s = state_current();
			
			if (s && s.id) {
				if (s.id === 'prevented') {
					switch (s.state) {
						case 'prevent_forward':
							current_state.pop();
							history.go(1);
							return;
							break;
						case 'prevent_back':
							current_state.pop();
							return;
							break;
						case 'custom_handling':
							yalwa.basics.navigate(s.url);
							return;
							break;
					}
				}
			}
			current_state.pop();
			if (s && s.id) {
				if (s.step) {
					//console.log(s.step)
					return;
				} else if (s.cancelled) {
					if (debug) {
						console.log('%ccancelled: ' + s.id, 'color:purple');
					}
					back();
					return;
				}
				var visible_dom_change = pagepop_checks[s.id] && pagepop_checks[s.id](s, state_current());
				if (visible_dom_change) {
					if (debug) {
						console.log('%cvisible dom change applied: ' + s.id, 'color:green');
					}
				} else {
					if (debug) {
						console.log('%cno visible dom change, proceeding: ' + s.id, 'color:purple');
					}
					back();
				}
			} else {
				if (debug) {
					console.log('%cno state, proceeding: ', 'color:purple');
				}
				//  BOF DEV-987
				if (['terms', 'privacy', 'dol_onboarding'].indexOf(yalwa.basics.get_routing()) !== -1) {
					//  EOF DEV-987
				} else if ((!yalwa.faq && !yalwa.paf && !location.hash && !yalwa.v.is_ios && !yalwa.v.is_phonegap) || ['settings', 'dol_onboarding'].indexOf(yalwa.basics.get_routing()) !== -1) {
					back();
				}
			}
		}
		
		return pub;
	}(pub.state));
	
	pub.sentry = ((pub = {}) => {
		
		pub.submit_error = err => {
			if (typeof err === 'string') {
				err = new Error(err);
			}
			if (location.port) {
				console.error(err);
			}
			if (!window.yalwa || !yalwa.v) {
				// something is completely broken, errors will just be symptoms
				return false;
			}
			if (typeof Sentry === 'undefined' || !err) {
				return false;
			}
			Sentry.captureException(err);
		};
		
		pub.submit_error_with_options = (err, options) => {
			if (typeof err === 'string') {
				err = new Error(err);
			}
			options = options || {};
			if (location.port) {
				console.error(err);
			}
			if (!window.yalwa || !yalwa.v) {
				// something is completely broken, errors will just be symptoms
				return false;
			}
			if (typeof Sentry === 'undefined' || !err) {
				return false;
			}
			Sentry.captureException(err, {
				contexts: {
					customdata: options.extra,
				},
			});
		}
		
		return pub;
		
	})(pub.sentry);
	
	pub.ga = (function(pub) {
		
		pub = pub || {};
		let dimensions = {};
		let initial_ping_sent = false;
		const debug = false;
		const sampling_categories = new Set([
			'native_ads_views_image_hidden',
			'native_ads_views_image_shown',
			'native_ads2_bp_views',
			'native_ads_clicks_image_hidden',
			'native_ads_clicks_image_shown',
			'native_ads2_bp_clicks',
			'native_ads2_vap_clicks',
			'native_ads2_vip_clicks',
			'native_ads_views',
			'native_ads_clicks',
			'native_ads_ajax_views',
			'native_ads_ajax_clicks',
			'native_ads2_ajax_views',
			'native_ads2_ajax_clicks',
		]);
		
		pub.init = function() {
			if (!yalwa.v.gtag_init) {
				return;
			}
			yalwa.v.gtag_init.sampling_is_tracked = tracked_in_ga4();
			if (check_optout()) {
				return;
			}
			
			if (yalwa.v.ga_disabled) {
				dataLayer.push({event: 'ga_disabled'});
			}
			
			set_initial_ga_dimensions();
			before_ping();
			
			const cf_original_referrer = yalwa.basics.ls_get('cf_original_referrer') || yalwa.basics.get_cookie('cf_original_referrer');
			yalwa.basics.ls_remove('cf_original_referrer');
			yalwa.basics.set_cookie('cf_original_referrer', 0, -1);
			
			let config = {
				'userID': yalwa.v.gtag_init.user || null,
				'appName': yalwa.v.gtag_init.appName,
				'sample_rate': yalwa.v.gtag_init.sample_rate,
				// 'page': yalwa.v.gtag_init.pageview || null,
				'sampling_is_tracked': yalwa.v.gtag_init.sampling_is_tracked,
				'cf_original_referrer': cf_original_referrer || null
			};
			config = jQuery.extend(config, dimensions);
			datalayer_push({event: 'ga_config', data: config});
			set_initial_ga_metrics();
			yalwa.basics.ga.update_pagetype_before();
			yalwa.basics.ga.update_navigation_type('simulated');
			initial_ping_sent = true;
			reset_initial_ga_dimensions();
			
			jQuery('.js-track_pageview_on_click').on('click', track_pageview_on_click);
			jQuery('.js-click_tracker').on('click', click_tracker_on_click);
			jQuery('.js-click_tracker_safe').on('click', click_tracker_on_click_safe);
			jQuery('.js-view_tracker').each(view_tracker_on_view);
		};
		
		function tracked_in_ga4() {
			let sample = yalwa.basics.get_cookie('ga4_sample'); // try cookie first
			if (sample === null || sample === false) { // maybe localStorage still has a previous value
				sample = yalwa.basics.ls_get('ga4_sample');
			}
			if (sample === null || sample === false) { // no previous info, generate random new one
				sample = Math.floor(Math.random() * 100);
			}
			
			// sync current values across both cookie and LS
			yalwa.basics.ls_set('ga4_sample', sample);
			yalwa.basics.set_cookie('ga4_sample', sample, 10 * yalwa.basics.ONE_YEAR);
			
			return parseInt(sample, 10) < 10;
		}
		
		function datalayer_push(data) {
			if (location.port) {
				if (debug) {
					console.log('datalayer_push', data);
				}
				let history = yalwa.basics.ls_get('GA_history', true) || [];
				history.push(jQuery.extend(data, {unix: yalwa.basics.unix(), url: location.href}));
				const max = 10;
				if (history.length > max) {
					history = history.slice(history.length - max, history.length);
				}
				yalwa.basics.ls_set('GA_history', history);
				jQuery(document).trigger('GA_history_change');
			}
			dataLayer.push(data);
		}
		
		pub.consent_granted = function() {
		
		};
		
		pub.ping_metric = function(metric, value, event) {
			const deferred = jQuery.Deferred();
			metric = yalwa.v.gtag_init.metric_names[metric];
			if (yalwa.v.ga_disabled || !metric) {
				return deferred.reject().promise();
			}
			event = event || {};
			let data = {
				'event': 'customMetricTracking',
				'metric': metric,
				'value': value,
				'eventTimeout': 2000,
				'eventCallback': () => deferred.resolve('success')
			}
			data['category'] = event.category || 'custom_metric';
			data['action'] = event.action || metric;
			if (event.label) {
				data['label'] = event.label;
			}
			data['value'] = event.value || value;
			datalayer_push(data);
			return deferred.promise();
		};
		
		function ignore_due_to_sampling(category) {
			// only track 10% for whitelisted events
			return sampling_categories.has(category) ? yalwa.basics.get_random_int(1, 100) > 10 : false;
		}
		
		pub.event = function(details) {
			if (location.port && yalwa.basics.get_get('log_events')) {
				if (yalwa.basics.get_get('log_events') === 'trace') {
					console.trace(details);
				} else {
					console.log(details);
				}
			}
			const deferred = jQuery.Deferred();
			if (yalwa.v.ga_disabled) {
				return deferred.reject().promise();
			}
			if (!details.category || !details.action) {
				yalwa.basics.sentry.submit_error(new Error('invalid ga event tracking, category: ' + details.category + ' action: ' + details.action));
				return deferred.reject().promise();
			}
			
			if (typeof details.action !== 'string') {
				console.log('GA Event action value type needs to be string instead of ' + typeof details.action + ' for event category ' + details.category);
			}
			before_ping();
			if (ignore_due_to_sampling(details.category)) {
				return;
			}
			datalayer_push({
				'event': 'eventTracking',
				'category': details.category,
				'action': details.action,
				'label': details.label,
				'value': details.value,
				'eventTimeout': 2000,
				'eventCallback': () => deferred.resolve('success')
			});
			reset_initial_ga_dimensions();
			return deferred.promise();
		};
		
		pub.datalayer = function(data) {
			datalayer_push(data);
		};
		
		pub.pageview = function(settings) {
			if (yalwa.v.ga_disabled) {
				return false;
			}
			settings = settings || {};
			settings.app_name = settings.app_name || yalwa.v.gtag_init.appName;
			before_ping();
			pub.dimension_set('CD_PAGETYPE_BEFORE', yalwa.basics.ga.get_pagetype_before());
			
			datalayer_push({
				event: 'artifical_pageview',
				settings: settings
			});
		};
		
		pub.get_updated_pagetype_in_appname = function(value) {
			return yalwa.v.gtag_init.appName.replace(/\|.+\|/, '|' + value + '|');
		}
		
		function before_ping() {
			pub.dimension_set('CD_CONNECTION', yalwa.basics.connection());
		}
		
		pub.dimension_get = dimension => {
			if (!yalwa.v.gtag_init || !yalwa.v.gtag_init.dimension_names) {
				return null;
			}
			const integer = yalwa.v.gtag_init.dimension_names[dimension];
			if (!integer) {
				yalwa.basics.sentry.submit_error(new Error('Tried to get invalid custom dimension: "' + dimension + '"'));
				return null;
			} else {
				return dimensions['dimension' + integer];
			}
		};
		
		pub.dimension_set = function(dimension, value, suppress_gtm_ping) {
			const integer = yalwa.v.gtag_init.dimension_names[dimension];
			if (!integer) {
				yalwa.basics.sentry.submit_error(new Error('Tried to set invalid custom dimension: "' + dimension + '" / "' + value + '"'));
			} else {
				let really_changed = false;
				if (value === null) {
					delete dimensions['dimension' + integer];
				} else {
					really_changed = dimensions['dimension' + integer] !== value;
					dimensions['dimension' + integer] = value;
				}
				if (!suppress_gtm_ping && really_changed) {
					pub.custom_dimension_update();
				}
			}
		};
		
		pub.custom_dimension_update = function() {
			if (initial_ping_sent) {
				datalayer_push({event: 'custom_dimension_update', data: dimensions});
			}
		};
		
		pub.dimension_unset = function(dimension, suppress_gtm_ping) {
			pub.dimension_set(dimension, null, suppress_gtm_ping);
		};
		
		pub.optout = function() {
			yalwa.basics.ls_set('ga_optout', true);
		};
		
		pub.ab_test_slot = function(variation_count) {
			let slot = yalwa.basics.ga.dimension_get('CD_ABTEST_SLOT');
			if (location.port && yalwa.basics.get_get('ab_slot')) {
				slot = parseInt(yalwa.basics.get_get('ab_slot'));
			}
			const range = 100;
			if (!slot) {
				return false;
			}
			variation_count = variation_count || 2;
			let size = Math.floor(range / variation_count);
			let i = 0;
			let index = null;
			do {
				i += size;
				if (slot < i) {
					index = i / size;
					break;
				}
			} while (i + size <= range);
			if (index > 0 && index < 11) {
				return 'ABCDEFGHIJ'.charAt(index - 1);
			}
			return false;
		};
		
		function track_user_feature_type() {
			if (yalwa.v.user_l1_type === undefined) {
				return false;
			} else {
				yalwa.basics.ga.dimension_set('CD_USER_L1_TYPE', yalwa.v.user_l1_type);
			}
		}
		
		function click_tracker_on_click() {
			const $this = jQuery(this);
			if ($this.data('d1')) {
				yalwa.basics.ga.event({category: $this.data('d1'), action: $this.data('d2'), label: $this.data('d3')});
			}
		}
		
		function click_tracker_on_click_safe(e) {
			e.preventDefault();
			const $this = jQuery(this);
			yalwa.basics.ga.event({
				category: $this.data('d1'),
				action: $this.data('d2'),
				label: $this.data('d3')
			}).done(() => {
				let url = $this.attr('href');
				if (url) {
					yalwa.basics.navigate(url);
				}
			});
			return false;
		}
		
		function view_tracker_on_view(index, element) {
			const $this = jQuery(element);
			yalwa.basics.ga.event({
				category: $this.data('d1-view') ? $this.data('d1-view').toString() : ($this.data('d1') ? $this.data('d1').toString() : null),
				action: $this.data('d2-view') ? $this.data('d2-view').toString() : ($this.data('d2') ? $this.data('d2').toString() : null),
				label: $this.data('d3-view') ? $this.data('d3-view').toString() : ($this.data('d3') ? $this.data('d3').toString() : null)
			});
		}
		
		function init_visibility_observer($elements) {
			const options = {
				rootMargin: '0px',
				threshold: 0.9 // safari fix the threshold only reach .9xx
			};
			const observer = new IntersectionObserver(observer_callback, options);
			if ($elements.length) {
				$elements.each((index, element) => observer.observe(element));
			}
		}
		
		function observer_callback(changes, observer) {
			changes.forEach(change => {
				// visible
				if (change.intersectionRatio > 0.9) {
					view_tracker_on_view(0, change.target);
					observer.unobserve(change.target); // track it only one time
				}
			});
		}
		
		pub.init_visibility_observer = init_visibility_observer;
		
		function track_pageview_on_click() {
			const $this = jQuery(this);
			const settings = {
				page: $this.data('page')
			};
			if (settings.page.match(/\/uhp_/) || $this.data('goal')) {
				settings.location = '/';
			}
			pub.pageview(settings);
		}
		
		function check_optout() {
			if (yalwa.basics.ls_get('ga_optout')) {
				if (yalwa.v.ga_id) {
					window['ga-disable-' + yalwa.v.ga_id] = true;
				}
				return true;
			}
			return false;
		}
		
		let pagetype_before_preserved;
		pub.update_pagetype_before = function() {
			if (pub.dimension_get('CD_PAGETYPE')) {
				pagetype_before_preserved = yalwa.basics.get_cookie('pagetype_before');
				yalwa.basics.set_cookie('pagetype_before', pub.dimension_get('CD_PAGETYPE'));
			}
		};
		
		pub.pagetype_before_preserved = function() {
			return pagetype_before_preserved;
		};
		
		pub.get_pagetype_before = function() {
			return yalwa.basics.get_cookie('pagetype_before') || 'unknown';
		}
		
		pub.update_navigation_type = function(type) {
			pub.dimension_set('CD_NAVIGATION_TYPE', type);
		};
		
		function add_server_info(timing) {
			const $sn = jQuery('.js-server_name');
			if ($sn.length && $sn.is(':visible')) {
				$sn.append(' | ' + timing.total + 'ms');
				if (yalwa.v.is_phonegap) {
					$sn.append(' | Cordova');
				}
				if (yalwa.basics.is_pwa()) {
					$sn.append(' | PWA');
				}
				$sn.append(' | PT: ' + pub.dimension_get('CD_PAGETYPE'));
				if (jQuery('body').data('ts')) {
					const ts_string = new Date(jQuery('body').data('ts') * 1000).toLocaleTimeString();
					$sn.append(' | ' + ts_string);
				}
			}
		}
		
		function flip(object) {
			let ret = {};
			for (let key in object) {
				ret[object[key]] = key;
			}
			return ret;
		}
		
		function get_mapped_metrics(flipped = false) {
			if (flipped) {
				return flip(yalwa.v.gtag_init.metric_names);
			} else {
				return yalwa.v.gtag_init.metric_names;
			}
		}
		
		function get_mapped_dimensions(flipped = false) {
			if (flipped) {
				return flip(yalwa.v.gtag_init.dimension_names);
			} else {
				return yalwa.v.gtag_init.dimension_names;
			}
		}
		
		function set_initial_ga_metrics() {
			const flipped = get_mapped_metrics(true);
			for (const id in yalwa.v.gtag_init.metrics) {
				if (yalwa.v.gtag_init.metrics.hasOwnProperty(id)) {
					pub.ping_metric(flipped[id], yalwa.v.gtag_init.metrics[id]);
				}
			}
		}
		
		function set_initial_ga_dimensions() {
			const flipped = get_mapped_dimensions(true);
			for (const id in yalwa.v.gtag_init.dimensions) {
				if (yalwa.v.gtag_init.dimensions.hasOwnProperty(id)) {
					if (!flipped[id]) {
						yalwa.basics.sentry.submit_error(new Error('Failed to find custom dimension: "' + id + '"'));
					} else {
						pub.dimension_set(flipped[id], yalwa.v.gtag_init.dimensions[id]);
					}
				}
			}
			const timing = timing_tracking(true);
			pub.dimension_set('CD_TIMING_TOTAL', timing.total);
			pub.dimension_set('CD_TIMING_WIRE', timing.wire);
			pub.dimension_set('CD_TIMING_FRONTEND', timing.frontend);
			pub.dimension_set('CD_TIMING_BACKEND', timing.backend);
			pub.dimension_set('CD_TIMING_INITIAL_NETWORK', timing.initial_network);
			pub.dimension_set('CD_TIMING_REQUEST_RESPONSE', timing.request_response);
			pub.update_navigation_type(navigation_type());
			pub.dimension_set('CD_PAGETYPE_BEFORE', yalwa.basics.ga.get_pagetype_before());
			if (yalwa.basics.is_pwa()) {
				pub.dimension_set('CD_APPTYPE', 'standalone');
			}
			track_user_feature_type();
			handle_session_l1();
		}
		
		function reset_initial_ga_dimensions() {
			pub.dimension_set('CD_TIMING_TOTAL', 'NOTSET', true);
			pub.dimension_set('CD_TIMING_WIRE', 'NOTSET', true);
			pub.dimension_set('CD_TIMING_FRONTEND', 'NOTSET', true);
			pub.dimension_set('CD_TIMING_BACKEND', 'NOTSET', true);
			pub.dimension_set('CD_TIMING_INITIAL_NETWORK', 'NOTSET', true);
			pub.dimension_set('CD_TIMING_REQUEST_RESPONSE', 'NOTSET', true);
			pub.custom_dimension_update();
		}
		
		function timing_tracking(use_buckets) {
			const result = {total: null, frontend: null, backend: null, wire: null};
			if (typeof (performance) !== 'undefined' && typeof (performance.getEntriesByType) !== 'undefined' && performance.getEntriesByType("navigation").length > 0) {
				let perf = performance.getEntriesByType("navigation")[0];
				result.total = performance.now();
				const wire_client_to_server = perf.requestStart - perf.redirectStart;
				const wire_server_to_client = perf.responseEnd - perf.responseStart;
				result.wire = wire_client_to_server + wire_server_to_client;
				result.frontend = result.total - perf.responseEnd;
				if (yalwa.v.backend_duration) { // calculation for this is more accurate on the server itself
					result.backend = yalwa.v.backend_duration;
					result.wire = perf.responseEnd - perf.redirectStart - result.backend;
				} else {
					result.backend = perf.responseStart - perf.requestStart;
				}
				result.initial_network = perf.connectEnd - perf.domainLookupStart;
				result.request_response = perf.responseEnd - perf.requestStart;
				pub.timing_tracking_raw = { ...result }; // for koopa
				if (use_buckets) {
					result.total = timing_bucket(result.total, 'total');
					result.wire = timing_bucket(result.wire, 'wire');
					result.backend = timing_bucket(result.backend, 'backend');
					result.frontend = timing_bucket(result.frontend, 'frontend');
					result.initial_network = timing_bucket(result.initial_network, 'wire');
					result.request_response = timing_bucket(result.request_response, 'wire');
				}
			}
			add_server_info(result);
			if (yalwa.basics.get_random_int(1, 100) === 1) { // track 1%
				yalwa.basics.beacon('/api/ajax/track/', {
					t: 'timing',
					bucket_frontend: result.frontend,
					bucket_backend: result.backend,
					bucket_wire: result.wire,
					pagetype: yalwa.basics.page_type()
				});
			}
			return result;
		}
		
		return pub;
		
	}(pub.ga));
	
	function not_working_email_provider_check(email) {
		if (yalwa.v.not_working_providers) {
			var not_working_provider = false;
			jQuery.each(yalwa.v.not_working_providers, function(index, provider) {
				if (email.toLowerCase().indexOf(provider.toLowerCase()) !== -1) {
					not_working_provider = provider;
				}
			});
			if (not_working_provider) {
				return not_working_provider.replace('.', '');
			} else {
				return false;
			}
		}
		return false;
	}
	
	function init_registration_check() {
		var $form = jQuery('.js-register_form');
		var check_complete = false;
		
		$form.on('submit', function(e) {
			var not_working_provider = not_working_email_provider_check(jQuery('.js-register_email').val());
			if (not_working_provider) {
				var $info = jQuery('.js-provider_not_working_error');
				if (!yalwa.v.provider_not_available_message) {
					yalwa.v.provider_not_available_message = $info.html();
				}
				var message = yalwa.v.provider_not_available_message.replace('%1$s', not_working_provider);
				$info.html(message);
				jQuery('.js-provider_not_working_plp .plp__text').html(message);
				jQuery('.js-provider_not_working_plp').trigger('plp_show');
				
				e.preventDefault();
				return false;
			}
			
			if ($form[0].checkValidity() === false || check_complete) {
				if (check_complete) {
					var regs = yalwa.basics.ls_get('regs', true) || [];
					regs.push(yalwa.basics.unix());
					yalwa.basics.ls_set('regs', regs);
				}
				return true;
			}
			e.preventDefault();
			check_uac().done(function(cn) {
				if (jQuery('.js-register_auth').length && !suspicious(cn)) {
					jQuery.ajax({
						method: "GET",
						url: '/api/ajax/register_auth/',
						data: {email: jQuery('.js-register_email').val()}
					}).done(function(ctrlStr) {
						jQuery('.js-register_auth').val(ctrlStr);
						check_complete = true;
						$form.submit();
					}).fail(function() {
						check_complete = true;
					});
				} else {
					check_complete = true;
					$form.submit();
				}
			});
		});
	}
	
	function ls_disabled() {
		let key = 'ls_support_' + yalwa.basics.unix();
		yalwa.basics.ls_set(key, true);
		let support = yalwa.basics.ls_get(key) === true;
		yalwa.basics.ls_remove(key);
		return !support;
	}
	
	function suspicious(cn) {
		let regs = yalwa.basics.ls_get('regs', true) || [];
		return ls_disabled() || cn || regs.length >= 2;
	}
	
	pub.uac_suspicious = function() {
		return yalwa.basics.ls_get('uac', true).length >= 2;
	};
	
	function check_uac() {
		const deferred = jQuery.Deferred();
		const uac = yalwa.basics.ls_get('uac', true);
		if (uac && uac.length) {
			deferred.resolve(true);
		} else {
			deferred.resolve(false);
		}
		return deferred.promise();
	}
	
	pub.velocity_path = function() {
		return yalwa.v.js_path + 'external/velocity.including.ui.min.js';
	};
	
	pub.emoji = (function(pub) {
		
		var mapping_data;
		var path;
		var picker_selected_class = 'emojilist__selector--selected';
		
		pub = pub || {};
		
		pub.dynamic = function(name) {
			return name ? '<img class="emojione" alt="" src="https://cdn.jsdelivr.net/emojione/assets/4.5/png/64/' + name + '.png">' : '';
		};
		
		pub.autocomplete = function($element) {
			path = yalwa.basics.static_url('images') + '/emojione/4.5.0/';
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/jquery.textcomplete.js', function() {
				load_mapping_data().done(function() {
					on_strategy_load($element);
				});
			});
		};
		
		pub.picker_init = function($container, settings) {
			settings = settings || {};
			return jQuery.ajax({
				url: '/api/ajax/general/',
				type: 'get',
				data: {
					action: 'emoji_categories',
				},
				cache: true,
				dataType: 'html'
			}).done(function(html) {
				$container.append(html);
				picker_change_tab(jQuery('.js-emojione_head').first());
				jQuery('.js-emojione_head').on('click', function() {
					picker_change_tab(jQuery(this));
				});
				jQuery('.js-emojilist_close').on('click', yalwa.basics.emoji.picker_close);
				if (settings.swipe && typeof Hammer !== 'undefined') {
					var hammertime = new Hammer(jQuery('.js-emojilist')[0], {});
					hammertime.on('swipeleft', picker_tab_next).on('swiperight', picker_tab_prev);
				}
			});
		};
		
		pub.picker_toggle = function() {
			yalwa.basics.toggle(jQuery('.js-emojilist'));
		};
		
		pub.picker_close = function() {
			yalwa.basics.hide(jQuery('.js-emojilist'));
		};
		
		function picker_tab_next() {
			var $next = jQuery('.js-emojione_head').filter('.' + picker_selected_class).next();
			if (!$next.length) {
				$next = jQuery('.js-emojione_head').first();
			}
			picker_change_tab($next);
		}
		
		function picker_tab_prev() {
			var $prev = jQuery('.js-emojione_head').filter('.' + picker_selected_class).prev();
			if (!$prev.length) {
				$prev = jQuery('.js-emojione_head').last();
			}
			picker_change_tab($prev);
		}
		
		function picker_change_tab($new_tab) {
			jQuery('.js-emojione_head').removeClass(picker_selected_class);
			$new_tab.addClass(picker_selected_class);
			yalwa.basics.hide(jQuery('.js-emojilist_tab'));
			yalwa.basics.show(jQuery('.js-emojilist_tab').filter('[data-category="' + $new_tab.data('category') + '"]'));
			jQuery('.js-emojilist_content').scrollTop(0);
		}
		
		function load_mapping_data() {
			if (mapping_data) {
				var deferred = jQuery.Deferred();
				deferred.resolve();
				return deferred.promise();
			}
			return jQuery.ajax({
				url: '/js/external/emoji_strategy.json',
				dataType: 'json'
			}).done(function(emoji_strategy) {
				mapping_data = emoji_strategy;
			});
		}
		
		function on_strategy_load($element) {
			var config = {
				maxCount: 10
			};
			config.appendTo = jQuery('.js-mc_compose');
			$element.textcomplete([{
				match: /\B:([\-+\w]*)$/,
				search: on_search,
				template: template,
				replace: on_replace,
				index: 1
			}
			], config);
		}
		
		function check_for_hit(id, data, term) {
			if (data.shortname.indexOf(term) > -1) {
				return 1;
			} else {
				if ((data.shortname_alternates !== null) && (data.shortname_alternates.indexOf(term) > -1)) {
					return 2;
				} else if ((data.keywords !== null) && (data.keywords.indexOf(term) > -1)) {
					return 3;
				}
			}
		}
		
		function on_search(term, callback) {
			var results = [
				[],
				[],
				[]
			];
			jQuery.each(mapping_data, function(id, data) {
				var type = check_for_hit(id, data, term);
				if (type) {
					results[type - 1].push(id);
				}
			});
			
			if (term.length >= 3) {
				results[0].sort(sort_length);
				results[1].sort(sort_length);
				results[2].sort();
			}
			
			callback(results[0].concat(results[1]).concat(results[2]));
		}
		
		function sort_length(a, b) {
			return (a.length > b.length);
		}
		
		function template(id) {
			return (path && id) ? '<img class="emojione" src="' + path + id + '.svg">' : '';
		}
		
		function on_replace(id) {
			return String.fromCodePoint(parseInt(id, 16));
			// return '\u' + id;
			return mapping_data[id].shortname;
		}
		
		return pub;
		
	}(pub.emoji));
	
	pub.sw = (function(pub) {
		
		pub = pub || {};
		
		pub.init = function() {
			if (!pub.is_supported() || is_disabled()) {
				return;
			}
			unregister('dol');
			register();
			setup_message_listener();
		};
		
		pub.get_recent_pushes = function() {
			return new Promise(function(resolve, reject) {
				let msg_chan = new MessageChannel();
				msg_chan.port1.onmessage = function(event) {
					if (event.data.error) {
						reject(event.data.error);
					} else {
						resolve(event.data);
					}
				};
				if (navigator.serviceWorker.controller) {
					navigator.serviceWorker.controller.postMessage("get_new_pushes", [msg_chan.port2]);
				}
			});
		};
		
		pub.is_supported = function() {
			return 'serviceWorker' in navigator && navigator.cookieEnabled;
		};
		
		pub.name = function() {
			if (navigator &&
				navigator.serviceWorker &&
				navigator.serviceWorker.controller &&
				navigator.serviceWorker.controller.scriptURL
			) {
				const tmp = navigator.serviceWorker.controller.scriptURL.match(/\/([a-z_]+\.js)/);
				return tmp && tmp[1] ? tmp[1] : null;
			}
			return null;
		}
		
		function is_disabled() {
			if (yalwa.v.is_phonegap) {
				return true;
			}
			if (location.hostname.search(/^secure\./) !== -1) {
				return true;
			}
			if (location.hostname.search(/^www\.hashtag-dating\.com/) !== -1) {
				unregister('all');
				return true;
			}
			if (location.hostname.search(/^api\.hashtag-dating\.com/) !== -1) {
				unregister('all');
				return true;
			}
			if (['demo', 'international'].indexOf(yalwa.basics.get_routing()) !== -1) {
				return true;
			}
			if (location.hostname === 'locan.to' || location.hostname === 'lcn.to') { // short url (used for sharing)
				unregister('all');
				return true;
			}
			return false;
		}
		
		function unregister(target) {
			let deferred = jQuery.Deferred();
			if (window.navigator && navigator.serviceWorker) {
				navigator.serviceWorker.getRegistrations()
					.then(function(registrations) {
						let promises = [];
						for (let registration of registrations) {
							if (target === 'all' || (target === 'dol' && sw_is_dol(registration))) {
								promises.push(registration.unregister());
							}
						}
						jQuery.when(promises).done(() => {
							deferred.resolve();
						});
					});
			}
			return deferred.promise();
		}
		
		function register() {
			if (navigator.serviceWorker.getRegistration) {
				navigator.serviceWorker.getRegistration().then(function(registration) {
					if (!registration) {
						do_registration();
					}
				});
			} else {
				do_registration();
			}
		}
		
		function sw_is_dol(registration) {
			return registration && registration.active && registration.active.scriptURL && registration.active.scriptURL.search('/sw_dol.js') !== -1;
		}
		
		function is_safari() {
			return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		}
		
		function do_registration() {
			navigator.serviceWorker.register('/sw.js' + (is_safari() ? '?safari=7' : ''), {updateViaCache: 'all'}).then(registration => {
				if (registration.active) {
					registration.active.postMessage({
						'countryID': yalwa.v.countryID
					});
					registration.active.postMessage({
						'is_pwa': {value: yalwa.basics.is_pwa() ? (yalwa.v.is_ios ? 'ios' : 'android') : false}
					});
				}
			});
		}
		
		function setup_message_listener() {
			if (navigator.serviceWorker.addEventListener) {
				navigator.serviceWorker.addEventListener('message', function(event) {
					switch (event.data.action) {
						case 'send_countryID':
							if (navigator.serviceWorker.controller) {
								navigator.serviceWorker.controller.postMessage({
									'countryID': yalwa.v.countryID
								});
							}
							break;
						case 'mc_poll':
							if (yalwa.basics.get_routing() === 'mc' || yalwa.chat) {
								yalwa.chat.polling_manual();
								if (event.data.payload) {
									yalwa.webpush.process_single_push(event.data.payload);
								}

							}
							break;
						case 'push_notification_click':
							yalwa.basics.webpush.notification_click(JSON.parse(event.data.info), event.data.new_tab);
							break;
						case 'new_push_received':
							if (event.data.payload) {
								yalwa.webpush.process_single_push(event.data.payload);
							}
							break;
					}
				});
			}
		}
		
		return pub;
		
	}(pub.sw));
	
	pub.chat_limit_reached = function() {
		let deferred = jQuery.Deferred();
		if (!yalwa.basics.is_logged_in()) {
			deferred.resolve(false);
		} else {
			const data = {
				method: 'POST',
				action: 'check_limit'
			};
			jQuery.ajax({
				url: '/api/ajax/chat',
				type: 'post',
				data: data,
				dataType: 'json'
			}).done(function(r) {
				if (r.status === 'reached') {
					deferred.resolve(true);
				} else {
					deferred.resolve(false);
				}
			}).fail(function(e) {
				deferred.resolve(false);
			});
		}
		return deferred.promise();
	}
	
	pub.webpush = (function(pub) {
		
		pub = pub || {};
		const recent_notifications_max = 10;
		const applicationServerKey = "BOTmdSh6+lEA9rKUBNRnSJGxyEZA0xe5UNL3/rnK/YZQgnfw+PLFLU6qHcmhTXiZmAZLCrmLovAGhfOxEqLdbtI=";
		const key_array = urlBase64ToUint8Array(applicationServerKey);
		
		let cache_key_base = 'webpush_endpoint';
		let cache_key_known = cache_key_base + '_known';
		let cache_key_confirmation = cache_key_base + '_confirmation';
		let cache_key_recent_notifications = cache_key_base + '_notifications';
		let notifications;
		let $priming_dialog;
		let $generic_shadow;
		let generic_shadow_opened;
		let $priming_allow_button;
		let $priming_close_button;
		const priming_routes = [
			'myads',
			'start',
			'mc',
			'payments',
			'searches', // my-subscriptions
			'followers'
		]
		
		pub.init = function() {
			$generic_shadow = jQuery('.js-generic_shadow');
			assign_priming_elements();
			if (pub.prerequisites_met()) {
				watch_permission_changes();
			}
			if (
				(yalwa.v.webpush_ask_on_init || pub.is_granted()) &&
				pub.is_supported() &&
				yalwa.basics.is_logged_in() &&
				!yalwa.v.is_phonegap &&
				!pub.is_denied()
			) {
				const touchpoint = yalwa.v.push_permission_touchpoint || 'update_existing';
				if (
					priming_routes.indexOf(yalwa.basics.get_routing()) !== -1 &&
					pub.is_default()
				) {
					if (priming_can_be_asked()) {
						// deactivated see ticket https://yalwa.atlassian.net/browse/DEV-7849
						//permission_priming(touchpoint);
						
						pub.ask_or_update_existing(touchpoint, touchpoint === 'update_existing');
						start_priming_timer();
					}
				} else {
					pub.ask_or_update_existing(touchpoint, touchpoint === 'update_existing');
				}
			}
		};
		
		pub.prerequisites_met = function() {
			if (pub.is_supported()
				&& yalwa.basics.is_logged_in()
				&& !yalwa.v.is_phonegap) {
				return true;
			}
			return false;
		};
		
		pub.unsubscribe = function() {
			let deferred = jQuery.Deferred();
			if (!pub.is_supported() || pub.is_denied()) {
				deferred.resolve(true);
			} else {
				try {
					navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
						return serviceWorkerRegistration.pushManager.getSubscription();
					}).then(function(subscription) {
						if (subscription) {
							yalwa.basics.ss_remove(cache_key_known);
							update_server(subscription, 'DELETE');
							subscription.unsubscribe();
						}
						deferred.resolve(true);
					});
				} catch (e) {
					yalwa.basics.sentry.submit_error(e);
					deferred.resolve(true);
				}
			}
			return deferred.promise();
		};
		
		pub.ask_or_update_existing = function(touchpoint, only_update) {
			if (!pub.is_supported()) {
				return;
			}
			try {
				navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
					return serviceWorkerRegistration.pushManager.getSubscription().catch((e) => {
						if (yalwa.mobile.burger) {
							yalwa.mobile.burger.show_push_options();
						}
					});
				}).then(function(subscription) {
					if (subscription && pub.is_granted()) {
						is_endpoint_known(subscription).done((is_known) => {
							if (!is_known) {
								update_server(subscription, 'POST');
							} else {
								jQuery('body').trigger('subscription_success');
							}
						});
					} else {
						ask_permission(touchpoint, only_update);
					}
				});
			} catch (e) {
				yalwa.basics.sentry.submit_error(e);
			}
		};
		
		pub.stored_notifications = function() {
			// see sw.js received_pushes for structure
			return yalwa.basics.ls_get(cache_key_recent_notifications, true) || [];
			;
		};
		
		pub.not_available_info = function() {
			if (yalwa.v.is_phonegap) {
				return;
			}
			if (!pub.is_supported()) {
				show_unavailable_label();
			} else if (pub.is_denied()) {
				show_denied_label();
			}
		};

		pub.process_single_push = function(notification) {
			if (!pub.is_supported() || !pub.is_granted() || !notification) {
			   return;
			}
		
			// Filter out notifications for other users
			if (yalwa.v.userID) {
				const pushUserID = notification.additionalData?.userID;
				if (pushUserID && parseInt(yalwa.v.userID) !== parseInt(pushUserID)) {
				   return;
				}
			}
			
			// Perform endpoint check if needed
			if (notification.additionalData?.endpointID) {
				check_confirm_endpoint(notification.additionalData.endpointID);
			}
		
			store_recent([notification]); // store_recent might expect an array
			jQuery.each(count_by_type([notification]), track_received);
		};
		
		pub.is_supported = function() {
			if (!yalwa.basics.sw.is_supported()) {
				return false;
			}
			if (!('PushManager' in window)) {
				return false;
			}
			if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
				return false;
			}
			if (typeof Notification !== 'function') {
				return false;
			}
			return true;
		}
		
		pub.is_default = function() {
			return permission_state() === 'default';
		}
		
		pub.is_denied = function() {
			return permission_state() === 'denied';
		}
		
		pub.is_granted = function() {
			return permission_state() === 'granted';
		}
		
		pub.notification_click = function(data, new_tab) {
			ga_clicked_pings(data.type_id).done(() => {
				if (new_tab) {
					return; // we've opened the url already
				}
				if (data.url_mobile) {
					if (data.url_mobile !== location.href) {
						yalwa.basics.navigate(data.url_mobile);
					}
				} else if (data.url) {
					yalwa.basics.navigate(data.url);
				}
			})
		}
		
		const priming_can_be_asked = () => {
			if (!jQuery('.js-webpush_priming').length) {
				return false;
			}
			
			if (yalwa.basics.get_routing() === 'mc' && parseInt(yalwa.basics.get_get('sl_index')) >= 1) {
				return false;
			}
			const start_time = parseInt(yalwa.basics.ls_get('priming_timer'));
			return yalwa.basics.is_logged_in() && start_time ? start_time + (1000 * 60 * 60 * 24) < new Date().getTime() : true; // it should be asked only every 24 hours for logged-in users
		}
		
		const start_priming_timer = () => yalwa.basics.is_logged_in() ? yalwa.basics.ls_set('priming_timer', new Date().getTime()) : '';
		
		function permission_priming(touchpoint) {
			if (!$generic_shadow) {
				$generic_shadow = jQuery('.js-generic_shadow');
			}
			if ($priming_dialog.length === 0) {
				assign_priming_elements();
			}
			$generic_shadow.on('click', close_priming.bind(this, touchpoint));
			$priming_close_button.on('click', close_priming.bind(this, touchpoint));
			yalwa.basics.show($generic_shadow);
			generic_shadow_opened = true;
			yalwa.basics.show($priming_dialog);
			priming_event_tracking(touchpoint, 'view');
			$priming_allow_button.off('click.priming_allow').on('click.priming_allow', permission_priming_click_handler.bind(this, touchpoint));
			adjust_permission_priming_button_size();
		}
		
		function assign_priming_elements() {
			$priming_dialog = jQuery('.js-webpush_priming');
			$priming_allow_button = jQuery('.js-webpush_priming_allow');
			$priming_close_button = jQuery('.js-webpush_priming_close');
		}
		
		function adjust_permission_priming_button_size() {
			let width = $priming_close_button.innerWidth() > $priming_allow_button.innerWidth() ? $priming_close_button.innerWidth() : $priming_allow_button.innerWidth();
			width = width < 145 ? 145 : width;
			$priming_allow_button.innerWidth(width);
			$priming_close_button.innerWidth(width);
		}
		
		function close_priming(touchpoint, event) {
			if (!$priming_dialog.is(':visible')) {
				return;
			}
			yalwa.basics.hide($generic_shadow);
			generic_shadow_opened = false;
			yalwa.basics.hide($priming_dialog);
			start_priming_timer();
			priming_event_tracking(touchpoint, 'click_no');
		}
		
		function permission_priming_click_handler(touchpoint, event) {
			priming_event_tracking(touchpoint, 'click_yes');
			pub.ask_or_update_existing(touchpoint, false);
		}
		
		const priming_event_tracking_touchpoint_mapping = {
			'mc-mobile-initial': 'my_locanto_mc',
			'mc-locanto-start': 'my_locanto_start',
			'mc-locanto-myads': 'my_locanto_ads',
			'my-locanto-purchases': 'my_locanto_purchases',
			'my-locanto-alerts': 'my_locanto_alerts',
			'my-locanto-followers': 'my_locanto_followers',
		}
		
		function priming_event_tracking(touchpoint, action) {
			if (!priming_event_tracking_touchpoint_mapping[touchpoint]) {
				return;
			}
			yalwa.basics.ga.event({
				category: 'plp_push_priming',
				action: 'plp_push_priming_' + action,
				label: 'plp_push_priming_' + priming_event_tracking_touchpoint_mapping[touchpoint]
			});
		}
		
		pub.permission_priming = permission_priming;
		
		function ga_clicked_pings(type) {
			const data = {
				category: 'push notification',
				action: 'clicked push',
				label: type + '|3'
			};
			return yalwa.basics.ga.ping_metric('CM_PN_CLICKED', 1, data);
		}
		
		function show_denied_label() {
			const $label_denied = jQuery('.js-webpush_disallowed_info');
			if ($label_denied.length) {
				$label_denied.removeClass('hidden');
			}
		}
		
		function show_unavailable_label() {
			const $label_unavailable = jQuery('.js-no_webpush_support_info');
			if ($label_unavailable.length) {
				$label_unavailable.removeClass('hidden');
			}
		}
		
		function permission_state() {
			if (typeof Notification === 'function' && Notification.permission !== 'undefined') {
				return Notification.permission;
			} else {
				return null;
			}
		}

		// Chrome 155+ on Android shows the notification prompt as an auto-hiding card
		// with a second opt-in entry point in Site Controls. Without this listener a
		// grant made there is only picked up on the next page load.
		function watch_permission_changes() {
			if (!navigator.permissions || typeof navigator.permissions.query !== 'function') {
				return;
			}
			try {
				navigator.permissions.query({name: 'notifications'}).then(function(permission_status) {
					permission_status.onchange = function() {
						if (permission_status.state === 'granted') {
							const touchpoint = yalwa.v.push_permission_touchpoint;
							if (touchpoint) {
								track_genstats(touchpoint, 'granted');
							}
							pub.ask_or_update_existing(touchpoint || 'update_existing');
						}
					};
				}).catch(function() {
					// permissions.query for 'notifications' is unsupported in some browsers
				});
			} catch (e) {
				yalwa.basics.sentry.submit_error(e);
			}
		}
		
		function ask_permission(touchpoint, only_update) {
			try {
				navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
					if (serviceWorkerRegistration.pushManager) {
						let track_it = false;
						let is_default = pub.is_default();
						if (pub.is_default()) {
							if (only_update) {
								return false;
							}
						}
						const denied_before_already = pub.is_denied();
						serviceWorkerRegistration.pushManager.subscribe({
							userVisibleOnly: true,
							applicationServerKey: key_array
						}).then(function(subscription) {
							if (is_default) {
								track_genstats(touchpoint, 'asked');
								track_it = true;
							}
							if (subscription) {
								on_allow(touchpoint, track_it);
								update_server(subscription, 'POST');
							} else {
								on_disallow(touchpoint, denied_before_already);
								return false;
							}
						}, function(error) {
							if (pub.is_denied()) {
								if (is_default) {
									track_genstats(touchpoint, 'asked');
									track_it = true;
								}
								on_disallow(touchpoint, denied_before_already);
							} else {
								// since we do not trigger native push dialog without user gesture/interactions not needed any more
								// could be firefox or other browsers needing user gesture/interactions
								//permission_priming(touchpoint);
							}
						});
					}
				}, function(error) {
					yalwa.basics.sentry.submit_error(error);
				})
			} catch (e) {
				if (Notification.permission === 'denied') {
					// console.warn('Notifications are denied by the user.');
				} else {
					yalwa.basics.sentry.submit_error(e);
				}
			}
			
		};
		
		function update_server(subscription, method) {
			let key = subscription.getKey('p256dh');
			let token = subscription.getKey('auth');
			let data = {
				'method': method,
				'endpoint': subscription.endpoint,
				'key': key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
				'token': token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
				'fingerprintID': yalwa.basics.fingerprint.getID() || 0
			}
			if (yalwa.v.userID) {
				data.userID = yalwa.v.userID;
			}
			let url = '/api/ajax/push_subscription';
			yalwa.basics.beacon(url, data);
			if (method === 'POST') {
				jQuery('body').trigger('subscription_success');
			}
			
		}
		
		function is_endpoint_known(subscription) {
			let is_known_cache = yalwa.basics.ss_get(cache_key_known, true) || {};
			if (yalwa.basics.session_storage_age() > 60 * 60) {
				is_known_cache = {};
			}
			let deferred = jQuery.Deferred();
			if (!subscription || !subscription.endpoint) {
				deferred.resolve(false);
			} else {
				if (is_known_cache[subscription.endpoint]) {
					deferred.resolve(true);
				} else {
					const data = {
						method: 'POST',
						check_subscription: true,
						endpoint: subscription.endpoint
					};
					if (yalwa.basics.is_logged_in()) {
						data.logged_in = true;
					}
					jQuery.ajax({
						url: '/api/ajax/push_subscription',
						type: 'post',
						data: data,
						dataType: 'json'
					}).done(function(r) {
						if (r.status === 'subscribed') {
							is_known_cache[subscription.endpoint] = true;
							deferred.resolve(true);
						} else {
							delete is_known_cache[subscription.endpoint];
							deferred.resolve(false);
						}
						yalwa.basics.ss_set(cache_key_known, is_known_cache);
					}).fail(function(e) {
						deferred.resolve(false);
					});
				}
			}
			return deferred.promise();
		}
		
		function urlBase64ToUint8Array(base64String) {
			let padding = '='.repeat((4 - base64String.length % 4) % 4);
			let base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
			
			let rawData = window.atob(base64);
			let outputArray = new Uint8Array(rawData.length);
			
			for (let i = 0; i < rawData.length; ++i) {
				outputArray[i] = rawData.charCodeAt(i);
			}
			
			return outputArray;
		}
		
		function check_confirm_endpoint(endpointID) {
			let cache = yalwa.basics.ls_get(cache_key_confirmation, true) || {};
			if (!cache[endpointID]) {
				confirm_endpoint(endpointID);
				cache[endpointID] = true;
				yalwa.basics.ls_set(cache_key_confirmation, cache);
			}
		}
		
		function confirm_endpoint(endpointID) {
			const data = {
				method: 'POST',
				confirm_subscription: true,
				endpointID: endpointID
			}
			if (yalwa.basics.is_logged_in()) {
				data.logged_in = true;
			}
			return jQuery.post({
				url: '/api/ajax/push_subscription',
				data: data
			});
		}
		
		function store_recent(notifications) {
			let cache = yalwa.basics.ls_get(cache_key_recent_notifications, true) || [];
			jQuery.each(notifications, function(index, notification) {
				if (notification.message) {
					cache.push(notification);
				}
			});
			if (cache.length > recent_notifications_max) {
				cache = cache.slice(cache.length - recent_notifications_max, cache.length);
			}
			if (cache.length) {
				yalwa.basics.show(jQuery('.js-push_history_burger'));
			}
			yalwa.basics.ls_set(cache_key_recent_notifications, cache);
		}
		
		function count_by_type(notifications) {
			let track_events = {};
			jQuery.each(notifications, function(index, notification) {
				let type = notification.type_id;
				if (!track_events.type) {
					track_events[type] = 0;
				}
				track_events[type]++;
			});
			return track_events;
		}
		
		function on_allow(touchpoint, track_it) {
			close_priming();
			jQuery('.js-webpush_priming,.js-webpush_ask,.js-webpush_denied').remove();
			if (track_it) {
				track_allow(touchpoint);
			}
		}
		
		function on_disallow(touchpoint, denied_before_already) {
			yalwa.basics.toast(
				{
					message: yalwa.v.lang.push_permissions_blocked,
					type: 'warning',
					progressBar: true,
					timeOut: 4000,
					extendedTimeOut: 2000
				});
			jQuery('.js-webpush_priming,.js-webpush_denied').remove();
			if (generic_shadow_opened) {
				yalwa.mobile.generic_shadow.hide();
			}
			
			if (!denied_before_already) {
				track_disallow(touchpoint);
			}
		}
		
		function track_disallow_error_message_showed(touchpoint) {
			yalwa.basics.ga.event({
				category: 'webpush_disallowed_native',
				action: 'mobile',
				label: touchpoint + ' | ' + yalwa.basics.get_routing()
			});
		}
		
		function track_disallow(touchpoint) {
			yalwa.basics.ga.event({
				category: 'webpush_mc',
				action: 'disallowed-native',
				label: touchpoint + ' | ' + yalwa.basics.get_routing()
			});
			track_genstats(touchpoint, 'denied');
		}
		
		function track_allow(touchpoint) {
			yalwa.basics.ga.event({
				category: 'webpush_mc',
				action: 'allowed-native',
				label: touchpoint + ' | ' + yalwa.basics.get_routing()
			});
			track_genstats(touchpoint, 'granted');
		}
		
		function track_genstats(touchpoint, metric) {
			const pg = yalwa.basics.ss_get('push_genstats', true) || {};
			const k = touchpoint + '_' + metric;
			if (pg[k]) { // log once per session
				return;
			}
			if (yalwa.basics.tracking_quota_add_and_check()) {
				return;
			}
			pg[k] = 1;
			yalwa.basics.ss_set('push_genstats', pg);
			yalwa.basics.beacon('/api/ajax/track', {
				t: 'push',
				touchpoint: touchpoint,
				metric: metric,
				app_type: yalwa.basics.app_type()
			});
			
		}
		
		function track_received(type_name, count) {
			const data = {
				category: 'push notification',
				action: 'received push',
				label: type_name + '|3',
				value: count
			};
			yalwa.basics.ga.ping_metric('CM_PN_RECEIVED', count, data);
		}
		
		return pub;
		
	}(pub.webpush));
	
	pub.auth = (function(pub) {
		
		var module;
		
		pub = pub || {};
		
		pub.redirect_to = false;
		
		pub.init = function() {
			module = yalwa.mobile.auth;
			module.update_login_handlers();
			module.update_logout_handlers();
			if (module.autoload()) {
				module.show_dialog();
			}
			pub.module = module;
		};
		
		pub.credential_api_support = function() {
			if (!window.PasswordCredential) {
				return false;
			}
			if (!window.PublicKeyCredential) {
				return false;
			}
			if (!navigator.credentials) {
				return false;
			}
			if (typeof (navigator.credentials.get) !== 'function') {
				return false;
			}
			return true;
		};
		pub.register = function(email) {
			return jQuery.ajax({
				type: 'post',
				url: '/api/ajax/general',
				dataType: 'json',
				data: {
					action: 'register_attempt',
					email: email,
					is_dol: yalwa.v.is_dol,
					areaID: yalwa.v.areaID
				}
			});
		};
		
		pub.login = function({ email, pw, keep, csrf_key, csrf_value, url = null, otp_token = null, remember_browser = false, fp_hash = null}) {
			let msgID = null;
			let redirect_url = false;
			const redirect_blacklist = ['#'];
			const redirect_to = yalwa.basics.auth.redirect_to;
			if (redirect_to && redirect_blacklist.indexOf(redirect_to) === -1) {
				try {
					redirect_url = new URL(yalwa.basics.auth.redirect_to);
				} catch (error) {
					yalwa.basics.sentry.submit_error("Failed to construct 'URL': Invalid URL: " + yalwa.basics.auth.redirect_to);
				}
			}
			if (yalwa.basics.get_isset('paf') && yalwa.basics.get_isset('manage')) {
				if (yalwa.basics.get_get('continue')) {
					let result = yalwa.basics.get_get('continue').match(/manage\/([0-9]+)\//);
					if (result && result[1]) {
						msgID = result[1];
					}
				}
			}
			const data = {
				action: 'login_attempt',
				email: email,
				pwd: pw,
				stay_logged_in: keep,
				is_dol: yalwa.v.is_dol,
				msgID: msgID,
				otp_token: otp_token,
				remember_browser: remember_browser,
				fp_hash:fp_hash,
			};
			if (redirect_url) {
				data.o = redirect_url.searchParams.get("o");
				data.os = redirect_url.searchParams.get("os");
			}
			if (pub.o) {
				data.o = pub.o;
			}
			if (pub.os) {
				data.os = pub.os;
			}
			data[csrf_key] = csrf_value;
			
			return jQuery.ajax({
				type: 'post',
				url: (url && location.port) ? url : '/api/ajax/general',
				dataType: 'json',
				data: data,
				xhrFields: {
					withCredentials: true
				}
			});
		};
		
		pub.logout = function() {
			return jQuery.ajax({
				type: 'post',
				url: '/api/ajax/general',
				dataType: 'json',
				data: {
					action: 'logout_attempt'
				},
				xhrFields: {
					withCredentials: true
				}
			});
		};
		
		pub.touchpoint_parameter = function(id) {
			return 'tp';
		};
		
		pub.gsi = (function(pub) {
			
			pub = pub || {};
			let select_by = null;
			const WINDOW_GOOGLE_IS_NOT_AVAILABLE = 1;
			const WINDOW_GOOGLE_ACCOUNTS_IS_NOT_AVAILABLE = 2;
			const BUTTON_ELEMENT_IS_NOT_AVAILABLE = 3;
			const CONTEXT_IS_NOT_VALID = 4;
			
			pub.black_listed_routes_for_one_tap = [
				'account_activation',
				'demo',
				'logout',
				'PAF_recently_edited',
				'yifp',
				'book-upgrade',
				'cart',
				'checkout',
				'confirm'
			];
			
			pub.init = function() {
				pub.black_listed_routes_for_one_tap.push('login', 'registration');
				if (!pub.context_valid(true)) {
					return;
				}
				load_library().then(() => {
					// one-tap uses FedCM which is not compatible with non-standard ports (80/443),
					// so it can't work on DEV -> don't show the dialog
					if (location.port) {
						return;
					}
					google_accounts_prompt();
				});
			};
			
			function load_library() {
				const deferred = jQuery.Deferred();
				
				yalwa.basics.load_js(yalwa.v.gsi_client_url, function() {
					if (!window.google) {
						deferred.reject(WINDOW_GOOGLE_IS_NOT_AVAILABLE);
						return deferred.promise();
					}
					if (!window.google.accounts) {
						deferred.reject(WINDOW_GOOGLE_ACCOUNTS_IS_NOT_AVAILABLE);
						return deferred.promise();
					}
					google_accounts_initialize();
					deferred.resolve('library loaded');
					
				}, null, true, ['async', 'defer']);
				
				return deferred.promise();
			}
			
			pub.context_valid = function(is_init, context) {
				if (yalwa.basics.is_logged_in()) {
					return false;
				}
				
				// Google Login: Error 403: This user-agent is not permitted to make an OAuth authorization request to Google as it is classified as an embedded user-agent (disallowed_useragent)
				if (yalwa.v.is_phonegap) {
					return false;
				}
				if (!context && pub.black_listed_routes_for_one_tap.indexOf(yalwa.basics.get_routing()) !== -1) {
					return false;
				}
				if (!yalwa.basics.gdpr_consent_given('essential')) {
					return false;
				}
				
				return true;
			};
			
			function is_button_renderable() {
				const deferred = jQuery.Deferred();
				const $elements = jQuery('.js-login_alternatives_google');
				if (!pub.context_valid(false, 'gsi_button')) {
					deferred.reject(CONTEXT_IS_NOT_VALID);
				}
				// if there are no elements reject
				if ($elements.length) {
					deferred.resolve($elements);
				} else {
					deferred.reject(BUTTON_ELEMENT_IS_NOT_AVAILABLE);
				}
				
				return deferred.promise();
			}
			
			pub.render_button = function() {
				if (yalwa.v.is_phonegap) {
					return;
				}
				if (!pub.context_valid(false, 'gsi_button')) {
					remove_alternatives_container();
					return;
				}
				load_library()
					.then(is_button_renderable)
					.then(init_visibility_observer)
					.fail(error_code => {
						if (
							error_code === BUTTON_ELEMENT_IS_NOT_AVAILABLE ||
							error_code === CONTEXT_IS_NOT_VALID
						) {
							remove_alternatives_container();
						}
					})
			};
			// dummy function
			pub.button_on_click_handler = function() {
			};
			
			// initialize it again by visibility changes
			// this is on ajax login the case login/register
			function init_visibility_observer($elements) {
				const options = {
					rootMargin: '0px',
					threshold: 0.9 // safari fix the threshold only reach .9xx
				};
				const observer = new IntersectionObserver(observer_callback, options);
				
				function observer_callback(changes, observer) {
					changes.forEach(change => {
						// visible
						if (change.intersectionRatio > 0.9) {
							google.accounts.id.renderButton(
								change.target,
								{
									theme: 'filled_blue',
									size: 'large',
									text: 'continue_with',
									width: 260,
									click_listener: pub.button_on_click_handler
								}
							);
						}
					});
				}
				
				$elements.each(function() {
					observer.observe(jQuery(this)[0]);
				})
			}
			
			function remove_alternatives_container() {
				const $register_container = jQuery('.js-ajax_register_social_section');
				const $register_form = jQuery('.js-register_form');
				const $or = $register_form.find('.js-or');
				$register_container.remove();
				$or.remove();
				yalwa.basics.show($register_form);
				
			}
			
			var gsi_initialized = false;

			function google_accounts_initialize() {
				if (gsi_initialized) {
					return;
				}
				gsi_initialized = true;
				google.accounts.id.initialize({
					client_id: yalwa.v.gsi_client_id,
					itp_support: true, // activate google-one-tap on safari
					use_fedcm_for_prompt: true,
					callback: handle_gs_credential_response
				});
			}
			
			function google_accounts_prompt() {
				google.accounts.id.prompt();
			}
			
			pub.on_success_callback = function() {
				// can be overwritten from outside
			};
			
			pub.set_select_by = function(value) {
				select_by = value;
			};
			
			async function handle_gs_credential_response(response) {
				if (response.credential) {
					let data = {
						action: 'login_social',
						type: 'google',
						credential: response.credential,
						select_by: select_by ? select_by : response.select_by,
						fp_hash: await yalwa.basics.fingerprint.get_hash(),
					};
					pub.request(data).done(async (response) => {
						if (response.success) {
							if (response.result === 'twofactor_needed') {
								await yalwa.basics.import_js('shared/web_components/twofactor.js');
								jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
								jQuery('yalwa-twofactordialog')[0].request_action('code', {email: response.email});
								twofactor_listeners(data);
							} else{
								on_login_response();
							}
						}
					});
				}
			}
			
			pub.request = function(data) {
				return jQuery.ajax({
					url: '/api/ajax/general',
					type: 'post',
					dataType: 'json',
					cache: false,
					data: data
				});
			}
			return pub;
		}(pub.gsi));
		
		return pub;
		
	}(pub.auth));

	function on_login_response() {
		yalwa.basics.auth.gsi.on_success_callback();
		if (yalwa.basics.auth.redirect_to) {
			yalwa.basics.navigate(yalwa.basics.auth.redirect_to)
		} else {
			yalwa.basics.reload();
		}
	}
	
	function twofactor_listeners(login_params) {
		jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
			const data = event.originalEvent.detail;
			login_params.otp_token = data.code || data.backup_code;
			login_params.remember_browser = data.remember_browser;
			yalwa.basics.auth.gsi.request(login_params).done((response) => {
				if (response.result === 'twofactor_needed') {
					jQuery('yalwa-twofactordialog')[0].show_invalid();
				} else {
					on_login_response(response);
				}
			});
		});
	}
	
	pub.is_app = function() {
		return yalwa.v.is_phonegap || yalwa.basics.is_pwa();
	};
	
	/**
	 * @desc method loads tippy library JavaScript and CSS files
	 * @returns {*}
	 */
	pub.load_tippy = function() {
		var deferred = jQuery.Deferred();
		yalwa.basics.load_js('https://unpkg.com/@popperjs/core@2.1.1/dist/umd/popper.min.js', () => {
			yalwa.basics.load_js('https://unpkg.com/tippy.js@6.1.0/dist/tippy-bundle.umd.min.js', () => deferred.resolve(true));
		});
		yalwa.basics.load_css('https://unpkg.com/tippy.js@6.1.0/dist/tippy.css');
		return deferred.promise();
	};
	
	function bem_modifier_get($element) {
		let bem_class;
		if ($element.data('bem')) {
			bem_class = $element.data('bem');
		} else {
			// search for the first class name without a "js-" prefix and not being a modifier itself
			jQuery.each($element.attr('class').split(' '), (i, name) => {
				if (!bem_class && name.indexOf('js-') !== 0 && name.indexOf('--') === -1) {
					bem_class = name;
				}
			});
		}
		return bem_class;
	}
	
	function modifier_helper(class_final, $element, action) {
		action = action || 'toggle';
		if (action === 'add') {
			$element.addClass(class_final);
		} else if (action === 'remove') {
			$element.removeClass(class_final);
		} else if (action === 'toggle') {
			$element.toggleClass(class_final);
		}
	};
	
	pub.bem_modifier = function($element, modifier, action) {
		if ($element.length > 1) {
			$element.each((i, e) => {
				const $e = jQuery(e);
				modifier_helper(bem_modifier_get($e) + '--' + modifier, $e, action)
			})
		} else {
			modifier_helper(bem_modifier_get($element) + '--' + modifier, $element, action);
		}
	};
	
	pub.pwa_promos = (function(pub) {
		pub = pub || {};
		
		function pwa_promo_track_header_impression() {
			yalwa.basics.ga.event({
				category: 'pwa_promo',
				action: 'impression',
				label: yalwa.v.is_logged_in === undefined ? 'logged_out' : 'logged_in' + '_header'
			});
		}
		
		function pwa_promo_eligible() {
			if (yalwa.basics.is_pwa() || !yalwa.basics.ss_get('pwa_promo_pageview') || yalwa.basics.get_cookie('pwa_promo')) {
				return false;
			}
			if (yalwa.v.is_logged_in) {
				return true;
			}
			return yalwa.basics.ss_get('pwa_promo_pageview') === '5';
		}
		
		pub.init_close_android_promo_listener = function() {
			jQuery('.js-pwa_promotion_close').on('click', () => {
				yalwa.basics.overlay.unregister('pwa_head');
				jQuery('.js-pwa_promotion_topbar').remove();
				yalwa.basics.bem_modifier(jQuery('.js-main_col'), 'pwa_promo', 'remove');
				yalwa.basics.set_cookie('pwa_promo', 1, yalwa.basics.ONE_MONTH);
				yalwa.basics.ga.event({
					category: 'pwa_promo',
					action: 'dismiss',
					label: yalwa.v.is_logged_in === undefined ? 'logged_out' : 'logged_in' + '_header'
				});
			});
		}
		
		pub.init_pwa_promo_ios = function() {
			if (yalwa.v.is_ios && !yalwa.v.is_dol && pwa_promo_eligible()) {
				jQuery(window).on('load', function() {
					if (jQuery('.js-pwa_promotion__ios').length > 0 && yalwa.basics.overlay.register('pwa_ios', true)) {
						jQuery('.js-pwa_promotion__ios').addClass('pwa_promotion__ios--show');
						pwa_promo_track_header_impression();
					}
				});
				jQuery('.js-pwa_promotion__ios_close').on('click', () => {
					yalwa.basics.overlay.unregister('pwa_ios');
					jQuery('.js-pwa_promotion__ios').removeClass('pwa_promotion__ios--show');
					yalwa.basics.set_cookie('pwa_promo', 1, yalwa.basics.ONE_MONTH);
					yalwa.basics.ga.event({
						category: 'pwa_promo',
						action: 'dismiss',
						label: yalwa.v.is_logged_in === undefined ? 'logged_out' : 'logged_in' + '_header'
					});
				});
			}
		}
		
		pub.init_pwa_promo_android = function() {
			if (!yalwa.v.is_ios && !yalwa.v.is_dol && pwa_promo_eligible()) {
				yalwa.basics.set_cookie('pwa_promo_eligible', 1, yalwa.basics.ONE_MONTH);
				jQuery(window).on('load', function() {
					if (jQuery('.js-pwa_promotion_topbar').length > 0) {
						pwa_promo_track_header_impression();
					}
				});
			}
		}
		
		return pub;
	}(pub.pwa_promos));
	
	pub.overlay = (function(pub) {
		
		pub = pub || {};
		
		let current_shown;
		
		pub.init = function() {
			if (typeof Set === 'undefined') {
				return;
			}
			current_shown = new Set();
		};
		
		pub.current_count = function() {
			return current_shown ? current_shown.size : 0;
		};
		
		pub.register = function(id, non_obtrusive) {
			if (non_obtrusive && pub.current_count() > 0) {
				return false;
			}
			if (current_shown && !current_shown.has(id)) {
				current_shown.add(id);
				return true;
			}
			return false;
		};
		
		pub.unregister = function(id) {
			if (current_shown && current_shown.has(id)) {
				current_shown.delete(id);
				return true;
			}
			return false;
		};
		
		return pub;
		
	}(pub.overlay));
	
	pub.tracking_quota_add_and_check = function() { // precaution when some loop is going wild
		const key = 'tracking_pings' + (Math.floor(yalwa.basics.unix() / 300)); // check in 5 minute intervals
		const threshold = 50;
		const count = parseInt(yalwa.basics.ss_get(key)) || 0;
		yalwa.basics.ss_set(key, count + 1);
		const too_much = count > threshold && !location.port;
		return too_much;
	};
	
	pub.after_logout_handler = function() {
		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.cordova_send({action: 'logout', params: {}});
		}
		
		ls_flush();
		
		//chrome will showing on back/forward button usage cached html. DEV-1069
		if (window.chrome) {
			yalwa.basics.state.prevent_back_button_caching(yalwa.v.chp_url);
		}
	};
	
	pub.load_template_once = function(name, $to_check, $append_to, data) {
		const $body = jQuery('body');
		$append_to = $append_to || $body;
		const deferred = jQuery.Deferred();
		if ($to_check.length) {
			deferred.resolve();
			return deferred.promise();
		}
		var data_final = {
			action: name,
		};
		if (data) {
			data_final = jQuery.extend(data_final, data);
		}
		jQuery.ajax({
			url: '/api/ajax/general',
			dataType: 'html',
			cache: false,
			data: data_final
		}).done(function(result) {
			if (is_json_string(result)) {
				const parsed_result = JSON.parse(result);
				const ycomponent_handler = yalwa.mobile.assets_loader();
				parsed_result.$append_to = $append_to;
				ycomponent_handler.load_assets_and_append_html(parsed_result).then(deferred.resolve);
				if (parsed_result.all_js_variables) {
					ycomponent_handler.load_assets_only({js_variables: parsed_result.all_js_variables});
				}
			} else {
				$append_to.append(result);
				deferred.resolve();
			}
		});
		return deferred.promise();
	};
	
	function is_json_string(string) {
		try {
			JSON.parse(string);
		} catch (e) {
			return false;
		}
		return true;
	}
	
	pub.load_template_json_once = function(name, $to_check, $append_to, data) {
		const $body = jQuery('body');
		const deferred = jQuery.Deferred();
		$append_to = $append_to || $body
		if ($to_check.length) {
			deferred.resolve();
		}
		var data_final = {
			action: name,
			gsi_support: yalwa.basics.auth.gsi.context_valid(false, 'gsi_button')
		};
		if (data) {
			data_final = jQuery.extend(data_final, data);
		}
		jQuery.ajax({
			url: '/api/ajax/general',
			dataType: 'JSON',
			cache: false,
			data: data_final
		}).done(function(result) {
			if (result.success) {
				$append_to.append(result.html);
				deferred.resolve(result.data);
			}
		}).fail(function() {
			deferred.reject();
		});
		return deferred.promise();
	};
	
	function prepare_cached_bst_dol_promo() {
		const $dol_promos = jQuery('.js-dol_promo');
		top_extension_handling($dol_promos);
		category_badge_handling($dol_promos);
	}
	
	function get_prev_ad($promo) {
		let $prev_ad = $promo.prev();
		if ($prev_ad.hasClass('js-asc')) {
			$prev_ad = $prev_ad.prev();
		}
		return $prev_ad;
	}
	
	function top_extension_handling($dol_promos) {
		$dol_promos.each(function() {
			const $promo = jQuery(this);
			const $prev_ad = get_prev_ad($promo);
			const has_cached_top_ad_html = $prev_ad.find('.js-top_ad').length > 0;
			if (has_cached_top_ad_html) {
				yalwa.basics.show($promo.find('.js-top_ad'));
			} else {
				yalwa.basics.bem_modifier($promo, 'top', 'remove');
			}
		})
	}
	
	function category_badge_handling($dol_promos) {
		$dol_promos.each(function() {
			const $promo = jQuery(this);
			const $prev_ad = get_prev_ad($promo);
			const has_cached_before_ad_category_badge = $prev_ad.find('.js-bst_list_item_category').length > 0;
			if (has_cached_before_ad_category_badge) {
				yalwa.basics.show($promo.find('.js-bst_list_item_category'));
			}
		})
	}
	
	function check_for_ignored_postings() {
		if (yalwa.basics.is_logged_in() && yalwa.v.has_ignored_emailIDs) {
			let $listings = jQuery('.js-bst_list_item,.js-bp_listing');
			const msgIDs = $listings.map((i, e) => jQuery(e).data('msgid')).get().filter(Boolean);
			if (!msgIDs.length) {
				return;
			}
			const callback = (response) => {
				if (response && response.msgIDs && response.msgIDs.length) {
					const $to_hide = $listings.filter(function() {
						return response.msgIDs.indexOf(jQuery(this).data('msgid')) !== -1;
					});
					yalwa.basics.hide($to_hide);
					let last_visited_ads = yalwa.basics.ss_get('last_visited_ads', true) || [];
					last_visited_ads = last_visited_ads.filter((ad) => {
						return response.msgIDs.indexOf(Number(ad.msgID)) === -1;
					});
					yalwa.basics.ss_set('last_visited_ads', last_visited_ads);
					yalwa.basics.show(
						jQuery('.js-show_ignored')
							.html(response.label)
							.on('click', () => {
								yalwa.basics.show($to_hide);
								jQuery('.js-show_ignored').remove();
							})
					);
				}
			};
			const cache_key = 'ignored_postings_' + yalwa.basics.simple_hash(JSON.stringify(msgIDs.sort()));
			const cached_response = yalwa.basics.ss_get(cache_key, true);
			if (cached_response) {
				callback(cached_response);
			} else {
				jQuery.ajax({
					url: '/api/ajax/general',
					type: 'post',
					dataType: 'json',
					data: {
						action: 'check_ignored_emails',
						msgIDs: msgIDs
					}
				}).done((response) => {
					yalwa.basics.ss_set(cache_key, response);
					callback(response);
				});
			}
		}
	}
	
	function login_touch_point_check() {
		if (yalwa.basics.is_logged_in() && yalwa.basics.ss_get('login_touch_point')) {
			yalwa.basics.ga.event({
				category: yalwa.basics.ss_get('login_touch_point'),
				action: 'login successful',
			});
			yalwa.basics.ss_remove('login_touch_point');
		}
	}
	
	pub.login_touch_point_set = function(touch_point) {
		yalwa.basics.ss_set('login_touch_point', touch_point, yalwa.basics.unix() + (2 * 60));
	};
	
	pub.login_track_cta_click_add = function($plp, last_tp) {
		$plp.on('click', 'a', e => {
			e.preventDefault();
			login_track_cta_click($plp, last_tp, false);
		});
		$plp.on('plp_hide', () => yalwa.basics.auth.gsi.set_select_by(null));
		yalwa.basics.auth.gsi.set_select_by($plp.data('id'));
		yalwa.basics.auth.gsi.on_success_callback = () => login_track_cta_click($plp, last_tp, true);
	}
	
	function login_track_cta_click($plp, label, onlytrack) {
		const $button = $plp.find('.ysb-highlight');
		const url = $button.attr('href');
		let cat;
		if ($plp.hasClass('js-reveal_number_plp')) {
			cat = 'reveal_number';
		} else if ($plp.hasClass('js-contact_vap_plp')) {
			cat = 'vap_contact';
		} else if ($plp.hasClass('js-show_posting_images_plp')) {
			cat = 'show_posting_images';
		} else if ($plp.hasClass('js-reveal_images_plp')) {
			cat = 'reveal_images';
		} else {
			return;
		}
		const event_data = {
			category: cat,
			action: 'logged-out: cta click ' + (url.indexOf('register') === -1 ? 'login' : 'register'),
		};
		if (label) {
			event_data.label = label;
		}
		yalwa.basics.ga.event(event_data).done(() => {
			yalwa.basics.login_touch_point_set(cat);
			if (!onlytrack) {
				yalwa.basics.navigate(url);
			}
		})
		return false;
	}
	
	function handle_email_change_toast() {
		if (yalwa.v.email_change_label) {
			if (yalwa.v.email_change_status === 'success') {
				yalwa.basics.toast({message: yalwa.v.email_change_label, type: 'success'});
			} else if (yalwa.v.email_change_status === 'error') {
				yalwa.basics.toast({message: yalwa.v.email_change_label, type: 'error'});
			}
		}
	}
	
	pub.simple_auto_slide = function(args) {
		const default_options = {
			container: null,
			css_prefix: '',
			container_class: 'js-simple_auto_slide',
			element_class: 'js-simple_auto_slide_item',
			bullets: {
				container_class: false
			},
			on_slide_displayed: false,
			timeout: 4000,
			arrows: {
				append_to: false,
				enabled: false,
				size: 9,
				directions: {
					left: {
						icon: 'arrowleft',
						folder: 'main',
					},
					right: {
						icon: 'arrowright',
						folder: 'main'
					}
				},
			},
			use_visibility_change_handler: true,
			clickable: true
		};
		let id,
			error,
			options,
			$container,
			$slide_items,
			$bullet_container,
			$arrow_container,
			$elements,
			slide_index = 0,
			scheduled_slide,
			slide_height = 0,
			hammer,
			slide_url,
			$element_with_url;
		const visibility_change_handler = () => document.hidden ? stop() : slide();
		const stop = () => clearTimeout(scheduled_slide);
		const hide_all = () => yalwa.basics.hide($elements);
		const determine_index = (direction) => {
			switch (direction) {
				case 'previous':
					return slide_index - 1 < 0 ? $elements.length - 1 : slide_index - 1;
				case 'next':
					return slide_index + 1 > $elements.length - 1 ? 0 : slide_index + 1;
			}
		}
		const set_current_index = index => {
			slide_index = index;
			if (options.on_slide_displayed) {
				options.on_slide_displayed(jQuery($elements[slide_index]));
			}
		}
		const get_current_index = () => {
			return slide_index;
		}
		const slide = (initial) => {
			initial = initial || false;
			stop();
			hide_all();
			reset_bullets();
			const next_index = determine_index('next');
			yalwa.basics.show(jQuery($elements[next_index]));
			jQuery($elements[next_index]).velocity('transition.slideRightIn', {
				duration: initial ? 0 : 250,
				display: 'grid'
			});
			jQuery($container.find('.js-bullet')[next_index]).addClass('selected');
			if (options.timeout) {
				scheduled_slide = setTimeout(() => slide(), options.timeout);
			}
			set_current_index(next_index);
			count(slide_index);
		}
		const slide_to = (index) => {
			stop();
			hide_all();
			reset_bullets();
			const next_index = index;
			yalwa.basics.show(jQuery($elements[next_index]));
			jQuery($elements[next_index]).velocity('transition.slideRightIn', {duration: 250, display: 'grid'});
			jQuery($container.find('.js-bullet')[next_index]).addClass('selected');
			if (options.timeout) {
				scheduled_slide = setTimeout(() => slide(), options.timeout);
			}
			set_current_index(next_index);
			count(slide_index);
		}
		const slide_to_previous = () => {
			stop();
			hide_all();
			reset_bullets();
			const next_index = determine_index('previous');
			yalwa.basics.show(jQuery($elements[next_index]));
			jQuery($elements[next_index]).velocity('transition.slideLeftIn', {duration: 250, display: 'grid'});
			jQuery($container.find('.js-bullet')[next_index]).addClass('selected');
			if (options.timeout) {
				scheduled_slide = setTimeout(() => slide(), options.timeout);
			}
			set_current_index(next_index);
			count(slide_index);
		}
		const count = (index) => {
			const $counter = $container.find('.js-simple_auto_slide_count');
			$counter.html(index + 1);
		}
		const reset_bullets = () => $container.find('.js-bullet').removeClass('selected');
		const add_bullets = () => {
			$bullet_container = jQuery('<div class="js-bullet_container"></div>').addClass(options.css_prefix + 'simple_auto_slide_bullet_container');
			$bullet_container.appendTo((options.bullets && options.bullets.container_class) ? $container.find('.' + options.bullets.container_class) : $container);
			for (let i = 0; i < $elements.length; i++) {
				let $bullet = jQuery('<div class="js-bullet"></div>').addClass(options.css_prefix + 'simple_auto_slide_bullet');
				$bullet.appendTo($bullet_container);
			}
			
		}
		const add_arrows = () => {
			const $append_to = options.arrows.append_to || $container;
			$arrow_container = jQuery('<div class="js-arrow_container simple_auto_slide_arrow_container"></div>').addClass(options.css_prefix + 'simple_auto_slide_arrow_container');
			$arrow_container.appendTo($append_to);
			for (const [direction, properties] of Object.entries(options.arrows.directions)) {
				let icon = yalwa.basics.yicon(properties.icon, {
					pixel: options.arrows.size,
					folder: properties.folder,
					alt: properties.hasOwnProperty('alt') ? properties.alt : ''
				});
				let icon_html = '<button class="js-arrow arrow_icon" data-direction="' + direction + '">' + icon + '</button>';
				let $arrow = jQuery(icon_html).addClass(options.css_prefix + 'simple_auto_slide_arrow');
				$arrow.appendTo($arrow_container);
				$arrow_container.find('.js-arrow[data-direction="' + direction + '"]').on('click', arrow_click_handler.bind(this, direction));
			}
		}
		const arrow_click_handler = (direction, event) => {
			event.stopPropagation(); // arrows are in main slider container and positioned absolutely, to avoid click trigger on the main container since main container can have another event we should stop the propagation
			switch (direction) {
				case 'left':
					slide_to_previous();
					break;
				case 'right':
					slide();
					break;
			}
			get_options().arrows.directions[direction].callback?.(event);
		}
		const get_options = () => {
			return options;
		}
		const slide_click_handler = (event) => {
			slide_url = jQuery(event.currentTarget).find('a').prop('href');
			if (slide_url) {
				yalwa.basics.navigate(slide_url);
			}
		}
		const handle_ovw_urls = _ => {
			$elements.each(function() {
				let url = false;
				$element_with_url = jQuery(this).find('a');
				slide_url = $element_with_url.prop('href');
				if (slide_url) {
					url = new URL(slide_url);
				}
				if (slide_url && url && url.pathname.startsWith('/m/')) {
					$element_with_url.prop('href', slide_url.replace('/m/', `/${yalwa.v.path_segment}/`));
				}
			})
		}
		const add_click_handler = _ => $elements.on('click', slide_click_handler);
		const add_pan_events = _ => {
			hammer = new Hammer($container[0], {});
			hammer.get('swipe').set({
				direction: Hammer.DIRECTION_HORIZONTAL,
				velocity: 0.3   // Require faster swipe (higher velocity)
			});
			hammer.on('swipeleft swiperight', function(event) {
				if (event.type === 'swipeleft') {
					slide();
				} else if (event.type === 'swiperight') {
					slide_to_previous()
				}
				get_options().arrows.directions[event.type === 'swipeleft' ? 'left' : 'right'].callback?.(event);
			});
		}
		const determine_slide_height = $element => {
			if (slide_height < $element.height()) {
				slide_height = $element.height();
			}
		}
		const set_slide_height = _ => {
			$slide_items.height(slide_height);
		}
		const show = () => {
			yalwa.basics.show($container);
			yalwa.basics.show($arrow_container);
		};
		const hide = () => {
			yalwa.basics.hide($container);
			yalwa.basics.hide($arrow_container);
		};
		const start = () => slide(true);
		const get_id = () => id;
		const get_error = () => {
		};
		const init_visibility_observer = ($container) => {
			const options = {
				rootMargin: '0px',
				threshold: 0.9 // safari fix the threshold only reach .9xx
			};
			
			function observer_callback(changes, observer) {
				changes.forEach(change => {
					// visible
					if (change.intersectionRatio > 0.9) {
						determine_slide_height(jQuery(change.target));
						if (observer.last) {
							set_slide_height();
						}
						// we are done also remove the visibility listener from element
						observer.unobserve(change.target);
					}
				});
			}
			
			$slide_items.each(function(index) {
				let $element = jQuery(this);
				let observer = new IntersectionObserver(observer_callback, options);
				observer.index = index;
				if ($slide_items.length - 1 === index) {
					observer.last = true;
				}
				observer.observe($element[0]);
			})
		}
		
		options = jQuery.extend(true, default_options, args || {});
		$container = options.container || jQuery('.' + options.container_class);
		$slide_items = $container.find('.js-simple_auto_slide_item');
		const date = new Date();
		id = date.getTime();
		this.get_id = get_id;
		this.get_error = get_error;
		if ($container.data('initialized')) {
			error = 'instance with id ' + this.get_id() + ' can not be initialized, Reason: already an instance initialized on this container_class with id ' + $container.data('initialized') + '. If you need multiple instances, to control them separately please use a unique container_class name.';
			this.start = get_error;
			this.hide = get_error;
			this.show = get_error;
			return;
		}
		$container.data('initialized', id);
		$elements = $container.find('.' + options.element_class);
		if (options.clickable) {
			handle_ovw_urls();
			add_click_handler();
		}
		set_current_index($elements.length);
		init_visibility_observer($container);
		add_bullets();
		if (options.arrows.enabled) {
			add_arrows();
		}
		if (options.use_visibility_change_handler) {
			document.addEventListener("visibilitychange", visibility_change_handler);
		}
		add_pan_events();
		this.start = _ => {
			start();
			return this;
		};
		this.hide = _ => {
			hide();
			return this;
		}
		this.show = _ => {
			show();
			return this;
		};
		this.stop = _ => {
			stop();
			return this;
		};
		this.slide = _ => {
			slide();
			return this;
		};
		this.slide_to = index => {
			slide_to(index);
			return this;
		};
		this.get_current_index = _ => {
			return get_current_index();
		};
	}
	pub.username_tips = (pub => {
		pub = pub || {};
		const TICK_ICON_SIZE = 16;
		const POPUP_TPL = '<div class="js_utpopup itpopup itpopup--ut"><div class="js-utpop_top_row top_row"><p class="js-utpopup_label"></p></div><div class="js-utpopup-content utpopup_content"></div></div>';
		
		pub.init = function() {
			jQuery(window).resize(pub.popup.position);
			jQuery('.js-username_tips').on('keyup', () => pub.popup.hide());
		};
		
		pub.show_tick = () => {
			if (jQuery('.js_uttick').length === 0) {
				let tick_icon = yalwa.basics.yicon('tick--green', {pixel: TICK_ICON_SIZE});
				let tick_offset = jQuery('.js-username_tips').data('ut-tick-offset') ? jQuery('.js-username_tips').data('ut-tick-offset') : 0;
				jQuery('.js-main_col').css({'position': 'relative'}).append(jQuery('<div class="js_uttick ittick">' + tick_icon + '</div>'));
				jQuery('.js_uttick').css({
					'top': jQuery('.js-username_tips').offset().top + (TICK_ICON_SIZE / 2) + jQuery(window).scrollTop() - jQuery('.js-headroom').height(),
					'left': (jQuery('.js-username_tips').offset().left - jQuery('.js-main_col').offset().left) + jQuery('.js-username_tips').outerWidth() - (TICK_ICON_SIZE + tick_offset)
				});
				jQuery('.js-username_tips').attr('data-input-valid', true);
			}
		}
		
		function hide_tick() {
			jQuery('.js_uttick').remove();
			jQuery('.js-username_tips').attr('data-input-valid', false);
		}
		
		pub.popup = {
			// create and show popup
			show: () => {
				hide_tick();
				if (jQuery('.js_utpopup').length === 0) {
					pub.popup.input = jQuery('.js-username_tips');
					jQuery('.js-main_col').css({'position': 'relative'}).append(jQuery(POPUP_TPL));
					pub.popup.position();
					jQuery('.js-utpop_top_row').prepend(yalwa.basics.yicon('warning--circle', {classes: 'js-utpopup_icon header_icon'}));
					pub.popup.set_heading();
				}
			},
			
			reset: () => jQuery('.js-utpopup-content').empty(),
			
			// position popup to relevant input
			position: () => {
				if (jQuery('.js-username_tips').length !== 0) {
					jQuery('.js_utpopup').css({
						'top': jQuery('.js-username_tips').offset().top + jQuery('.js-username_tips').outerHeight(),
						'left': jQuery('.js-username_tips').offset().left,
						'width': jQuery('.js-username_tips').outerWidth()
					});
					jQuery('.js_utpopup').css({
						'top': jQuery('.js-username_tips').offset().top + (pub.popup && pub.popup.input && pub.popup.input.outerHeight ? pub.popup.input.outerHeight() : 0) + jQuery(window).scrollTop(),
						'left': jQuery('.js-username_tips').offset().left - jQuery('.js-main_col').offset().left
					});
				}
			},
			
			// set top label text
			set_heading: (label = '') => jQuery('.js-utpopup_label').text(label),
			
			// remove popup from dom
			hide: (time_in_ms = 0) => setTimeout(() => jQuery('.js_utpopup').remove(), time_in_ms),
			
		}
		return pub;
		
	})(pub.username_tips);
	pub.set_VAP_touchpoint = function(value) {
		yalwa.basics.set_cookie('VAP_touchpoint', value, 15);
	};
	
	pub.track_vap_contact = function() {
		yalwa.basics.ga.ping_metric('CM_VAP_CONTACT_SUBMIT', 1);
	}
	
	pub.current_device_classification = function() {
		if (window.innerWidth >= 1080) {
			return 'desktop';
		} else if (window.innerWidth >= 768) {
			return 'tablet';
		} else {
			return 'mobile';
		}
	}
	
	async function crypto_sign(message) {
		// the JS-internal SubtleCrypto Web API is used for generating an HMAC
		// signature. it is supported by most browsers:
		// https://caniuse.com/mdn-api_crypto_subtle
		// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto
		
		// first, we generate a random text string. this will be returned
		// by the function and passed on with the AJAX request. we're only signing
		// to deter potential attackers by making the attack more tedious to do
		const key = Math.random().toString(36).slice(2);
		
		// now, encode and convert the random string into an SHA-256 HMAC CryptoKey
		const encodedKey = new TextEncoder().encode(key);
		const crypto_key = await window.crypto.subtle.importKey(
			'raw',
			encodedKey,
			{
				// these settings are repeated in php ajax_service->validate_signature()
				name: 'HMAC',
				hash: {name: 'SHA-256'}
			},
			true,
			['sign', 'verify']
		);
		
		// now encode the message (in this case, the URL and data passed to it) and
		// turn it into an HMAC signature using the CryptoKey
		const encodedText = new TextEncoder().encode(message);
		const signature = await window.crypto.subtle.sign('HMAC', crypto_key, encodedText);
		
		// finally, return both the random text string
		// and the signature (as a base64 string)
		return {
			key: key,
			sig: btoa(String.fromCharCode(...new Uint8Array(signature)))
		}
	}
	
	// Function to sort an object by its keys
	function sort_object_by_keys(obj) {
		// Get the keys and sort them
		const sorted_keys = Object.keys(obj).sort();
		
		// Create a new object with the sorted keys
		const sorted_obj = {};
		sorted_keys.forEach(key => {
			sorted_obj[key] = obj[key];
		});
		
		return sorted_obj;
	}
	
	pub.ajaxservice = async function({
										 type = 'GET',
										 resource = null,
										 action = null,
										 identifier = null,
										 data = {},
										 dataType = 'json',
										 csrf = '',
										 include_session = false,
										 is_cross_origin = false,
										 cache = true
									 } = {}) {
		if (!resource) {
			return null;
		}
		if (!action) {
			return null;
		}
		
		let now;
		if (csrf) {
			// determine if the CSRF token may already have expired; if it has,
			// refresh the page instead of sending a request that is likely to fail
			now = Math.floor(Date.now() / 1000) + 5;
			
			let csrf_ts = parseInt(csrf.slice(0, csrf.indexOf(',')));
			
			if (csrf_ts < now) {
				// too late! refresh the page
				yalwa.basics.reload();
				return null;
			}
		}
		
		let url;
		if (is_cross_origin) {
			// if we have a country ID here, it means it will be a service that
			// runs on api.locanto.info (otherwise the country can be determined
			// from the host)
			url = yalwa.v.api_info_base + '/api/' + resource + '/' + action + '/';
		} else {
			// old ajax services running on the local domains,
			// we can use relative urls here
			url = '/api/service/' + resource + '/' + action + '/';
		}
		
		if (identifier) {
			url += identifier + '/';
		}
		
		data = sort_object_by_keys(data);
		
		// we will build the same message in class ajax_service from the
		// REQUEST_URI and valid uip parameters
		// this will also ensure that only allowed (and validated) parameters
		// can be used in these requests
		let message = url + '?' + new URLSearchParams(data).toString();
		const crypto_key_sig = await crypto_sign(message);
		
		if (is_cross_origin) {
			// all cross-origin requests need to be POST; the key, signature,
			// session ID, and csrf tokens will be sent in special payload
			// parameters prefixed with x_y_
			type = 'POST';
			data['x_y_key'] = crypto_key_sig.key;
			data['x_y_sig'] = crypto_key_sig.sig;
			data['x_y_cid'] = yalwa.v.countryID;
			if (include_session) {
				if (!now) {
					now = Math.floor(Date.now() / 1000) + 5;
				}
				if (now > yalwa.v.sid_expire_ts) {
					// too late! refresh the page
					yalwa.basics.reload();
					return null;
				}
				data['x_y_sid'] = yalwa.v.sid;
			}
			if (csrf) {
				data['x_y_csrf'] = csrf;
			}
		}
		
		let ajax_settings = {
			type: type,
			url: url,
			data: data,
			dataType: dataType
		};
		
		if (!is_cross_origin) {
			// these headers names are repeated in class ajax_service as
			// HTTP_X_Y_KEY and HTTP_X_Y_SIG
			
			let headers = {
				'x-y-key': crypto_key_sig.key,
				'x-y-sig': crypto_key_sig.sig,
			}
			if (csrf) {
				// this header is accessed in class uip_csrf
				// as HTTP_X_Y_CSRF and use as the token
				headers['x-y-csrf'] = csrf;
			}
			
			ajax_settings['headers'] = headers;
		}
		
		if (type === 'GET' && !cache) {
			ajax_settings['cache'] = cache;
		}
		
		return jQuery.ajax(ajax_settings);
	}
	
	// Helper function to convert snake_case to PascalCase
	pub.to_pascal_case = function(str) {
		return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
			.replace(/^\w/, (c) => c.toUpperCase());
	}
	
	pub.html_escape = function(str) {
		const div = document.createElement('div');
		div.textContent = str;
		return div.innerHTML;
	};
	
	pub.is_space_bar_or_enter_pressed = function(event) {
		if (event.key === " " ||
			event.code === "Space" ||
			event.keyCode === 32
		) {
			return true;
		}
		return event.key === 'Enter' || event.keyCode === 13;
		
	};
	
	pub.keyhandler_for_space_and_enter = function(event) {
		let $this = jQuery(event.currentTarget);
		if (pub.is_space_bar_or_enter_pressed(event)) {
			$this.trigger('click');
		}
	};
	
	pub.simple_hash = (value) => {
		const str = String(value);
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			const chr = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0;
		}
		return hash;
	}
	
	let lock_count = 0;
	let saved_scroll_y = 0;
	let saved_right_pad = '';
	let saved_position = '';
	let saved_top = '';
	let saved_width = '';
	pub.scroll_lock = function() {
		if (++lock_count > 1) {
			return;
		}
		saved_scroll_y = window.scrollY || 0;
		const body = document.body;
		const sbw = window.innerWidth - document.documentElement.clientWidth;
		saved_right_pad = body.style.paddingRight;
		saved_position = body.style.position;
		saved_top = body.style.top;
		saved_width = body.style.width;
		
		if (sbw > 0) { // avoid layout shift from scrollbar disappearance
			const computedPad = parseFloat(getComputedStyle(body).paddingRight) || 0;
			body.style.paddingRight = `${computedPad + sbw}px`;
		}
		// freeze body at current scroll position
		body.style.position = 'fixed';
		body.style.top = `-${saved_scroll_y}px`;
		body.style.width = '100%';
	};

	pub.scroll_is_locked = function() {
		return lock_count > 0;
	};

	pub.scroll_unlock = function() {
		if (--lock_count > 0) {
			return;
		}
		const body = document.body;
		
		// restore styles
		body.style.paddingRight = saved_right_pad;
		body.style.position = saved_position;
		body.style.top = saved_top;
		body.style.width = saved_width;
		window.scrollTo(0, saved_scroll_y); // restore scroll position
	};
	
	return pub;
	
}(yalwa.basics));

yalwa.basics.init();
